import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import URL_UTILITY from '@/app/utility/url.utility';
import { format } from 'date-fns';
import DatePicker from 'vue2-datepicker';
import allDocuments from '../../../../components/shared/allDocuments';
import uploadExcel from '@/app/components/shared/uploadExcel';
import ApprovalHistory from '@/app/components/onlineApproval/internalWorkFlow/history/approvalHistory';
import UploadDocument from '@/app/components/onlineApproval/internalWorkFlow/history/uploadDocument';
import ExcelJS from 'exceljs';
import responseModal from '../../../shared/responseModal'; // 1.7 (Himanshu)
import accountingFlexField from "./accountingFlexField";
export default {
  name: 'invoiceApprovalDetails',
  watch: {
    currentPageExpense: function() {
      this.getExpenseMonth();
    },
    perPageExpense: function() {
      this.currentPageExpense = 1;
      this.getExpenseMonth();
    },
    currentPageTdsSection: function() {
      this.getTdsSection();
    },
    perPageTdsSection: function() {
      this.currentPageTdsSection = 1;
      this.getTdsSection();
    },
    currentPageTdsRate: function() {
      this.getTdsRate();
    },
    perPageTdsRate: function() {
      this.currentPageTdsRate = 1;
      this.getTdsRate();
    },
    currentPageGrnMapping: function() {
      this.getGrnReceiptMappingData();
    },
    perPageGrnMapping: function() {
      this.currentPageGrnMapping = 1;
      this.getGrnReceiptMappingData();
    },
    tags() {
      this.adjustTagsWidth();
    },
    currentPageCostCentre: function() {
      this.getCostCentreDetails();
    },
    perPageCostCentre: function() {
      this.currentPageCostCentre = 1;
      this.getCostCentreDetails();
    },
    currentPageDistribution: function() {
      this.getDistributionDetails();
    },
    perPageDistribution: function() {
      this.currentPageDistribution = 1;
      this.getDistributionDetails();
    },
    currentPageUserPreference: function() {
      this.getUsersData();
    },
    perPageUserPreference: function() {
      this.currentPageUserPreference = 1;
      this.getUsersData();
    },
    currentPageTransporterName: function() {
        this.getTransporterNameData();
    },
    currentPageDocSequence: function() {
        this.getDocSequenceData();
    },
  },
  props: [
    'invoiceRowData',
    'wfMenuId',
    'userId',
    'eventId',
    'invoiceApprovalDetails',
    'wfType',
    'cardName'
  ],
  components: {
    allDocuments,
    ApprovalHistory,
    DatePicker,
    UploadDocument,
    uploadExcel,
    responseModal, // 1.7 (Himanshu)
    accountingFlexField
  },
  data() {
    return {
      perPage: commonHelper.perPageRecord,
      previewPage: 1,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      perPageGrnMapping: commonHelper.perPageRecord,
      pageOptionsGrnMapping: commonHelper.getPageOption(),
      totalRowsGrnMapping: null,
      currentPageGrnMapping: 1,
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      loader: false,
      editMode: false,
      vendorInvId: null,
      menuId: null,
      subMenuId: null,
      wfHdrId: null,
      wfDtlId: null,
      approvalStatusKey: null,
      headerDetails: {
        po_header_id: null,
        po_num: null,
        po_status: null,
        inv_num: null,
        inv_amt: null,
        show_inv_amt: null,
        first_party_gstn: null,
        third_party_gstn: null,
        currency: null,
        inv_agreement: null,
        inv_status: null,
        liability_account: null,
        dif_amount: null,
        payment_term: null,
        inv_date: null,
        due_date: null,
        uploaded_document: null,
        vendor_inv_id: null,
        le_id: null,
        le_name: null,
        vendor_id: null,
        vendor_name: null,
        ou_id: null,
        vendor_site_id: null,
        approval_status: null,
        approval_status_key: null,
        wf_inprocess_hdr_id: null,
        wf_inprocess_dtl_id: null,
        seq_order: null,
        vendor_site_name: null,
        exchange_rate: null,
        actual_gr_date: null,
        gl_date: null,
        period_name: null,
        material_received_by: null,
        receipt_num: null,
        buyer_name: null,
        buyer_email_id: null,
        buyer_emp_id: null,
        po_creation_date: null,
        erp_le_id: null,
        remarks: null,
        grn_attach_flag: false,
        manual_invoice: null,
        exchange_amount: null,
        invoice_amount: null,   // 1.7 (Himanshu)
        purpose_code: null, // 2.4 (Himanshu)
        physical_mrn_number: null,
        physical_mrn_date: null
      },
      invoiceLineData: [
        {
          period_name: null,
          tds_flag: false,
          tds_section_code: null,
          tds_section_meaning: null,
          tax_rate_id: null,
          tax_rate_name: null,
          tax_non_recoverable: false
        }
      ],
      //  1.6 <Anuj> Added three columns: QC Completed, QC Remark, and QC Doc Attach.
      invoiceLineFields: [
        {
          key: 'po_number',
          label: 'PO Number',
          class: 'col-width-fix'
        },
        {
          key: 'po_line_num',
          label: 'PO Line No.',
          class: 'col-width-fix text-center'
        },
        {
          key: 'po_release_num',
          label: 'PO Release',
          class: 'col-width-fix text-center'
        },
        {
          key: 'po_shipment_line_num',
          label: 'Shipment Line No.',
          class: 'text-center'
        },
        {
          key: 'item_code',
          class: 'col-width-fix'
        },
        {
          key: 'item_description',
          label: 'Description'
        },
        {
          key: 'po_price',
          label: 'PO Price',
          class: 'col-width-fix'
        },
        {
          key: 'uom',
          label: 'UOM',
          class: 'col-width-fix'
        },
        {
          key: 'deliver_qty',
          label: 'Qty. Being Delivered',
          class: 'qty-width-fix'
        },
        {
          key: 'acc_qty',
          label: 'Accepted Quantity'
        },
        {
          key: 'acc_amt',
          label: 'Accepted Amount'
        },
        {
          key: 'hsn_sac',
          label: 'Invoice HSN/SAC',
          // class: 'col-width-fix' // 1.8 (Himanshu)
        },
        {
          key: 'shp_to_loc',
          label: 'Ship To Loc'
        },
        {
          key: 'release_line_from_date',
          label: 'Release Start Date'
        },
        {
          key: 'release_line_to_date',
          label: 'Release End Date'
        },
        {
          key: 'item_type',
          class: 'col-width-fix'
        },
        {
          key: 'tax_category_name',
          label: 'Tax Category'
        },
        { key: 'taxable_amount', class: 'tax-amt-fix' },
        {
          key: 'tax_amount',
          class: 'text-fix-po'
        },
        {
          key: 'tax_details',
          label: 'Tax',
          stickyColumn: true
        },
        {
          key: 'qc_status',
          label: 'QC Completed',
          class: 'col-fix-qc text-center'
        },
        {
          key: 'qc_remark',
          label: 'QC Remark',
          class: 'col-width-fix'
        },
        {
          key: 'qc_doc_attach',
          label: 'QC Doc Attach',
          class: 'col-width-fix'
        },
        {
          key: 'status_code',
          label: 'GRN Status',
          class: 'col-width-fix'
        },
        {
          key: 'status_msg',
          label: 'Error Message'
        }
      ],
      previewTaxData: [],
      previewTaxFields: [
        { key: 'tax_type', class: 'tax-type-fix' },
        { key: 'taxable_amount', class: 'col-width-acc' },
        { key: 'tax_rate', class: 'tax-type-fix' },
        { key: 'amount', label: 'Tax Amount', class: 'tax-type-fix' },
        {
          key: 'tax_category_name',
          label: 'Tax Category',
          class: 'tax-cat-fix'
        },
        { key: 'rcm_flag', label: 'RCM', stickyColumn: true }
      ],
      workflowId: { menuId: null, userId: null, eventId: null },
      showPreviewTaxModal: false,
      documentData: [],
      documentFields: [
        {
          key: 'original_file_name',
          label: 'File Name'
        },
        {
          key: 'file_name',
          label: 'Preview',
          stickyColumn: true
        },
        {
          key: 'preview_file',
          label: 'New Tab',
          stickyColumn: true
        },
        {
          key: 'delete',
          stickyColumn: true
        }
      ],
      showDocumentModal: false,
      rejectedReason: null,
      showRejectModal: false,
      showApproveModal: false,
      approvalReason: null,
      openKmAuth: null,
      uploadedFileName: null,
      showOpenModal: false,
      docDtlId: null,
      authToken: null,
      downloadDocUrl: URL_UTILITY.getOpenKmDocDeleteUrl,
      showInvoiceCommonModal: false,
      modalType: null,
      expenseData: [],
      expenseFields: [
        {
          key: 'period_name'
        }
      ],
      expenseMonthSearch: null,
      tdsSectionSearch: null,
      tdsRateSearch: null,
      perPageExpense: commonHelper.perPageRecord,
      totalRowsExpense: null,
      currentPageExpense: 1,
      tdsSectionData: [],
      tdsSectionFields: [
        {
          key: 'lookup_code',
          label: 'Section'
        },
        {
          key: 'meaning',
          label: 'Description'
        }
      ],
      perPageTdsSection: commonHelper.perPageRecord,
      totalRowsTdsSection: null,
      currentPageTdsSection: 1,
      tdsRateData: [],
      tdsRateFields: [
        { key: 'tax_rate_id' },
        { key: 'tax_rate_name', label: 'Tax Rate' }
      ],
      perPageTdsRate: commonHelper.perPageRecord,
      totalRowsTdsRate: null,
      currentPageTdsRate: 1,
      specIndex: null,
      isComDetailsSaved: false,
      isFinDetailsSaved: false,
      expenseType: null,
      approvalHistoryData: [],
      approvalHistoryFields: [
        {
          key: 'approver_name'
        },
        { key: 'approver_designation', label: 'Designation' },
        {
          key: 'action_date'
        },
        {
          key: 'seq_order',
          label: 'Approver Order'
        },
        {
          key: 'approval_status',
          label: 'Status'
        },
        {
          key: 'comments'
        }
      ],
      showGrnMappingModal: false,
      grnMappingData: [],
      grnMappingFields: [
        {
          key: 'receipt_num',
          label: 'Receipt Number'
        },
        {
          key: 'receipt_date'
        },
        {
          key: 'invoice_number'
        },
        {
          key: 'invoice_date'
        }
      ],
      validateMsg: null,
      isCurrencyDisabled: false,
      urlSummaryData: null,
      showHistory: false,
      historyType: null,
      totalTaxableAmt: null,
      freightExcTax: null,
      taxExcFreight: null,
      allFlag: false,
      approvalRemarks: null,
      rejectionRemarks: null,
      fileExtension: null,
      showDocDetails: false,
      currentPageIndex: null,
      excelFile: null,
      excelData: [],
      excelHeaders: [],
      showValueSetModal: false,
      showApproveForwardModal: false,
      selectedEmp: { text: null, value: null },
      grnMapFlag: false,
      setTimeVset: null,
      selectedEmpEmail: [],
      selectedEmpId: [],
      showSplitModal: false,
      splitLineData: {},
      splitData: [
        {
          amount: null,
          cost_centre: null,
          expense_month: null,
          from_date: null,
          to_date: null,
          state_code: null,
          concatenated_segments: null,
          distribution_set_id: null,
          percent_distribution: null
        }
      ],
      splitFields: [
        // { key: 'add', stickyColumn: true },
        // { key: 'remove', stickyColumn: true },
        { key: 'amount' },
        { key: 'percent_distribution' },
        { key: 'cost_centre' },
        { key: 'expense_month' },
        { key: 'from_date' },
        { key: 'to_date' },
        { key: 'concatenated_segments', label: 'Code Combination' }
      ],
      lineNo: null,
      poLineNums: [],
      selectedLine: null,
      remainingAmount: null,
      showCostCentreModal: false,
      costCentreData: [],
      costCentreFields: [
        {
          key: 'state_code'
        },
        {
          key: 'cost_centre'
        }
      ],
      costCentreSearch: null,
      perPageCostCentre: commonHelper.perPageRecord,
      totalRowsCostCentre: null,
      currentPageCostCentre: 1,
      finFromDate: null,
      finToDate: null,
      splitFinData: [
        {
          oracle_line_description: null,
          period: null,
          period_to: null,
          unit_price: null,
          days: null,
          amount: null,
          cost_centre: null,
          expense_month: null,
          code_combination: null
        }
      ],
      splitFinFields: [
        { key: 'oracle_line_description' },
        { key: 'period', label: 'Period From' },
        { key: 'period_to', label: 'Period To' },
        { key: 'days', stickyColumn: true },
        // { key: 'cost_centre' },
        // { key: 'unit_price', label: 'Cost Centre Amount' },
        { key: 'amount', label: 'Distribution Amount' },
        { key: 'expense_month' },
        { key: 'code_combination' },
        { key: 'status_code' },
        { key: 'status_message' }
      ],
      periodTotalDays: [],
      periodFromDates: [],
      periodToDates: [],
      endDateArr: [],
      remainingFinAmt: null,
      operatingUnitSearch: '',
      operatingUnit: { value: null, text: null },
      operatingUnitData: [],
      operatingUnitFields: [
        { key: 'ou_id', label: 'Operating Unit Id' },
        { key: 'ou_name', label: 'Operating Unit' }
      ],
      perPageOperatingUnit: commonHelper.perPageRecord,
      totalRowsOperatingUnit: null,
      currentPageOperatingUnit: 1,
      vendorSiteSearch: '',
      vendorSiteData: [],
      vendorSiteFields: [
        { key: 'vendor_site_id' },
        { key: 'vendor_site_name' }
      ],
      perPageVendorSite: commonHelper.perPageRecord,
      totalRowsVendorSite: null,
      currentPageVendorSite: 1,
      showUploadExcel: false,
      showLineDescriptionModal: false,
      lineDescription: null,
      downloadInvoiceSampleUrl:
        URL_UTILITY.getInvoiceSampleFile +
        '/manualInvoiceExcelUploadFormat.xlsx',
      showSplitModalWithPo: false,
      splitLineDataWithPo: {},
      splitPeriodFromDate: null,
      splitPeriodToDate: null,
      splitWithPoData: [],
      splitWithPoFields: [
        { key: 'period', label: 'From Date' },
        { key: 'period_to', label: 'To Date' },
        { key: 'days', stickyColumn: true },
        { key: 'amount', label: 'Distribution Amount' },
        { key: 'expense_month' }
        // { key: 'code_combination' }
      ],
      remainingAmtWithPo: null,
      dateDisabledFlag: false,
      showDistributionModal: false,
      distribution: { text: null, value: null },
      distributionData: [],
      distributionFields: [
        { key: 'distribution_set_id' },
        { key: 'distribution_set_name' }
      ],
      currentPageDistribution: 1,
      perPageDistribution: commonHelper.perPageRecord,
      pageOptionsDistribution: commonHelper.getPageOption(),
      totalRowsDistribution: null,
      distributionSearch: null,
      distributionSetFlag: false,
      expenseMonth: null,
      finFromDateWithPo: null,
      finToDateWithPo: null,
      dateDisabledFlagWithPo: false,
      splitFinDataWithPo: [],
      splitFinFieldsWithPo: [
        { key: 'oracle_line_description' },
        { key: 'period', label: 'Period From' },
        { key: 'period_to', label: 'Period To' },
        { key: 'days', stickyColumn: true },
        { key: 'amount', label: 'Distribution Amount' },
        { key: 'expense_month' },
        { key: 'code_combination' },
        { key: 'override_flag', label: 'Override', stickyColumn: true }
      ],
      remainingFinAmtWithPo: null,
      dateDisabledFinFlagWithPo: false,
      copyArrItems: [],
      deepCopy: [],
      downloadType: null,
      userPreferenceModal: false,
      usersFields: [
        {
          key: 'selectBox',
          label: 'Select',
          stickyColumn: true,
          variant: 'info',
          class: 'stickyColumn col-sm-1'
        },
        {
          key: 'user_email'
        }
      ],
      usersData: [],
      selectedUsers: [],
      selectAllCheckBoxUsers: false,
      searchUser: null,
      selectedUsersData: [],
      selectedUsersFields: [
        {
          key: 'user_email'
        }
      ],
      perPageUserPreference: commonHelper.perPageRecord,
      totalRowsUserPreference: null,
      currentPageUserPreference: 1,
      selectAllCheckBox: false,
      wccDate: null,
      billType: null,
      poWithFreight: null,
      advanceData: [],
      advanceFields: [
        {
          key: 'selectBox',
          label: 'Select',
          stickyColumn: true,
          variant: 'info',
          class: 'stickyColumn col-sm-1'
        },
        {
          key: 'po_num',
          label: 'PO Number'
        },
        {
          key: 'adv_num',
          label: 'Advance Number'
        },
        { // 2.0 (Himanshu)  Commented prepay_line_number columns
          // 2.1 (Himanshu)  Unommented prepay_line_number columns
          key:'prepay_line_number',
          label:'Prepay Line Number'
        },
        {
          key: 'adv_amt',
          label: 'Advance Amount'
        },
        {
          key: 'adv_date',
          label: 'Advance Date'
        },
        // {
        //   key: 'adv_amt_paid',
        //   label: 'Advance Amt Paid'
        // },
        // {
        //   key: 'adv_amt_unpaid',
        //   label: 'Advance Amt Unpaid'
        // },
        {
          key: 'applied_amt',
          label: 'Applied Amt'
        },
        {
          key: 'adv_amt_unapplied',
          label: 'Advance Amt Unapplied',
          class: 'col-large'
        },
        {
          key: 'applied_amt',
          label: 'Advance Amt Applied',
          class: 'col-large'
        },
        {
          key: 'invoice_type',
          label: 'Invoice Type'
        },
        {
          key: 'tds_rate',
          label: 'TDS Rate'
        },
        {
          key: 'tds_section',
          label: 'TDS Section'
        },
        {
          key: 'app_date',
          label: 'Application Date'
        },
        {
          key: 'oracle_pending',
          label: 'Oracle Pending'
        },
        {
          key: 'realapp_pending'
        },
        {
          key: 'amount_pending'
        },
        {
          key: 'adj_amt',
          label: 'Adjustment Amount'
        }
      ],
      selectedRow: [],
      totalAdjAmt: 0,
      advancesAppliedData: [],
      advanceAppliedFields: [
        {
          key: 'delete',
          label: 'Unapply',
          stickyColumn: true,
          variant: 'danger',
          class: 'stickyColumn col-sm-1'
        },
        {
          key: 'po_num',
          label: 'PO Number'
        },
        {
          key: 'adv_num',
          label: 'Advance Number'
        },
        { // 2.0 (Himanshu)  Commented prepay_line_number columns
          // 2.1 (Himanshu)  Unommented prepay_line_number columns
          key:'prepay_line_number',
          label:'Prepay Line Number'
        },
        {
          key: 'adv_amt',
          label: 'Advance Amount'
        },
        {
          key: 'adv_date',
          label: 'Advance Date'
        },
        {
          key: 'app_date',
          label: 'Application Date'
        },
        {
          key: 'tds_rate',
          label: 'TDS Rate'
        },
        {
          key: 'tds_section',
          label: 'TDS Section'
        },
        {
          key: 'adj_amt',
          label: 'Adjustment Amount'
        }
      ],
      totalAdjAmtApplied: 0,
      taxableAmountWithoutCurrency: null,
      advanceNumber: null,
      payment_terms_manual: null,
      advanceMatchFlag: false,
      specLineIndex: null,
      showUploadDoc: false,
      selectedReqDtls: {},
      invDtlAttach: null,
      alreadyChecked: false,
      rcmTaxIndex: null, // 1.7 (Himanshu)
      showOpenRcmTaxes: false,
      loading: false,
      rcmTaxesData: [],
      rcmTaxesFields: [
        {
          key: 'tax_rate_percentage',
          label: 'Tax Rate'
        }
      ],  // 1.7 (Himanshu),
      showOpenTaxTypeModal: false,  // 2.2(Himanshu) RCM tax type edit and add
      taxTypeData: [],
      taxTypeFields: [
        {
          key: 'tax_type_code'
        }
      ],
      addNewRcmTaxFlag: false,
      vendorInvoiceDetailId: null,
      selectedInvoiceIndex: null, // 2.2(Himanshu) RCM tax type edit and add
      retention: null, // 2.6 (Himanshu)
      totalCNAmount: null, // 2.8 (Himanshu)
      totalCNTax: null,
      currentPageTransporterName: 1,
      totalRowsTransporterName: null,
      transporterNameFields: [
        {
          key: 'party_name'
        }
      ],
      transporterNameData: [],
      showOpenTransporterName: false,
      currentPageDocSequence: 1,
      totalRowsDocSequence: null,
      showOpenDocSequence: false,
      docSequenceData: [],
      docSequenceFields: [
        {
          key: 'lookup_code',
          label: 'Lookup Code'
        },
        {
          key: 'meaning',
          label: 'Description'
        }
      ], // 2.8 (Himanshu)
      codeCombinationModal: false,
      currentItem: null
      // invoiceLineDataCopy: []
    };
  },
  mounted() {
    if (this.invoiceRowData) {
      // from grid
      this.vendorInvId = this.invoiceRowData.vendor_inv_id;
      this.wfHdrId = this.invoiceRowData.wf_inprocess_hdr_id;
      this.wfDtlId = this.invoiceRowData.wf_inprocess_dtl_id;
      this.approvalStatusKey = this.invoiceRowData.approval_status_key;
      this.menuId = this.$store.state.shared.menuId;
      this.workflowId.menuId = this.wfMenuId;
      this.workflowId.userId = this.userId;
      this.workflowId.eventId = this.eventId;
      this.approvalRemarks = this.invoiceRowData.approval_remarks;
      this.rejectionRemarks = this.invoiceRowData.rejection_remarks;
    }
    if (this.invoiceApprovalDetails) {
      // from dashboard
      this.vendorInvId = this.invoiceApprovalDetails.vendor_inv_id;
      this.wfHdrId = this.invoiceApprovalDetails.wf_inprocess_hdr_id;
      this.wfDtlId = this.invoiceApprovalDetails.wf_inprocess_dtl_id;
      this.approvalStatusKey = this.invoiceApprovalDetails.approval_status_key;
      this.menuId = this.invoiceApprovalDetails.dy_menu_id;
      this.workflowId.menuId = this.invoiceApprovalDetails.wf_menu_id;
      this.workflowId.userId = this.invoiceApprovalDetails.wf_user_id;
      this.workflowId.eventId = this.invoiceApprovalDetails.wf_event_id;
      this.approvalRemarks = this.invoiceApprovalDetails.approval_remarks;
      this.rejectionRemarks = this.invoiceApprovalDetails.rejection_remarks;
    }
    if (this.$route.params.summaryData) {
      this.urlSummaryData = JSON.parse(
        Buffer.from(this.$route.params.summaryData, 'base64').toString('ascii')
      );
    }
    if (this.urlSummaryData) {
      // from url link
      this.vendorInvId = this.urlSummaryData.vendor_inv_id;
      this.wfHdrId = this.urlSummaryData.wf_inprocess_hdr_id;
      this.wfDtlId = this.urlSummaryData.wf_inprocess_dtl_id;
      this.approvalStatusKey = this.urlSummaryData.approval_status_key;
      this.menuId = this.urlSummaryData.dy_menu_id;
      this.workflowId.menuId = this.urlSummaryData.wf_menu_id;
      this.workflowId.userId = this.urlSummaryData.wf_user_id;
      this.workflowId.eventId = this.urlSummaryData.wf_event_id;
      this.approvalRemarks = this.urlSummaryData.approval_remarks;
      this.rejectionRemarks = this.urlSummaryData.rejection_remarks;
    }
    if(!this.headerDetails.manual_invoice) {
      // 1.8 (Himanshu) Addd Invoive HSN/SAC
      this.invoiceLineFields.splice(11, 1, 
        {
          key: 'hsn_sac',
          label: 'PO HSN/SAC',
          // class: 'col-width-fix' // 1.8 (Himanshu)
        },
      {
        key: 'invoice_hsn_sac',
        label: 'Invoice HSN/SAC'
      })
    }
      this.getVendorInvoiceDetailsById();
    this.getHistory();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save' && this.editMode) {
          if (this.headerDetails.approval_status_key !== 'APPROVED') {
            if (this.headerDetails.manual_invoice) {
              this.updateInvoiceDetailsManual();
            } else {
              this.updateInvoiceDetailsFinance();
            }
          } else {
            alert('Record is already APPROVED');
          }
        }
        if (actionName === 'update') {
          this.editMode = true;
        }
      }
    });
    document.addEventListener('keydown', this.handleKeyDown);
    document.oncontextmenu = function() {
      return false;
    };
    this.mapMenuId();
  },
  methods: {
    viewDocument() {
      if (!this.showDocDetails) {
        this.showDocDetails = true;
        this.getUploadedDocDtl();
      } else {
        this.showDocDetails = false;
      }
    },
    getUploadedDocDtl() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: 100,
        menu_id: this.menuId,
        sub_menu_id: this.subMenuId,
        record_id: this.vendorInvId
      };
      this.documentData = [];
      this.$store
        .dispatch('intWorkflow/getOpenKmDocDtl', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            if (response.data.data.page.length > 0) {
              const docList = response.data.data.page;
              this.documentData = docList.map(data => {
                data.file_size = this.formatBytes(data.file_size);
                return data;
              });
              this.totalRows = response.data.data.total_elements;
            } else {
              alert('Document not available for this record');
              this.$emit('closeModal');
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    openPreviewDocInvoice(flag, docDtlId, fileName, index, data) {
      this.currentPage = index + 1;
      const filterDynamicData = data.filter(a => a.original_file_name);
      const getFileName = data[index].original_file_name;
      for (let i = 0; i < filterDynamicData.length; i++) {
        if (filterDynamicData[i].original_file_name == getFileName) {
          this.currentPageIndex = i + 1;
          break;
        }
      }
      const tempData = filterDynamicData.map(elem => {
        return {
          original_file_name: elem.original_file_name,
          document_det_id: elem.doc_detail_id
        };
      });
      this.dynamicData = tempData;
      if (flag) {
        this.getOpenKmAuthTokenPreview(
          flag,
          docDtlId,
          fileName,
          'previewDoc',
          null
        );
      }
    },
    getOpenKmAuthTokenPreview(flag, docDtlId, fileName, type, item) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (this.openKmAuth && type == 'previewDoc') {
              // this.partOnboardingPreview(flag, docDtlId, this.openKmAuth, fileName);
              // need to change
              this.previewOpenDoc(docDtlId, this.openKmAuth, fileName, flag);
              // this.showHideOpenModal(docDtlId, this.openKmAuth, fileName, flag);
            } else {
              this.newPreviewOpenDoc(
                this.documentData[item - 1].original_file_name,
                this.documentData[item - 1].doc_detail_id
              );
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOpenKmAuthToken(docDtlId, fileName, type) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (type === 'new_window') {
              this.openDocumentNewTab(docDtlId, fileName, this.openKmAuth);
            } else {
              const url =
                this.downloadDocUrl +
                '/download/' +
                docDtlId +
                '?token=' +
                this.openKmAuth;
              commonHelper.downloadFile(url, fileName);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getPageIndex(item) {
      this.getOpenKmAuthTokenPreview(null, null, null, 'newPreviewDoc', item);
      this.specIndex = item;
    },
    newPreviewOpenDoc(uploadedFileName, docDtlId) {
      this.fileExtension = commonHelper.getFileExtension(uploadedFileName);
      // this.eventBus.$emit('changeFileName', uploadedFileName);
      const payload = {
        docDetailId: docDtlId,
        token: this.openKmAuth,
        fileExtension: this.fileExtension
      };
      this.loader = true;
      commonHelper.previewImgDoc(payload, () => (this.loader = false));
    },
    previewOpenDoc(docDtlId, openKmAuth, fileName) {
      this.fileExtension = commonHelper.getFileExtension(fileName);
      const payload = {
        docDetailId: docDtlId,
        token: openKmAuth,
        fileExtension: this.fileExtension
      };
      this.loader = true;
      this.tempFunc(payload, () => (this.loader = false));
    },
    tempFunc(payload, callback) {
      const url =
        URL_UTILITY.getOpenKmDocDeleteUrl +
        '/preview/' +
        payload.docDetailId +
        '?token=' +
        payload.token;
      const token = sessionStorage.getItem('token');
      fetch(url, {
        method: 'get',
        headers: new Headers({
          Authorization: `Bearer ${token}`
        })
      })
        .then(response => {
          return response.blob();
        })
        .then(blob => {
          let imgLink = null;
          if (payload.fileExtension === 'pdf') {
            imgLink = window.URL.createObjectURL(
              new Blob([blob], { type: 'application/pdf' })
            );
            document.querySelector('#prev-docs').src = imgLink;
          } else if (payload.fileExtension === 'xlsx') {
            this.readExcelBlob(blob);
          } else {
            imgLink = window.URL.createObjectURL(new Blob([blob]));
            document.querySelector('#prev-docs').src = imgLink + '#toolbar=0';
          }
        })
        .finally(() => {
          callback();
        });
    },
    afterOpen() {
      this.$refs.excelViewer.setRowBackgroundColor(1, '#b0d5f3');
    },
    async readExcelBlob(blob) {
      const arrayBuffer = await this.readBlobAsArrayBuffer(blob);
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);
      const worksheet = workbook.getWorksheet(1);
      this.excelHeaders = worksheet.getRow(1).values;
      // this.excelData = worksheet.getSheetValues().slice(1);
      this.excelData = [];
      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        if (rowNumber > 1) {
          const rowData = row.values;
          this.excelData.push(rowData);
        }
      });
    },
    readBlobAsArrayBuffer(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
        reader.readAsArrayBuffer(blob);
      });
    },
    defaultExpenseMonth(date) {
      const parts = date.split('-');
      const month = parts[1].toUpperCase();
      const year = parts[2].slice(2);
      this.headerDetails.period_name = month + '-' + year;
    },
    showHideHistory(flag, historyType) {
      this.showHistory = flag;
      this.historyType = historyType;
    },
    saveFunction() {
      if (this.editMode) {
        if (this.headerDetails.approval_status_key !== 'APPROVED') {
          this.updateInvoiceDetailsFinance();
        } else {
          alert('Record is already APPROVED');
        }
      }
    },
    setFieldsForFinance() {
      if (this.headerDetails.invoice_level === 'INVOICE') {
        this.invoiceLineFields.push(
          { key: 'period_name', label: 'Expense Month' },
          { key: 'tds_flag', label: 'TDS Flag', stickyColumn: true },
          { key: 'tds_section_meaning', label: 'TDS Section' },
          { key: 'tax_rate_name', label: 'TDS Rate' },
          { key: 'split', stickyColumn: true }
        );
      }
      // else if (this.headerDetails.invoice_level === 'GRN') {
      //   this.invoiceLineFields.push({
      //     key: 'split',
      //     stickyColumn: true
      //   });
      // }
    },
    getVendorInvoiceDetailsById() {
      const payload = {
        vendor_inv_id: this.vendorInvId,
        user_id: this.workflowId.userId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getVendorInvoiceDetailsById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.headerDetails = result;
            if (this.headerDetails.po_num && this.headerDetails.adj_flag !== '2') { // 3.0 (Himanshu) Added condition to not show period in remarks for CN
              this.headerDetails.remarks = this.headerDetails.remarks ? this.headerDetails.remarks : `INV No-${
                this.headerDetails.inv_num
              } | PO-${this.headerDetails.po_num} | GRN-${
                this.headerDetails.receipt_num
                  ? this.headerDetails.receipt_num
                  : ''
              } | EXP MON-${this.headerDetails.period_name} | PO Hdr Dsc `;
            } else { // 3.0 (Himanshu) For CN, we will not show period in remarks as CN can be raised without reference of GRN and period will not be available in such cases
              this.headerDetails.remarks = `INV No-${
                this.headerDetails.inv_num
              } | PO-${this.headerDetails.po_num} | GRN-${
                this.headerDetails.receipt_num
                  ? this.headerDetails.receipt_num
                  : ''
              } | PO Hdr Dsc `;
            }
              this.headerDetails.exchange_amount = +this.headerDetails.inv_amt * +this.headerDetails.exchange_rate; // 1.7 (Himanshu) variable for exchange amount
            this.operatingUnit.text = result.manual_ou_name;
            this.operatingUnit.value = result.manual_ou_id;
            if(this.headerDetails.adj_flag === '0') {
            // this.getAdvanceData(); // 3.1 (Himanshu) Commented to remove advance details from Vatika as per new requirement
            // this.getAdvancesAppliedData();
            }            
            this.approvalStatusKey = result.approval_status_key;
            this.billType = result.bill_type;
            this.retention = result.retention; // 2.6 (Himanshu)
            this.wccDate = result.wcc_date;
            this.poWithFreight = result.po_with_freight === 'Y' ? 'Yes' : 'No';
            this.headerDetails.show_inv_amt = commonHelper.formatAmountWithoutCurrency(
              result.inv_amt
            );
            this.headerDetails.invoice_amount = result.inv_amt; //1.7 (Himanshu) For Invoice Amount for Prepayment
            this.invoiceLineData = result.invoice_dtls.map(elem => {
              // elem.taxable_amount = elem.deliver_qty * elem.po_price;
              elem.period_name = result.period_name;
              elem.qc_status = elem.qc_status === 'Y' ? true : false      // 1.6 <Anuj> 
              elem.taxable_amount_inr = +this.headerDetails.exchange_rate * +elem.taxable_amount; // 2.4 (Himanshu) taxable amount (INR) key added in details
              elem.taxable_amount_inr = elem.taxable_amount_inr.toFixed(2); // 2.4 (Himanshu)
              elem.tax_details_length = Array.isArray(elem.tax_details)
              ? elem.tax_details.length
              : 0;

              return elem;
            });
            if (
              result.actual_gr_date &&
              result.period_name &&
              result.material_received_by
            ) {
              this.isComDetailsSaved = true;
            } else if(this.headerDetails.adj_flag === '2') { // 2.8 (Himanshu) For CN, we can consider it as saved if invoice date, source invoice number and line number is present
              this.isComDetailsSaved = true;
            } else {
              this.isComDetailsSaved = false;
            }
            if (result.gl_date) {
              this.isFinDetailsSaved = true;
            } else {
              this.isFinDetailsSaved = false;
            }
            this.validateCurrency();
            this.getTotalTaxAmount();
            if (this.headerDetails.invoice_level == 'INVOICE') {
              this.headerDetails.gl_date = !this.headerDetails.gl_date
                ? format(new Date(), appStrings.DATEFNSFORMAT)
                : this.headerDetails.gl_date;
            }
            if (this.headerDetails.manual_invoice) {
              if (this.headerDetails.invoice_level === 'INVOICE') {
                if(this.headerDetails.adj_flag === '1') { // 2.8 (Himanshu)
                 this.invoiceLineFields = [ 
                  { // 2.8 (Himanshu)
                    key: 'return_inv_date',
                    label: 'Invoice Date'
                  },
                  {
                    key: 'source_inv_num',
                    label: 'Invoice No.'
                  },
                  {
                    key: 'line_number',
                    label: 'Line No.', // 2.8 (Himanshu)
                    stickyColumn: true
                  },
                  {
                    key: 'item_description',
                    label: 'Item Description', // 2.8 (Himanshu)
                    class: 'col-fix-lg'
                  },
                  // {
                  //   key: 'po_price',
                  //   label: 'PO Price',
                  //   class: 'col-width-fix'
                  // },
                  // {
                  //   key: 'deliver_qty',
                  //   label: 'Qty. Being Delivered',
                  //   class: 'qty-width-fix'
                  // },
                  {
                    key: 'hsn_sac',
                    label: 'HSN/SAC',
                    class: 'col-fix-small text-left'
                  },
                  {
                    key: 'taxable_amount',
                    class: 'tax-amt-fix',
                    label: 'Invoice Line Amt'
                  },
                  {
                    key: 'tax_amount',
                    class: 'text-fix-po',
                    label: 'Line Tax Amt'
                  },
                  { key: 'cn_return_amt', class: 'tax-amt-fix', label: 'CN Amt' },
                  {
                    key: 'cn_return_tax_amt',
                    class: 'tax-amt-fix',
                    label: 'CN Tax Amt'
                  },
                  {
                    key: 'tax_details',
                    label: 'Tax',
                    stickyColumn: true
                  },
                  {
                    key: 'split',
                    stickyColumn: true
                  }
                ]
                } else {
                this.invoiceLineFields = [
                  {
                    key: 'manual_invoice_line_id',
                    label: 'Manual Invoice Line No.'
                  },
                  {
                    key: 'item_description',
                    label: 'Description'
                  },
                  {
                    key: 'po_price',
                    label: 'PO Price',
                    class: 'col-width-fix'
                  },
                  {
                    key: 'deliver_qty',
                    label: 'Qty. Being Delivered',
                    class: 'qty-width-fix'
                  },
                  {
                    key: 'hsn_sac',
                    label: 'Invoice HSN/SAC',
                    // class: 'col-width-fix' // 1.8 (Himanshu)
                  },
                  { key: 'taxable_amount', class: 'tax-amt-fix' },
                  {
                    key: 'tax_amount',
                    class: 'text-fix-po'
                  },
                  {
                    key: 'tax_non_recoverable',
                    label: 'Tax Non Recoverable'
                  },
                  {
                    key: 'status_code',
                    label: 'GRN Status',
                    class: 'col-width-fix'
                  },
                  {
                    key: 'status_msg',
                    label: 'Error Message'
                  },
                  {
                    key: 'tax_details',
                    label: 'Tax',
                    stickyColumn: true
                  },
                  {
                    key: 'split',
                    stickyColumn: true
                  }
                ];
              }
                if(this.headerDetails.currency !== 'INR') { // 2.4 (Himanshu) key added
                  this.invoiceLineFields.splice(
                   this.invoiceLineFields.findIndex(f => f.key === 'taxable_amount') + 1,
                   0,
                   { key: 'taxable_amount_inr', label: 'Taxable Amount (INR)', class: 'tax-amt-fix' }
                 );
                }
              } else {
                if(this.headerDetails.adj_flag === '1') { // 2.8 (Himanshu)
                 this.invoiceLineFields = [
                  { // 2.8 (Himanshu)
                    key: 'return_inv_date',
                    label: 'Invoice Date'
                  },
                  {
                    key: 'source_inv_num',
                    label: 'Invoice No.'
                  },
                  {
                    key: 'line_number',
                    label: 'Line No.',
                    stickyColumn: true
                  },
                  {
                    key: 'item_description',
                    label: 'Item Description',
                    class: 'col-fix-lg'
                  },
                  // {
                  //   key: 'po_price',
                  //   label: 'PO Price',
                  //   class: 'col-width-fix'
                  // },
                  // {
                  //   key: 'deliver_qty',
                  //   label: 'Qty. Being Delivered',
                  //   class: 'qty-width-fix'
                  // },
                  {
                    key: 'hsn_sac',
                    label: 'HSN/SAC',
                    class: 'col-fix-small text-left'
                  },
                  { // 2.8 (Himanshu)
                    key: 'taxable_amount',
                    class: 'tax-amt-fix',
                    label: 'Invoice Line Amt'
                  },
                  {
                    key: 'tax_amount',
                    class: 'text-fix-po',
                    label: 'Line Tax Amt'
                  },
                  { key: 'cn_return_amt', class: 'tax-amt-fix', label: 'CN Amt' },
                  {
                    key: 'cn_return_tax_amt',
                    class: 'tax-amt-fix',
                    label: 'CN Tax Amt'
                  },
                  {
                    key: 'tax_details',
                    label: 'Tax',
                    stickyColumn: true
                  },
                  // {
                  //   key: 'split',
                  //   stickyColumn: true
                  // }
                ]
                } else {
                   this.invoiceLineFields = [
                  {
                    key: 'manual_invoice_line_id',
                    label: 'Manual Invoice Line No.'
                  },
                  {
                    key: 'item_description',
                    label: 'Description'
                  },
                  {
                    key: 'po_price',
                    label: 'PO Price',
                    class: 'col-width-fix'
                  },
                  {
                    key: 'deliver_qty',
                    label: 'Qty. Being Delivered',
                    class: 'qty-width-fix'
                  },
                  {
                    key: 'hsn_sac',
                    label: 'Invoice HSN/SAC',
                    // class: 'col-width-fix'
                  },
                  { key: 'taxable_amount', class: 'tax-amt-fix' },
                  {
                    key: 'tax_amount',
                    class: 'text-fix-po'
                  },
                  {
                    key: 'tax_details',
                    label: 'Tax',
                    stickyColumn: true
                  },
                  {
                    key: 'split',
                    stickyColumn: true
                  }
                ];
                }
                
              }
            } else { // 2.8 (Himanshu)
              if(this.headerDetails.adj_flag === '2') {
                this.invoiceLineFields = [
                  {
                    key: 'po_number'
                  },
                  {
                    key: 'po_line_num',
                    label: 'PO Line Number'
                  },
                  {
                    key: 'po_release_num',
                    label: 'PO Release Number'
                  },
                  {
                    key: 'source_inv_num',
                    label: 'Invoice Number'
                  },
                  {
                    key: 'return_inv_date',
                    label: 'Invoice Date'
                  },
                  {
                    key: 'grn_number',
                    label: 'GRN Number'
                  },
                  {
                    key: 'item_description',
                    label: 'Item Description',
                  },
                  {
                    key: 'quantity',
                    label: 'Net Qty. Received', // 3.0 (Himanshu)
                    class: 'col-fix-small'
                  },
                  {
                    key: 'po_price',
                    label: 'Unit Price', // 3.0 (Himanshu)
                    class: 'text-right'
                  },
                  {
                    key: 'tax_amount',
                    label: 'Tax Amount',
                    class: 'text-right'
                  },
                  {
                    key: 'return_qty',
                    label: 'CN Qty.', // 3.0 (Himanshu)
                    class: 'col-fix-small text-left'
                  },
                  {
                    key: 'cn_return_amt',
                    label: 'CN Amount', // 3.0 (Himanshu)
                    class: 'text-right'
                  },
                  {
                    key: 'cn_return_tax_amt',
                    label: 'CN Tax Amount', // 3.0 (Himanshu)
                    class: 'text-right'
                  },
                  {
                    key: 'tax_details',
                    label: 'Tax',
                    stickyColumn: true
                  },
                ]
                for(let i of this.invoiceLineData) {
                  i.grn_number = this.headerDetails.receipt_num;
                  i.cn_return_amt = commonHelper.formatAmountWithoutCurrency(i.cn_return_amt); // 3.0 (Himanshu)
                  i.cn_return_tax_amt = commonHelper.formatAmountWithoutCurrency(i.cn_return_tax_amt); // 3.0 (Himanshu)
                  i.po_price = commonHelper.formatAmountWithoutCurrency(i.po_price); // 3.0 (Himanshu)
                  i.tax_amount = commonHelper.formatAmountWithoutCurrency(i.tax_amount); // 3.0 (Himanshu)
                }
              } else {
                this.setFieldsForFinance();
              }
              
            }
            // if (!this.headerDetails.manual_invoice) {
            //   if (this.headerDetails.invoice_level == 'INVOICE') {
            //     this.headerDetails.remarks = this.headerDetails.remarks
            //       ? this.headerDetails.remarks
            //       : this.headerDetails.inv_num +
            //         ' | ' +
            //         this.headerDetails.vendor_name +
            //         ' | ' +
            //         this.headerDetails.po_num;
            //   }
            // }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHidePreviewTaxModal(flag, item, index) {
      // 2.2 (Himanshu) RCM tax type add or edit mandatory check
      // if(flag === false && this.previewTaxData.length> 0 && this.headerDetails.manual_invoice && this.headerDetails.invoice_level === 'INVOICE' && ((this.headerDetails.third_party_gstn === 'GSTNOTAVAILABLE' && this.previewTaxData[0].rcm_flag === 'Y')) && (this.previewTaxData[this.previewTaxData.length-1].tax_type===null || this.previewTaxData[this.previewTaxData.length-1].tax_rate===null)) {
      //   this.makeToast('Either fill in all the details or delete the blank line', "danger")
      //   this.showPreviewTaxModal = true;
      // } else {
       this.showPreviewTaxModal = flag;
       this.selectedInvoiceIndex = index; // 2.2 (Himanshu) added a new index for selected manual index
      if (flag) {
        this.previewTaxData = item.tax_details;
        if(this.headerDetails.manual_invoice 
                  && this.headerDetails.invoice_level === 'INVOICE') {
        if(item.tax_details_length > 0) {
          this.previewTaxFields = [
        { key: 'tax_type', class: 'tax-type-fix' },
        { key: 'taxable_amount', class: 'col-width-acc' },
        { key: 'tax_rate', class: 'tax-type-fix' },
        { key: 'amount', label: 'Tax Amount', class: 'tax-type-fix' },
        {
          key: 'tax_category_name',
          label: 'Tax Category',
          class: 'tax-cat-fix'
        },
        { key: 'rcm_flag', label: 'RCM', stickyColumn: true }
      ];
        } else {
          this.previewTaxFields = [
          {key: 'add', class: 'tax-type-fix'}, // 2.2 (Himanshu) RCM tax type add
        {key: 'remove', class: 'tax-type-fix'}, // 2.2 (Himanshu) RCM tax type add
        { key: 'tax_type', class: 'tax-type-fix' },
        { key: 'taxable_amount', class: 'col-width-acc' },
        { key: 'tax_rate', class: 'tax-type-fix' },
        { key: 'amount', label: 'Tax Amount', class: 'tax-type-fix' },
        {
          key: 'tax_category_name',
          label: 'Tax Category',
          class: 'tax-cat-fix'
        },
        { key: 'rcm_flag', label: 'RCM', stickyColumn: true }
      ];
        }
        }
        this.vendorInvoiceDetailId = item.vendor_inv_dtl_id;
        this.getPreviewTaxData(index);
        // this.previewTaxData.map(ele => {
        //   if (ele.manual !== 'Y') {
        //     ele.taxable_amount = item.deliver_qty * item.po_price;
        //   } else {
        //     ele.taxable_amount = null;
        //   }
        // });
      }
      // }
      
    },
    formattingAmount(amount) {
      return commonHelper.formatAmountWithoutCurrency(amount);
    },
    showHideDocumentModal(flag) {
      this.showDocumentModal = flag;
    },
    showHideRejectModal(flag) {
      this.showRejectModal = flag;
      if (!flag) {
        this.rejectedReason = null;
      }
    },
    isSplitAvail(invoiceLevel, type) {
      if (invoiceLevel === 'BUYER') {
        if (type === 'approve_forward') {
          this.selectUserPreference();
          if (
            this.operatingUnit.value &&
            this.headerDetails.vendor_site_id &&
            this.headerDetails.remarks
          ) {
            this.updateInvoiceDetailsManual();
            this.showHideApproveForwardModal(true);
          } else {
            alert('Please Enter Mandatory Fields');
          }
        } else if (type === 'approve') {
          const isCCSaved = this.invoiceLineData.filter(ele => !ele.cc_flag);
          if (isCCSaved.length && this.headerDetails.ajd_flag === '0') {
            alert('Kindly Save Cost Centre Details.');
          } else {
            this.showHideApproveModal(true);
          }
        }
        // const isCCSaved = this.invoiceLineData.filter(ele => !ele.cc_flag);
        // if (isCCSaved.length) {
        //   alert('Kindly Save Cost Centre Details.');
        // } else {
        //   if (type === 'approve_forward') {
        //     this.showHideApproveForwardModal(true);
        //   }
        //   if (type === 'approve') {
        //     this.showHideApproveModal(true);
        //   }
        // }
      } else if (invoiceLevel === 'INVOICE') {
        if (type === 'approve_forward') {
          this.selectUserPreference(); // 2.3 (Himanshu) API called in case of Invoice Level
          this.showHideApproveForwardModal(true);
        } else if (type === 'approve') {
          // const isDistSaved = this.invoiceLineData.filter(ele => !ele.fin_flag); // 3.1 (Himanshu) Commented to remove distribution details from Vatika as per new requirement
          // if (isDistSaved.length) {
          //   alert('Kindly Save Distribution Details.');
          // } else {
            // if(this.advancesAppliedData.length<=1 && !this.headerDetails.manual_invoice) {
            //   alert('Advance apply is mandatory')
            // } else {
             this.showHideApproveModal(true);
            // }
          // }
        }
        // const isDistSaved = this.invoiceLineData.filter(ele => !ele.fin_flag);
        // if (isDistSaved.length) {
        //   alert('Kindly Save Distribution Details.');
        // } else {
        //   if (type === 'approve_forward') {
        //     this.showHideApproveForwardModal(true);
        //   }
        //   if (type === 'approve') {
        //     this.showHideApproveModal(true);
        //   }
        // }
      }
    },
    showHideApproveModal(flag) {
      if (!this.headerDetails.manual_invoice) {
        if (this.headerDetails.invoice_level === 'INVOICE' && this.headerDetails.adj_flag !== '2') { // 2.8 (Himanshu) For CN, we can skip GRN check
          // if(this.advancesAppliedData.length<=1) {
          //   alert('Advance apply is mandatory')
          // } else {
            // if ( // 3.1 (Himanshu)
            //   this.headerDetails.receipt_num &&
            //   this.headerDetails.grn_attach_flag
            // ) {
              this.showApproveModal = flag;
            // } else {
            //   alert('GRN Not Created Yet/GRN pdf not attached');
            // }
          // }
        } else {
          this.showApproveModal = flag;
        }
      } else {
        this.showApproveModal = flag;
      }
      if (!flag) {
        this.approvalReason = null;
      }
    },
    isRecieptNumberAvail() {
      // if (this.headerDetails.receipt_num) { // 3.1 (Himanshu)
        this.showHideApproveModal(true);
      // } else {
      //   alert('GRN Not Created Yet/GRN pdf not attached');
      // }
    },
    approveRejectInvoiceApproval(status) {
      if (
        this.headerDetails.manual_invoice &&
        this.headerDetails.invoice_level === 'INVOICE'
      ) {
        const payload = {
          vendor_invoice_id: this.vendorInvId,
          invoice_type: this.headerDetails.manual_invoice ? 1 : 0,
          tag: 'DIS_VALIDATION_ALL'
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/checkSplitDataMismatched', payload)
          .then(response => {
            this.loader = false;
            this.showAlert = true;
            if (response.status === 200) {
              if (response.data.data === 'F' && status === 'APPROVED') {
                alert(
                  'Cost centre and Distribution amount not matched'
                );
              } else {
                const payload = {
                  event_id: this.workflowId.eventId,
                  wf_inprocess_dtl_id: this.wfDtlId,
                  notification_status: status,
                  notification_comments:
                    status === 'REJECTED'
                      ? this.rejectedReason
                      : this.approvalReason
                };
                this.loader = true;
                this.$store
                  .dispatch('intWorkflow/approvalRejectSingle', payload)
                  .then(response => {
                    this.loader = false;
                    this.showAlert = true;
                    if (response.status === 200) {
                      this.getVendorInvoiceDetailsById();
                      this.editMode = false;
                      this.isSuccess = true;
                      this.responseMsg = response.data.message;
                      if (status === 'REJECTED') {
                        this.showHideRejectModal(false);
                      } else if (status === 'APPROVED') {
                        this.showHideApproveModal(false);
                      }
                      this.$emit('updateInvoice');
                    } else {
                      this.showAlert = false;
                      alert(response.response.data.message);
                      // this.isSuccess = false;
                      // this.responseMsg = response.response.data.message;
                    }
                  })
                  .catch(() => {
                    this.loader = false;
                  });
              }
            } else {
              this.showAlert = false;
              alert(response.response.data.message);
              this.isSuccess = false;
              this.responseMsg = response.response.data.message;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      } else {
        const payload = {
          event_id: this.workflowId.eventId,
          wf_inprocess_dtl_id: this.wfDtlId,
          notification_status: status,
          notification_comments:
            status === 'REJECTED'
              ? this.rejectedReason
              : this.approvalReason
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/approvalRejectSingle', payload)
          .then(response => {
            this.loader = false;
            this.showAlert = true;
            if (response.status === 200) {
              this.getVendorInvoiceDetailsById();
              this.editMode = false;
              this.isSuccess = true;
              this.responseMsg = response.data.message;
              if (status === 'REJECTED') {
                this.showHideRejectModal(false);
              } else if (status === 'APPROVED') {
                this.showHideApproveModal(false);
              }
              if(status === 'APPROVED' && this.headerDetails.invoice_level === 'BUYER') { // 2.5 (Himanshu) Changed condition from GRN level to Buyer level
                this.updateGrnFlag()
              }
              this.$emit('updateInvoice');
            } else {
              this.showAlert = false;
              alert(response.response.data.message);
              // this.isSuccess = false;
              // this.responseMsg = response.response.data.message;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    showHideInvoiceCommonModal(flag, modalType, index, type) {
      this.modalType = modalType;
      this.specIndex = index;
      this.expenseType = type;
      if (flag) {
        if (this.modalType === 'expense_month') {
          this.getExpenseMonth();
        } else if (this.modalType === 'tds_section') {
          this.getTdsSection();
        } else if (this.modalType === 'tds_rate') {
          this.getTdsRate();
        } else if (this.modalType === 'operating_unit') {
          this.getOperatingUnitDetails();
        } else if (this.modalType === 'vendor_site') {
          this.getVendorSiteDetails();
        }
      }
      if (!flag) {
        this.specIndex = null;
        this.perPageTdsRate = commonHelper.perPageRecord;
        this.totalRowsTdsRate = null;
        this.currentPageTdsRate = 1;
      }
      this.showInvoiceCommonModal = flag;
    },
    getExpenseMonth() {
      const payload = {
        _page: this.currentPageExpense - 1,
        _limit: this.perPageExpense,
        po_creation_date: this.headerDetails.po_creation_date,
        period_name: this.expenseMonthSearch
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getExpenseMonth', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.expenseData = result;
            this.totalRowsExpense = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getTdsSection() {
      const payload = {
        _page: this.currentPageTdsSection - 1,
        _limit: this.perPageTdsSection,
        section_name: this.tdsSectionSearch
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getTdsSection', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.tdsSectionData = result;
            this.totalRowsTdsSection = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getTdsRate() {
      const payload = {
        _page: this.currentPageTdsRate - 1,
        _limit: this.perPageTdsRate,
        org_id: this.headerDetails.ou_id,
        section_code: this.invoiceLineData[this.specIndex].tds_section_code,
        tds_rate: this.tdsRateSearch
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getTdsRate', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.tdsRateData = result;
            this.totalRowsTdsRate = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedExpense(item) {
      if (this.expenseType == 'header') {
        this.headerDetails.period_name = item.period_name;
      } else if (this.expenseType == 'line') {
        this.invoiceLineData[this.specIndex].period_name = item.period_name;
        this.invoiceLineData = JSON.parse(JSON.stringify(this.invoiceLineData));
      } else if (this.expenseType == 'line_cc') {
        this.splitData[this.specIndex].expense_month = item.period_name;
        this.splitData = JSON.parse(JSON.stringify(this.splitData));
      } else if (this.expenseType == 'with_po_expense') {
        this.splitFinDataWithPo[this.specIndex].expense_month =
          item.period_name;
        // this.splitData = JSON.parse(JSON.stringify(this.splitData));
      } else if (this.expenseType == 'header_expense') {
        if (this.splitData.length) {
          this.expenseMonth = item.period_name;
          this.splitData = this.splitData.map(ele => {
            ele.expense_month = item.period_name;
            return ele;
          });
        } else if (this.splitFinData.length) {
          this.expenseMonth = item.period_name;
          this.splitFinData = this.splitFinData.map(ele => {
            ele.expense_month = item.period_name;
            return ele;
          });
        } else {
          alert('Kindly Enter Cost Centre Details First');
        }
      } else if(this.expenseType === 'split_line') {
        this.splitFinData[this.specIndex].expense_month = item.period_name;
        this.splitFinData = JSON.parse(JSON.stringify(this.splitFinData));
      }
      this.perPageExpense = commonHelper.perPageRecord;
      this.totalRowsExpense = null;
      this.currentPageExpense = 1;
      this.showInvoiceCommonModal = false;
    },
    rowSelectedTdsSection(item) {
      this.invoiceLineData[this.specIndex].tds_section_code = item.lookup_code;
      this.invoiceLineData[this.specIndex].tds_section_meaning = item.meaning;
      this.invoiceLineData = JSON.parse(JSON.stringify(this.invoiceLineData));
      this.showInvoiceCommonModal = false;
      this.perPageTdsSection = commonHelper.perPageRecord;
      this.totalRowsTdsSection = null;
      this.currentPageTdsSection = 1;
    },
    rowSelectedTdsRate(item) {
      this.invoiceLineData[this.specIndex].tax_rate_id = item.tax_rate_id;
      this.invoiceLineData[this.specIndex].tax_rate_name = item.tax_rate_name;
      this.invoiceLineData = JSON.parse(JSON.stringify(this.invoiceLineData));
      this.showInvoiceCommonModal = false;
      this.perPageTdsRate = commonHelper.perPageRecord;
      this.totalRowsTdsRate = null;
      this.currentPageTdsRate = 1;
    },
    validateFunction(rate) {
      var regex = /^\d+(\.\d{0,4})?$/g;
      if (rate) {
        if (!regex.test(rate)) {
          alert('Exchange Rate cannot be greater than four decimal places');
          this.headerDetails.exchange_rate = null;
        }
      }
    },

    clearTdsValues(index) {
      this.invoiceLineData[index].tds_section_code = null;
      this.invoiceLineData[index].tds_section_meaning = null;
      this.invoiceLineData[index].tax_rate_id = null;
      this.invoiceLineData[index].tax_rate_name = null;
    },
    clearVsetValues(segment, index) {
      if (segment === 'expense-month') {
        this.invoiceLineData[index].period_name = null;
      } else if (segment === 'expense_month_cc') {
        this.splitData[index].expense_month = null;
        this.splitData = JSON.parse(JSON.stringify(this.splitData));
      } else if (segment === 'tds_section') {
        this.invoiceLineData[index].tds_section_code = null;
        this.invoiceLineData[index].tds_section_meaning = null;
      } else if (segment === 'tds_rate') {
        this.invoiceLineData[index].tax_rate_id = null;
        this.invoiceLineData[index].tax_rate_name = null;
      } else if (segment === 'cost_centre') {
        this.splitData[index].cost_centre = null;
      } else if (segment === 'expense_month_header') {
        this.headerDetails.period_name = null;
        this.headerDetails = JSON.parse(JSON.stringify(this.headerDetails));
      } else if (segment === this.selectedEmp.text) {
        this.selectedEmp.text = null;
        this.selectedEmp.value = null;
      } else if (segment === 'operating_unit') {
        this.operatingUnit.text = null;
        this.operatingUnit.value = null;
        this.headerDetails.vendor_site_id = null;
        this.headerDetails.vendor_site_name = null;
      } else if (segment === 'vendor_site') {
        this.headerDetails.vendor_site_id = null;
        this.headerDetails.vendor_site_name = null;
      } else if (segment === this.distribution.value) {
        this.distribution.text = null;
        this.distribution.value = null;
        this.splitData = [];
      } else if (segment === this.expenseMonth) {
        this.expenseMonth = null;
        this.splitData = this.splitData.map(ele => {
          ele.expense_month = null;
          return ele;
        });
      } else if (segment === 'header_expense') {
        this.expenseMonth = null;
        this.splitFinData = this.splitFinData.map(ele => {
          ele.expense_month = null;
          return ele;
        });
      }
      // else if (segment === 'QC_STATUS') {
      //   this.invoiceLineData[index].qc_status = null
      // }
    },
    // async allDetailsAvail() {
    //   if (this.alreadyChecked) {
    //     return false;
    //   }
    //   this.alreadyChecked = true;
    //   if (this.headerDetails.invoice_level !== 'INVOICE') {
    //     if (
    //       this.headerDetails.actual_gr_date &&
    //       this.headerDetails.period_name &&
    //       this.headerDetails.material_received_by
    //     ) {
    //       if (this.headerDetails.invoice_level === 'GRN') {
    //         let count = 0;
    //         for (let i of this.invoiceLineData) {
    //           if (i.qc_status) {
    //             count++;
    //           }
    //         }

    //         // if (count === 0) {
    //           // const payload = {
    //           //   hdr_id: this.headerDetails.vendor_inv_id
    //           // };
    //           // this.loader = true;
    //           // try {
    //           //   const response = await this.$store.dispatch(
    //           //     'intWorkflow/getGrnQcDocFlag',
    //           //     payload
    //           //   );
    //           //   this.loader = false;
    //           //   if (response.status === 200) {
    //           //     return true;
    //           //   } else {
    //           //     this.$bvToast.toast(
    //           //       response.response.data.message,
    //           //       {
    //           //         title: 'Error',
    //           //         variant: 'danger',
    //           //         solid: true,
    //           //         autoHideDelay: 10000
    //           //       }
    //           //     );
    //           //     return false;
    //           //   }
    //           // } catch (error) {
    //           //   this.loader = false;
    //           //   alert('Something went wrong while checking document flag');
    //           //   return false;
    //           // }
    //         // } else {
    //         //   alert('Please Enter all the mandatory fields');
    //         //   return false;
    //         // }
    //         if(count>0){
    //           alert('Please Enter all the mandatory fields');
    //           return false;
    //         }
    //       } else {
    //         return true;
    //       }
    //     } else {
    //       alert('Please Enter all the mandatory fields');
    //       return false;
    //     }
    //   }
    //   if (this.headerDetails.invoice_level === 'INVOICE') {
    //     if (this.headerDetails.gl_date) {
    //       return true;
    //     } else {
    //       alert('Please Enter GL Date');
    //       return false;
    //     }
    //   }
    //   return false;
    // },
    allDetailsAvail() {
      // 2.8 (Himanshu)
      if (this.headerDetails.invoice_level !== 'INVOICE' && this.headerDetails.adj_flag !== '2') { // 2.8 (Himanshu) condition added for adjustment flag
        if (
          this.headerDetails.actual_gr_date &&
          this.headerDetails.period_name &&
          this.headerDetails.material_received_by
        ) { 
            // 1.6 <Anuj>
            if (this.headerDetails.invoice_level === 'GRN') {
              let count = 0;
              for (let i of this.invoiceLineData) {     
                // if (i.item_code.slice(0, 2) === 'SR') {
                  if (!i.qc_status) {                    
                    count++;
                  // }
                }
              }
              if(count > 0){                
                alert('Please Enter all the mandatory fields');
                return false;
              }
            }
          return true;
        } else {
          alert('Please Enter all the mandatory fields');
        }
      } else {
        return true; // 2.8 (Himanshu) for adjustment invoice, mandatory check is not required for GRN details
      }
      if (this.headerDetails.invoice_level === 'INVOICE') {
        if (this.headerDetails.gl_date) {
          return true;
        } else {
          alert('Please Enter GL Date');
        }
      }
    },
    updateInvoiceDetailsManual() {
      // if(this.headerDetails.invoice_level == 'INVOICE' && this.advancesAppliedData.length<=1) {
      //   alert('Advance Apply is mandatory')
      //  } else {
      if(this.headerDetails.invoice_level === 'INVOICE' && this.headerDetails.currency !== 'INR' && (this.headerDetails.exchange_rate === null || this.headerDetails.exchange_rate === "")) {
        alert('Exchange Rate mandatory')
      } else if(this.headerDetails.invoice_level === 'INVOICE' && this.headerDetails.currency !== 'INR' && (this.headerDetails.purpose_code === null || this.headerDetails.purpose_code === "")) { // 2.4 (Himanshu) mandatory check added for purpose code
        alert('Purpose Code mandatory')
      } else {
        if (
          this.headerDetails.remarks &&
          this.operatingUnit.text &&
          this.headerDetails.vendor_site_id
        ) {
          const invoiceDetails = this.invoiceLineData.map(elem => {
            // 1.7 (Himanshu) For updating tax rate and tax amount
            let taxDetails = [];
            for(let i of elem.tax_details) {
              taxDetails.push({
                vnd_inv_tax_id: +i.vnd_inv_tax_id,
                tax_rate: +i.tax_rate,
                amount: +i.amount
              })
            }
            return {
              vendor_inv_dtl_id: elem.vendor_inv_dtl_id,
              period_name: elem.period_name,
              tds_flag: elem.tds_flag,
              tds_section_code: elem.tds_section_code,
              tds_section_meaning: elem.tds_section_meaning,
              tax_rate_id: elem.tax_rate_id,
              tax_rate_name: elem.tax_rate_name,
              tax_non_recoverable: elem.tax_non_recoverable
                ? elem.tax_non_recoverable
                : false,
                hsn_sac: elem.hsn_sac,
                tax_dtls: taxDetails // 1.7 (Himanshu) for updating tax details
            };
          });
          // if (invoiceDetails.length) {
          const payload = {
            vendor_invoice_id: this.vendorInvId,
            remarks: this.headerDetails.remarks,
            manual_ou_id: this.operatingUnit.value,
            manual_ou_name: this.operatingUnit.text,
            vendor_site_id: this.headerDetails.vendor_site_id,
            vendor_site_name: this.headerDetails.vendor_site_name,
            gl_date: this.headerDetails.gl_date,
            vendor_invoice_dtls: invoiceDetails ? invoiceDetails : null,
            payment_term: this.payment_terms_manual,
            exchange_rate: this.headerDetails.exchange_rate
                   ? +this.headerDetails.exchange_rate
                   : null,
            purpose_code: this.headerDetails.purpose_code // 2.4 (Himanshu) key added in payload
          };
          this.loader = true;
          this.$store
            .dispatch('intWorkflow/updateInvoiceDetailsFinance', payload)
            .then(response => {
              this.loader = false;
              this.showAlert = true;
              if (response.status === 200) {
                this.editMode = false;
                this.vendorInvId = response.data.data.vendor_inv_id;
                this.payment_terms_manual = response.data.data.payment_term;
                this.getVendorInvoiceDetailsById();
                this.isSuccess = true;
                this.responseMsg = response.data.message;
              } else {
                this.isSuccess = false;
                this.responseMsg = response.response.data.message;
              }
            })
            .catch(() => {
              this.loader = false;
              this.isSuccess = false;
              this.responseMsg = appStrings.autoFailedMsg;
            });
        } else {
          alert('Please Enter Mandatory Fields');
        }
      }       
      //  }  
    },
    updateInvoiceDetailsFinance() {
      // const invoiceLineMapping = [];
      // for (let i = 0; i < this.invoiceLineData.length; i++) {
      //   if (
      //     this.invoiceLineData[i].vendor_inv_dtl_id !== 0 &&
      //     this.invoiceLineData[i].vendor_inv_dtl_id ==
      //       this.invoiceLineDataCopy[i].vendor_inv_dtl_id
      //   ) {
      //     if (
      //       this.invoiceLineData[i].period_name !==
      //         this.invoiceLineDataCopy[i].period_name ||
      //       this.invoiceLineData[i].tds_flag !==
      //         this.invoiceLineDataCopy[i].tds_flag ||
      //       this.invoiceLineData[i].tds_section_code !==
      //         this.invoiceLineDataCopy[i].tds_section_code ||
      //       this.invoiceLineData[i].tax_rate_id !==
      //         this.invoiceLineDataCopy[i].tax_rate_id
      //     ) {
      //       invoiceLineMapping.push(this.invoiceLineData[i]);
      //     }
      //   } else if (this.invoiceLineData[i].vendor_inv_dtl_id === 0) {
      //     invoiceLineMapping.push(this.invoiceLineData[i]);
      //   }
      // }
      if(this.headerDetails.invoice_level == 'INVOICE' && this.advanceMatchFlag && this.advancesAppliedData.length<=1) {
        alert('Advance Apply is mandatory')
       } else { // 2.0 (Himanshu) Commented Advance Apply mandatory for PO Invoices
        // 2.1 (Himanshu) Unommented Advance Apply mandatory for PO Invoices
          // this.alreadyChecked = false;
          // const result = await this.allDetailsAvail();
         if (this.headerDetails.invoice_level == 'GRN') {
           let count = 0;
           for (let i of this.invoiceLineData) {
             if (i.acc_amt === null || i.acc_qty === null || i.acc_amt === 0 || i.acc_qty === 0) {
               count++;
             }
           }
           if (count > 0 && this.headerDetails.adj_flag !== '2') { // 2.8 (Himanshu) adj_flag condition added
             alert('Either Accepted Quantity or Accepted Amount empty');
           } else {
            // this.alreadyChecked = false;
            // const result = await this.allDetailsAvail();
            //  if (result) {
             if (this.allDetailsAvail()) {
               const invoiceDetails = this.invoiceLineData.map(elem => {
                 return {
                   vendor_inv_dtl_id: elem.vendor_inv_dtl_id,
                   period_name: elem.period_name,
                   tds_flag: elem.tds_flag,
                   tds_section_code: elem.tds_section_code,
                   tds_section_meaning: elem.tds_section_meaning,
                   tax_rate_id: elem.tax_rate_id,
                   tax_rate_name: elem.tax_rate_name,
                   acc_qty: +elem.acc_qty,
                   acc_amt: +elem.acc_amt,
                   qc_status: elem.qc_status ? 'Y' : 'N',       // 1.6 <Anuj>
                   qc_remark: elem.qc_remark,                   // 1.6 <Anuj>
                   hsn_sac: elem.hsn_sac                        // 1.9 <Himanshu> Added key for saving Invoice
                 };
               });
               if (invoiceDetails.length) {
                 const payload = {
                   vendor_invoice_id: this.vendorInvId,
                   actual_gr_date: this.headerDetails.actual_gr_date,
                   physical_mrn_number: this.headerDetails.physical_mrn_number,
                 physical_mrn_date: this.headerDetails.physical_mrn_date,
                   gl_date: this.headerDetails.gl_date,
                   period_name: this.headerDetails.period_name,
                   material_received_by: this.headerDetails.material_received_by,
                   exchange_rate: this.headerDetails.exchange_rate
                     ? +this.headerDetails.exchange_rate
                     : null,
                   remarks: this.headerDetails.remarks,
                   manual_ou_id: this.operatingUnit.value,
                   manual_ou_name: this.operatingUnit.text,
                   vendor_invoice_dtls: invoiceDetails ? invoiceDetails : null
                 };
                 this.loader = true;
                 this.$store
                   .dispatch('intWorkflow/updateInvoiceDetailsFinance', payload)
                   .then(response => {
                     this.loader = false;
                     this.showAlert = true;
                     if (response.status === 200) {
                       this.editMode = false;
                       this.vendorInvId = response.data.data.vendor_inv_id;
                       this.getVendorInvoiceDetailsById();
                       this.isSuccess = true;
                       this.responseMsg = response.data.message;
                     } else {
                       this.isSuccess = false;
                       this.responseMsg = response.response.data.message;
                     }
                   })
                   .catch(() => {
                     this.loader = false;
                     this.isSuccess = false;
                     this.responseMsg = appStrings.autoFailedMsg;
                   });
               }
             }
           }
         } else {
           if (this.allDetailsAvail()) {
          //  if (result) {
             const invoiceDetails = this.invoiceLineData.map(elem => {
               return {
                 vendor_inv_dtl_id: elem.vendor_inv_dtl_id,
                 period_name: elem.period_name,
                 tds_flag: elem.tds_flag,
                 tds_section_code: elem.tds_section_code,
                 tds_section_meaning: elem.tds_section_meaning,
                 tax_rate_id: elem.tax_rate_id,
                 tax_rate_name: elem.tax_rate_name,
                 acc_qty: +elem.acc_qty,
                 acc_amt: +elem.acc_amt,
                 qc_status: elem.qc_status ? 'Y' : 'N',         // 1.6 <Anuj>
                 qc_remark: elem.qc_remark,                     // 1.6 <Anuj>
                 hsn_sac: elem.hsn_sac                          // 1.9 <Himanshu> Added key for saving Invoice
               };
             });
             if (invoiceDetails.length) {
               const payload = {
                 vendor_invoice_id: this.vendorInvId,
                 actual_gr_date: this.headerDetails.actual_gr_date,
                 physical_mrn_number: this.headerDetails.physical_mrn_number,
                 physical_mrn_date: this.headerDetails.physical_mrn_date,
                 gl_date: this.headerDetails.gl_date,
                 period_name: this.headerDetails.period_name,
                 material_received_by: this.headerDetails.material_received_by,
                 exchange_rate: this.headerDetails.exchange_rate
                   ? +this.headerDetails.exchange_rate
                   : null,
                 remarks: this.headerDetails.invoice_level == 'INVOICE' ? this.headerDetails.remarks : null,
                 manual_ou_id: this.operatingUnit.value,
                 manual_ou_name: this.operatingUnit.text,
                 vendor_invoice_dtls: invoiceDetails ? invoiceDetails : null
               };
               this.loader = true;
               this.$store
                 .dispatch('intWorkflow/updateInvoiceDetailsFinance', payload)
                 .then(response => {
                   this.loader = false;
                   this.showAlert = true;
                   if (response.status === 200) {
                     this.editMode = false;
                     this.vendorInvId = response.data.data.vendor_inv_id;
                     this.getVendorInvoiceDetailsById();
                     this.isSuccess = true;
                     this.responseMsg = response.data.message;
                   } else {
                     this.isSuccess = false;
                     this.responseMsg = response.response.data.message;
                   }
                 })
                 .catch(() => {
                   this.loader = false;
                   this.isSuccess = false;
                   this.responseMsg = appStrings.autoFailedMsg;
                 });
             }
           }
         }
       }
    },
    getValidateGlDate(glDate) {
      if (glDate) {
        const payload = {
          le_id: this.headerDetails.erp_le_id,
          gl_date: glDate
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/getValidateGlDate', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              this.validateMsg =
                response.data.data.data.CLOSING_STATUS == 'O'
                  ? 'OPEN'
                  : response.data.data.data.CLOSING_STATUS == 'N'
                  ? 'NOT OPEN'
                  : '';
              if (this.validateMsg !== 'OPEN') {
                this.headerDetails.gl_date = null;
                alert('Period is Not Open For GL Date');
              }
              if (this.validateMsg == 'OPEN') {
                this.headerDetails.gl_date = glDate;
                this.responseMsg = `${response.data.message} , GL Date status is ${this.validateMsg}.`;
              }
            } else {
              this.showAlert = true;
              this.isSuccess = false;
              this.responseMsg = response.response.data.message;
            }
          })
          .catch(() => {
            this.loader = false;
            this.isSuccess = false;
            this.responseMsg = appStrings.autoFailedMsg;
          });
      }
    },
    grnDisabledDates(date) {
      const restrictedFromDate = new Date(this.headerDetails.po_creation_date);
      restrictedFromDate.setHours(0, 0, 0, 0);
      const restrictedToDate = new Date();
      restrictedToDate.setHours(0, 0, 0, 0);
      return date < restrictedFromDate || date > restrictedToDate;
    },
    glDisabledDates(date) {
      const restrictedFromDate = new Date(this.headerDetails.inv_date);
      restrictedFromDate.setHours(0, 0, 0, 0);
      const restrictedToDate = new Date();
      restrictedToDate.setHours(0, 0, 0, 0);
      return date < restrictedFromDate || date > restrictedToDate;
    },
    getPeriodIndex(index) {
      this.specIndex = index;
    },
    getPeriodToIndex(index) {
      this.specIndex = index;
    },
    periodDisabledDates(date) {
      const restrictedFromDate = new Date(
        this.splitFinDataWithPo[this.specIndex].period
      );
      restrictedFromDate.setHours(0, 0, 0, 0);
      const restrictedToDate = new Date(this.finToDateWithPo);
      restrictedToDate.setHours(0, 0, 0, 0);
      return date < restrictedFromDate || date > restrictedToDate;
    },
    finWithoutPoDisabledDates(date) {
      const restrictedFromDate = new Date(this.finFromDate);
      restrictedFromDate.setHours(0, 0, 0, 0);
      return date < restrictedFromDate;
    },
    finWithPoDisabledDates(date) {
      const restrictedFromDate = new Date(this.finFromDateWithPo);
      restrictedFromDate.setHours(0, 0, 0, 0);
      return date < restrictedFromDate;
    },
    createGrnInvoiceApproval() {
      const filterInvoiceDetails = this.invoiceLineData.map(elem => {
        return {
          child_trx_id: elem.vendor_inv_dtl_id,
          po_header_id: this.headerDetails.po_header_id,
          po_line_id: elem.po_line_id,
          po_line_location_id: elem.po_line_location_id,
          po_distribution_id: elem.po_distribution_id,
          rec_qty: elem.quantity,
          grn_dtl_id: elem.grn_dtl_id,
          trx_id_dtls: this.headerDetails.vendor_inv_id
        };
      });
      if (filterInvoiceDetails.length) {
        const payload = {
          inv_hdr_id: this.headerDetails.vendor_inv_id,
          ou_id: this.headerDetails.ou_id,
          po_header_id: this.headerDetails.po_header_id,
          vendor_id: this.headerDetails.vendor_id,
          vendor_site_id: this.headerDetails.vendor_site_id,
          invoice_number: this.headerDetails.inv_num,
          invoice_amount: this.headerDetails.inv_amt,
          invoice_date: this.headerDetails.inv_date,
          grn_hdr_id: 0,
          dtls: filterInvoiceDetails ? filterInvoiceDetails : null
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/createGrnInvoiceApproval', payload)
          .then(response => {
            this.loader = false;
            this.showAlert = true;
            if (response.status === 200) {
              this.editMode = false;
              this.isSuccess = true;
              this.responseMsg = response.data.message;
            } else {
              this.isSuccess = false;
              this.responseMsg = response.response.data.message;
            }
          })
          .catch(() => {
            this.loader = false;
            this.isSuccess = false;
            this.responseMsg = appStrings.autoFailedMsg;
          });
      }
    },
    truncateComment(souce, size) {
      return commonHelper.truncate(souce, size);
    },
    showHideGrnMappingModal(flag) {
      this.showGrnMappingModal = flag;
      if (flag) {
        this.getGrnReceiptMappingData();
      } else if (!flag && this.grnMapFlag) {
        this.setTimeVset = setTimeout(() => {
          const promt = confirm(
            'Would you like to approve without GRN Mapping.?'
          );
          if (promt) {
            this.showHideApproveModal(true);
          }
        }, 500);
      }
    },
    validateGrnMappingModal() {
      this.grnMapFlag = false;
      this.showHideGrnMappingModal(true);
    },
    getGrnReceiptMappingData() {
      const payload = {
        _page: this.currentPageGrnMapping - 1,
        _limit: this.perPageGrnMapping,
        po_num: this.headerDetails.po_num
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getGrnReceiptMappingData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.grnMappingData = response.data.data.data.page;
            this.totalRowsGrnMapping = response.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedGrnMapping(item) {
      this.showGrnMappingModal = false;
      this.getGrnReceiptDetailsData(item);
    },
    validateCurrency() {
      const payload = {
        legal_entity_id: this.headerDetails.erp_le_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/validateCurrencyExchangeRate', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const result = response.data.data.data;
            if (result) {
              if (result.CURRENCY_CODE == this.headerDetails.currency) {
                this.isCurrencyDisabled = true;
              } else {
                this.isCurrencyDisabled = false;
              }
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    dateValidation(invoiceLevel) {
      if (invoiceLevel === 'BUYER' || invoiceLevel === 'GRN') {
        if(this.headerDetails.adj_flag !== '2') { // 2.8 (Himanshu)
         this.isCurrentDateInRangeFunction(invoiceLevel);
        } else {
          this.checkGrnMappingValidation(invoiceLevel);
        }      
      } else {
        this.checkGrnMappingValidation(invoiceLevel);
      }
    },
    isCurrentDateInRangeFunction(invoiceLevel) {
      const filterInvoiceLineDetails = this.invoiceLineData.map(elem => {
        return {
          po_distribution_id: elem.po_distribution_id
        };
      });
      const payload = {
        po_header_id: this.headerDetails.po_header_id,
        po_line_data: filterInvoiceLineDetails
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/isCurrentDateInRange', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const result = response.data.data;
            if (result.length) {
              if (result[0].po_status === 'APPROVED') {
                const rejectAvail = result.filter(
                  data => data.receipt_days_exception_code === 'REJECT'
                );
                if (rejectAvail.length) {
                  const expectedEarlyDeliveryDate = rejectAvail
                    .filter(ele => {
                      if (ele.expected_early_delivery_date) {
                        return new Date(ele.expected_early_delivery_date);
                      }
                    })
                    .map(data => new Date(data.expected_early_delivery_date));
                  const expectedLateDeliveryDate = rejectAvail
                    .filter(ele => {
                      if (ele.expected_late_delivery_date) {
                        return new Date(ele.expected_late_delivery_date);
                      }
                    })
                    .map(data => new Date(data.expected_late_delivery_date));
                  if (
                    expectedEarlyDeliveryDate.length &&
                    expectedLateDeliveryDate.length
                  ) {
                    var currentDate = new Date();
                    var maxDate = new Date(
                      Math.max(...expectedEarlyDeliveryDate)
                    );
                    var minDate = new Date(
                      Math.min(...expectedLateDeliveryDate)
                    );
                    // return currentDate >= maxDate && currentDate <= minDate;
                    if (currentDate >= maxDate && currentDate <= minDate) {
                      this.checkGrnMappingValidation(invoiceLevel);
                    } else {
                      alert(
                        'Kindly, contact to the buyer for change the need date in the PO'
                      );
                    }
                  } else {
                    this.checkGrnMappingValidation(invoiceLevel);
                    // return true;
                  }
                } else {
                  this.checkGrnMappingValidation(invoiceLevel);
                  // return true;
                }
              } else {
                alert(`PO Status is: ${result[0].po_status}`);
              }
            }
          } else {
            alert(response.response.data.message);
          }
        })
        .catch(() => {
          this.loader = false;
          // alert(appStrings.autoFailedMsg);
        });
    },
    isCurrentDateInRange() {
      const rejectAvail = this.invoiceLineData.filter(
        data => data.receipt_days_exception_code === 'REJECT'
      );
      if (!rejectAvail.length) {
        return true;
      }
      const expectedEarlyDeliveryDates = rejectAvail
        .map(ele =>
          ele.expected_early_delivery_date
            ? new Date(ele.expected_early_delivery_date)
            : null
        )
        .filter(date => date);
      const expectedLateDeliveryDates = rejectAvail
        .map(ele =>
          ele.expected_late_delivery_date
            ? new Date(ele.expected_late_delivery_date)
            : null
        )
        .filter(date => date);
      if (
        !expectedEarlyDeliveryDates.length ||
        !expectedLateDeliveryDates.length
      ) {
        return true;
      }
      const currentDate = new Date();
      const maxDate = new Date(Math.max(...expectedEarlyDeliveryDates));
      const minDate = new Date(Math.min(...expectedLateDeliveryDates));
      return currentDate >= maxDate && currentDate <= minDate;
    },
    // isCurrentDateInRange() {
    //   const rejectAvail = this.invoiceLineData.filter(
    //     data => data.receipt_days_exception_code === 'REJECT'
    //   );
    //   if (rejectAvail.length) {
    //     const expectedEarlyDeliveryDate = rejectAvail
    //       .filter(ele => {
    //         if (ele.expected_early_delivery_date) {
    //           return new Date(ele.expected_early_delivery_date);
    //         }
    //       })
    //       .map(data => new Date(data.expected_early_delivery_date));
    //     const expectedLateDeliveryDate = rejectAvail
    //       .filter(ele => {
    //         if (ele.expected_late_delivery_date) {
    //           return new Date(ele.expected_late_delivery_date);
    //         }
    //       })
    //       .map(data => new Date(data.expected_late_delivery_date));
    //     if (
    //       expectedEarlyDeliveryDate.length &&
    //       expectedLateDeliveryDate.length
    //     ) {
    //       var currentDate = new Date();
    //       var maxDate = new Date(Math.max(...expectedEarlyDeliveryDate));
    //       var minDate = new Date(Math.min(...expectedLateDeliveryDate));
    //       return currentDate >= maxDate && currentDate <= minDate;
    //     } else {
    //       return true;
    //     }
    //   } else {
    //     return true;
    //   }
    // },
    checkGrnMappingValidation(invoiceLevel) {
      if (invoiceLevel === 'GRN') {
        if (this.headerDetails.receipt_num) {
          this.showHideApproveModal(true);
        } else {
          this.grnMapFlag = true;
          this.getGrnReceiptDataAvail();
        }
      } else {
        // if(this.advancesAppliedData.length<=1 && invoiceLevel === 'INVOICE') {
        //   alert('Advance apply is mandatory')
        // } else {
          this.showHideApproveModal(true);
        // }
      }
    },
    getGrnReceiptDataAvail() {
      const payload = {
        _page: 0,
        _limit: 1000,
        po_num: this.headerDetails.po_num
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getGrnReceiptMappingData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const result = response.data.data.data.page;
            if (result.length) {
              this.showHideGrnMappingModal(true);
              const final = result
                .filter(elem => elem.invoice_number)
                .map(data => data.invoice_number);
              const isGrnNumAvail = final.includes(this.headerDetails.inv_num);
              const grnMapIndex = final.indexOf(this.headerDetails.inv_num);
              if (isGrnNumAvail) {
                if (grnMapIndex > -1) {
                  this.getGrnReceiptDetailsData(
                    result[grnMapIndex],
                    'auto_map'
                  );
                }
              }
            } else {
              this.showHideApproveModal(true);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // New Function Starting

    getGrnReceiptDetailsData(item, type) {
      const payload = {
        _page: 0,
        _limit: 100,
        shipment_hdr_id: item.shipment_header_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getGrnReceiptDetailsData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const result = response.data.data.data.page;
            if (result) {
              if (result.length == this.invoiceLineData.length) {
                const allMismatchedParams = [];
                for (let i = 0; i < this.invoiceLineData.length; i++) {
                  const item1 = this.invoiceLineData[i];
                  const matchedItem2 = result.find(
                    item2 =>
                      item2.po_distribution_id === item1.po_distribution_id
                  );
                  if (!matchedItem2) {
                    alert(
                      `Error: No matching item found for PO Distribution ID: ${item1.po_distribution_id}.`
                    );
                    // return `Error: No matching item found for po_line_location_id ${item1.po_line_location_id} in array2.`;
                  }
                  const mismatchedParams = [];
                  if (item1.po_line_id !== matchedItem2.po_line_id) {
                    mismatchedParams.push('PO Line Id Not Matched');
                  }
                  if (item1.deliver_qty !== matchedItem2.grn_qty) {
                    mismatchedParams.push('Deliver Qty. Not Matched');
                  }
                  if (item1.po_price !== matchedItem2.unit_price) {
                    mismatchedParams.push('PO Price not matched');
                  }
                  if (item1.item_code !== matchedItem2.item_code) {
                    mismatchedParams.push('Item Code Not Matched');
                  }
                  if (item1.tax_amount !== matchedItem2.tax) {
                    mismatchedParams.push('TAX Amount Not Matched');
                  }
                  if (mismatchedParams.length > 0) {
                    allMismatchedParams.push(
                      `PO Line Location ID: ${
                        item1.po_line_location_id
                      }: ${mismatchedParams.join(', ')}`
                    );
                  }
                  // if (mismatchedParams.length > 0) {
                  //   const errorMsg = `Error: Parameters do not match for po_line_location_id ${
                  //     item1.po_line_location_id
                  //   }: ${mismatchedParams.join(', ')}.`;
                  //   alert(errorMsg);
                  // }
                }
                if (allMismatchedParams.length > 0) {
                  const defaultMsg =
                    'GRN Validation not applicable for following reason(s) :\n';
                  let errorMsg = '';
                  allMismatchedParams.forEach(item => {
                    errorMsg += item + '\n';
                  });
                  alert(defaultMsg + errorMsg);
                  // const errorMsg = `Error: Parameters do not match for the following items:\n${allMismatchedParams.join(
                  //   '\n'
                  // )}.`;
                  // alert(errorMsg);
                } else {
                  this.grnMappingForInvoiceApproval(result, type);
                }
              } else if (result.length !== this.invoiceLineData.length) {
                alert('Invoice Line(s) Not Matched with GRN');
              }
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // New Function Ending
    grnMappingForInvoiceApproval(result, type) {
      const lineDetails = result.map(elem => {
        return {
          po_line_id: elem.po_line_id,
          po_line_location_id: elem.po_line_location_id,
          shipment_line_id: elem.shipment_line_id,
          po_distribution_id: elem.po_distribution_id,
          deliver_qty: elem.grn_qty
        };
      });
      const payload = {
        vendor_inv_id: this.vendorInvId,
        receipt_num: result[0].receipt_num,
        auto_grn_flag: type === 'auto_map' ? true : false,
        shipment_hdr_id: result[0].shipment_hdr_id,
        vendor_invoice_dtls: lineDetails ? lineDetails : null
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/grnMappingForInvoiceApproval', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.getVendorInvoiceDetailsById();
            if (type === 'auto_map') {
              this.grnMapFlag = false;
              alert('Automatically GRN Map Successfully.');
              this.showHideGrnMappingModal(false);
              this.showHideApproveModal(true);
            }
            this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
          } else {
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    switchVariable() {
      this.allFlag = this.allFlag
        ? (this.allFlag = false)
        : this.allFlag == false
        ? (this.allFlag = true)
        : null;
      this.getHistory();
      const cardElement = document.getElementById('accordion-3');
      const isCardOpen = cardElement.classList.contains('show');
      if (!isCardOpen) {
        cardElement.__vue__.$root.$emit('bv::toggle::collapse', 'accordion-3');
      }
    },
    getHistory() {
      const payload = {
        eventId: this.workflowId.eventId,
        nfaHdrId: this.vendorInvId,
        approvalStatus: this.allFlag ? 'Y' : !this.allFlag ? 'N' : ''
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getApprovalList', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.approvalHistoryData = response.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getTotalTaxAmount() {
      const payload = {
        vendor_inv_id: this.vendorInvId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getTotalTaxAmount', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.taxableAmountWithoutCurrency =
              response.data.data.taxable_amount_sum;
              this.taxAmountWithoutCurrency = response.data.data.tax_amount_sum;
            this.totalTaxableAmt = commonHelper.formatAmountWithoutCurrency(
              response.data.data.taxable_amount_sum
            );
            this.totalCNAmount = commonHelper.formatAmountWithoutCurrency( // 1.8 (Himanshu)
              response.data.data.cn_taxable_sum
            );
            this.freightExcTax = commonHelper.formatAmountWithoutCurrency(
              response.data.data.taxable_amount_line_sum
            );
            this.taxExcFreight = commonHelper.formatAmountWithoutCurrency(
              response.data.data.tax_amount_sum
            );
            this.totalCNTax = commonHelper.formatAmountWithoutCurrency( // 1.8 (Himanshu)
              response.data.data.cn_tax_sum
            );
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openValueSetModal(vsetCode, index) {
      this.vsetCode = vsetCode;
      this.specLineIndex = index;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.EMP_ID_BY_GRP_ID) {
        this.selectedEmpEmail.push(item.value_code);
        if (!this.selectedEmpId.some(emp => emp.approver_id === +item.employee_id)) { // 2.7 (Himanshu)
          this.selectedEmpId.push({ approver_id: +item.employee_id });
        }
      } 
      // else if(this.vsetCode === appStrings.VALUESETTYPE.QC_STATUS){
      //     this.invoiceLineData[this.specLineIndex].qc_status = item.value_code
      //     this.invoiceLineData = JSON.parse(JSON.stringify(this.invoiceLineData))
      // }
    },
    removeTags(tags, tagsId, tag) {
      const index = tags.indexOf(tag);
      if (index !== -1) {
        tags.splice(index, 1);
        tagsId.splice(index, 1);
      }
    },
    adjustTagsWidth() {
      const tagsWidth = this.$refs.tags.$el.scrollWidth;
      this.$refs.tags.$el.style.width = `${tagsWidth}px`;
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    showHideApproveForwardModal(flag) {
      this.showApproveForwardModal = flag;
      if (!flag) {
        this.selectedEmp = { text: null, value: null };
        this.approvalReason = null;
        this.selectedEmpEmail = [];
        this.selectedEmpId = [];
      }
    },
    approveForwardInvoice() {
      if(this.headerDetails.manual_invoice &&
        this.headerDetails.invoice_level === 'BUYER') {
          const payload = {
            vendor_invoice_id: this.vendorInvId,
            invoice_type: this.headerDetails.manual_invoice ? 1 : 0,
            tag:'CC_VALIDATION_ALL'
          };
          this.loader = true;
          this.$store
            .dispatch('intWorkflow/checkSplitDataMismatched', payload)
            .then(response => {
              this.loader = false;
              if (response.status === 200) {
                if(response.data.data === 'F') {
                  alert('Invoice line amount and cost centre amount match failed');
                } else {
                  const uniqueApproverObjects = [ // 2.9 (Himanshu)
                    ...new Map(
                      this.selectedEmpId.map(e => [e.approver_id, e])
                    ).values()
                  ];
                  const payload = {
                    event_id: this.workflowId.eventId,
                    inprocess_hdr_id: this.wfHdrId,
                    inprocess_dtl_id: this.wfDtlId,
                    approver_ids: uniqueApproverObjects, // 2.9 (Himanshu)
                    notification_comments: this.approvalReason
                  };
                  this.loader = true;
                  this.$store
                    .dispatch('intWorkflow/approveForwardInvoice', payload)
                    .then(response => {
                      this.loader = false;
                      if (response.status === 200) {
                        alert('Approve and Forward Successfully');
                        this.getVendorInvoiceDetailsById();
                        this.showHideApproveForwardModal(false);
                        this.$emit('updateInvoice');
                      } else {
                        alert(response.response.data.message);
                      }
                    })
                    .catch(() => {
                      alert(appStrings.autoFailedMsg);
                    });
                }
              } else {
                alert(response.response.data.message);
              }
            })
            .catch(() => {
              alert(appStrings.autoFailedMsg);
            });
      } else {
        const payload = {
          event_id: this.workflowId.eventId,
          inprocess_hdr_id: this.wfHdrId,
          inprocess_dtl_id: this.wfDtlId,
          approver_ids: this.selectedEmpId,
          notification_comments: this.approvalReason
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/approveForwardInvoice', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              alert('Approve and Forward Successfully');
              this.getVendorInvoiceDetailsById();
              this.showHideApproveForwardModal(false);
              this.$emit('updateInvoice');
            } else {
              alert(response.response.data.message);
            }
          })
          .catch(() => {
            alert(appStrings.autoFailedMsg);
          });
      }
      
    },
    autoClickNextPage() {
      const nextPage = this.currentPage + 1;
      if (nextPage <= this.totalRows / this.previewPage) {
        this.currentPage = nextPage;
        this.getPageIndex(nextPage);
      }
    },
    autoClickPrevPage() {
      const prevPage = this.currentPage - 1;
      if (prevPage > 0) {
        this.currentPage = prevPage;
        this.getPageIndex(prevPage);
      }
    },
    handleKeyDown(event) {
      // if (
      //   event.keyCode == '17' ||
      //   event.keyCode == '91' ||
      //   event.keyCode == '92' ||
      //   event.keyCode == '16' ||
      //   event.keyCode == '83'
      // ) {
      //   event.preventDefault();
      //   alert('Not Allowed');
      // } else
      if (event.keyCode == '39') {
        this.autoClickNextPage();
      } else if (event.keyCode == '37') {
        this.autoClickPrevPage();
      }
    },
    getOpenKmAuthTokenUploadDocument(docDtlId, type, item) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (this.openKmAuth) {
              if (docDtlId) {
                this.deleteRow(docDtlId, this.openKmAuth);
              } else {
                if (item) {
                  this.invDtlAttach = type;
                  this.selectedReqDtls = item;
                  if (
                    (this.headerDetails.invoice_level === 'GRN' && this.headerDetails.approval_status_key === 'APPROVED') ||
                    this.headerDetails.invoice_level === 'INVOICE' ||
                    this.headerDetails.invoice_level === 'BUYER'
                  ) {
                    this.selectedReqDtls.hideDeleteBtn = true;
                  } else {
                    this.selectedReqDtls.hideDeleteBtn = false;
                  }
                }
                this.showHideHistory(true, 'uploadDocument');
              }
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    deleteRow(docDetailId, openKmAuth) {
      const payload = {
        docDetailId: docDetailId,
        token: openKmAuth
      };
      if (docDetailId !== 0) {
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/delteOpenKmDoc', payload)
          .then(response => {
            this.loader = false;
            this.showAlert = true;
            if (response.status === 200) {
              alert('Document Delete Successfully');
              this.editMode = false;
              this.isSuccess = true;
              this.respMessage = response.data.message;
              this.getUploadedDocDtl();
            } else {
              this.isSuccess = false;
              this.respMessage =
                response.response.data.message || 'Something went wrong';
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    onSelectOrgType(event) {
      const record = this.invoiceLineData.find(
        item => item.vendor_inv_dtl_id === event
      );
      if (record) {
        const promt = confirm('Are you sure, you want to change line?');
        if (promt) {
          this.newFunctionById(record);
        }
      } else {
        alert('Line Not Found');
      }
    },
    newFunctionById(record) {
      const payload = {
        vendor_invoice_dtl_id: record.vendor_inv_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getSplitLineDetailsById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            if (result.length) {
              this.splitData = result;
              this.repeatFunction(record);
            } else {
              this.splitData = [];
              this.repeatFunction(record);
            }
            if (
              this.headerDetails.manual_invoice &&
              this.headerDetails.invoice_level === 'INVOICE'
            ) {
              this.getSplitLineFinDetailsById();
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    repeatFunction(record) {
      this.splitLineData = record;
      this.splitLineData = JSON.parse(JSON.stringify(this.splitLineData));
      if (this.splitLineData.po_price !== null && this.splitLineData.po_price !== undefined) { // 2.8 (Himanshu)
        this.splitLineData.po_price = Number(this.splitLineData.po_price).toFixed(2);
      }
      this.splitLineData.taxable_amount = this.splitLineData.taxable_amount.toFixed(
        2
      );
      this.splitLineData.tax_amount = this.splitLineData.tax_amount.toFixed(2);
      const total = this.splitData
        .filter(ele => ele.amount)
        .map(data => data.amount);
      const totalAmount = commonHelper.calculateTotal(total).toFixed(2);
      if(this.headerDetails.adj_flag === '1') { // 2.8 (Himanshu)
      this.remainingAmount = this.splitLineData.cn_return_amt - totalAmount;
      } else {
      this.remainingAmount = this.splitLineData.taxable_amount - totalAmount;
      }     
      this.remainingAmount = this.remainingAmount.toFixed(2);
    },
    splitFunction(item, index) {
      if (this.headerDetails.invoice_level === 'BUYER') {
        this.updateInvoiceDetailsManual();
      } else if (this.headerDetails.invoice_level === 'INVOICE') {
        if (this.headerDetails.gl_date) {
          this.updateInvoiceDetailsManual();
        } else {
          alert('Please Enter GL Date');
        }
      }
      if (
        this.headerDetails.invoice_level === 'BUYER'
          ? this.operatingUnit.value &&
            this.headerDetails.remarks &&
            this.headerDetails.vendor_site_id
          : this.headerDetails.invoice_level === 'INVOICE'
          ? this.operatingUnit.value &&
            this.headerDetails.remarks &&
            this.headerDetails.vendor_site_id &&
            this.headerDetails.gl_date
          : this.headerDetails.invoice_level === null
      ) {
        this.splitLineData = item;
        this.splitLineData = JSON.parse(JSON.stringify(this.splitLineData));
        // this.splitLineData.po_price = this.splitLineData.po_price.toFixed(2); // 2.8 (Himanshu)
        if (this.splitLineData.po_price !== null && this.splitLineData.po_price !== undefined) {
          this.splitLineData.po_price = Number(this.splitLineData.po_price).toFixed(2);
        }
        this.splitLineData.taxable_amount = this.splitLineData.taxable_amount.toFixed(
          2
        );
        this.splitLineData.tax_amount = this.splitLineData.tax_amount.toFixed(
          2
        );
        this.remainingAmount = this.splitLineData.taxable_amount;
        this.splitData = [];
        this.splitFinData = [];
        if (item.period_from_date) {
          this.finFromDate = item.period_from_date;
        } else {
          this.finFromDate = null;
        }
        if (item.period_to_date) {
          this.finToDate = item.period_to_date;
        } else {
          this.finToDate = null;
        }
        this.lineNo = null;
        if (
          (this.headerDetails.invoice_level === 'BUYER' &&
            this.approvalStatusKey === 'APPROVED') ||
          this.headerDetails.invoice_level === null
        ) {
          this.splitFields = [
            { key: 'from_date' },
            { key: 'to_date' },
            { key: 'percent_distribution' },
            { key: 'amount' },
            { key: 'cost_centre' },
            { key: 'expense_month' },
            { key: 'concatenated_segments', label: 'Code Combination' }
          ];
        }
        if (this.headerDetails.invoice_level === 'INVOICE') {
          this.splitFields = [
            { key: 'from_date' },
            { key: 'to_date' },
            { key: 'percent_distribution' },
            { key: 'amount' },
            { key: 'cost_centre' },
            { key: 'expense_month' },
            { key: 'concatenated_segments', label: 'Code Combination' }
          ];
        }
        this.showHideSplitModal(true, index);
      }
    },
    defaultDateSetInvoice() {
      if (this.splitData.length) {
        const data = JSON.parse(JSON.stringify(this.splitData));
        const minDate = new Date(
          Math.min(...data.map(item => new Date(item.from_date)))
        );
        const maxDate = new Date(
          Math.max(...data.map(item => new Date(item.to_date)))
        );
        if (minDate && maxDate) {
          this.finFromDate = commonHelper.formattedDate(minDate);
          this.finToDate = commonHelper.formattedDate(maxDate);
        }
      }
    },
    showHideSplitModal(flag, index) {
      this.showSplitModal = flag;
      if (flag) {
        // 2.8 (Himanshu)
          let valueAndTextArr;
        if(this.headerDetails.adj_flag === '1') {
        valueAndTextArr = this.invoiceLineData.map(type => {
          return {
            value: type.vendor_inv_dtl_id,
            text: type.line_number
          };
        });
        } else {
        valueAndTextArr = this.invoiceLineData.map(type => {
          return {
            value: type.vendor_inv_dtl_id,
            text: type.manual_invoice_line_id
          };
        });
        }       
        this.poLineNums = valueAndTextArr;
        this.selectedLine = this.poLineNums[index].value;
        if (flag) {
          this.getSplitLineDetailsById();
          if (
            this.headerDetails.manual_invoice &&
            this.headerDetails.invoice_level === 'INVOICE'
          ) {
            this.getSplitLineFinDetailsById();
          }
        }
      }
      if (!flag) {
        this.getVendorInvoiceDetailsById();
      }
      // setTimeout(() => {
      //   this.defaultDateSetInvoice();
      // }, 500);
    },
    addSplitLines(lineNo, taxableAmount) {
      if (lineNo) {
        if (lineNo > 99) {
          alert('Line No cannot be greater than 99');
          this.lineNo = null;
        } else {
          if (!this.splitData.length) {
            const divideAmount = taxableAmount / lineNo;
            let totalAmount = 0;
            for (let i = 0; i < lineNo; i++) {
              this.splitData.push({
                amount: Number.isInteger(divideAmount)
                  ? divideAmount.toFixed(2)
                  : commonHelper.splitAmountDecimal(divideAmount, 2),
                cost_centre: null
              });
            }
            for (let i = 0; i < this.splitData.length - 1; i++) {
              totalAmount += +this.splitData[i].amount;
            }
            this.splitData[lineNo - 1].amount = parseFloat(
              this.splitLineData.taxable_amount - totalAmount
            ).toFixed(2);
            this.lineNo = null;
            if (this.headerDetails.period_name) {
              this.splitData.map(
                ele => (ele.expense_month = this.headerDetails.period_name)
              );
            }
          } else {
            const promt = confirm('Are you sure, you want to add new line(s)?');
            if (promt) {
              this.splitData = [];
              const divideAmount = taxableAmount / lineNo;
              let totalAmount = 0;
              for (let i = 0; i < lineNo; i++) {
                this.splitData.push({
                  amount: Number.isInteger(divideAmount)
                    ? divideAmount.toFixed(2)
                    : commonHelper.splitAmountDecimal(divideAmount, 2),
                  cost_centre: null
                });
              }
              for (let i = 0; i < this.splitData.length - 1; i++) {
                totalAmount += +this.splitData[i].amount;
              }
              this.splitData[lineNo - 1].amount = parseFloat(
                this.splitLineData.taxable_amount - totalAmount
              ).toFixed(2);
              this.lineNo = null;
              if (this.headerDetails.period_name) {
                this.splitData.map(
                  ele => (ele.expense_month = this.headerDetails.period_name)
                );
              }
            }
          }
          const filterAmt = this.splitData
            .filter(ele => ele.amount)
            .map(item => item.amount);
          if (filterAmt.length) {
            const totalFilterAmt =
              filterAmt.length > 1
                ? commonHelper.calculateTotal(filterAmt).toFixed(2)
                : parseFloat(filterAmt[0]).toFixed(2);
            this.remainingAmount =
              this.splitLineData.taxable_amount - totalFilterAmt;
            this.remainingAmount = parseFloat(this.remainingAmount).toFixed(2);
          }
        }
      }
    },
    isRemainingAmtAvail() {
      if (this.remainingAmount == 0) {
        this.addEditSplitLineData();
      } else {
        alert('Remaining Amount Should be 0');
      }
    },
    isRemainingAmtAvailFin() {
      if (this.remainingFinAmt == 0) {
        this.addEditSplitLineFinData();
      } else {
        alert('Remaining Amount Should be 0');
      }
    },
    isRemainingAmtAvailWithPo() {
      if (this.remainingAmtWithPo == 0) {
        this.addEditSplitLineWithPo();
      } else {
        alert('Remaining Amount Should be 0');
      }
    },
    isRemainingAmtAvailFinWithPo() {
      if (this.remainingFinAmtWithPo == 0) {
        this.addEditSplitLineFinWithPo();
      } else {
        alert('Remaining Amount Should be 0');
      }
    },
    addEditSplitLineFinWithPo() {
      const filterData = this.splitFinDataWithPo.filter(
        ele =>
          !ele.code_combination || !ele.period || !ele.period_to || !ele.days
      );
      if (filterData.length) {
        alert('Please Enter Mandatory Fields.');
      } else {
        const splitFinWithPoDetails = this.splitFinDataWithPo.map(elem => {
          return {
            inv_distribution_dtl_id: elem.inv_distribution_dtl_id
              ? elem.inv_distribution_dtl_id
              : 0,
            oracle_line_description: elem.oracle_line_description,
            period_from: elem.period,
            period_to: elem.period_to,
            days: elem.days,
            distribution_amount: elem.amount,
            expense_month: elem.expense_month,
            code_combination: elem.code_combination,
            override_flag: elem.override_flag ? elem.override_flag : false
          };
        });
        const payload = {
          vendor_invoice_dtl_id: this.splitLineDataWithPo.vendor_inv_dtl_id,
          distribution_dtls: splitFinWithPoDetails
            ? splitFinWithPoDetails
            : null
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/addEditSplitLineFinWithPo', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              this.getSplitLineFinWithPoDetailsById();
              alert(response.data.message);
            } else {
              alert(response.response.data.message);
            }
          })
          .catch(() => {
            this.loader = false;
            alert(appStrings.autoFailedMsg);
          });
      }
    },
    getSplitLineFinWithPoDetailsById() {
      const payload = {
        vendor_invoice_dtl_id: this.splitLineDataWithPo.vendor_inv_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getSplitLineFinWithPoDetailsById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.splitFinDataWithPo = result.map(ele => {
              ele.amount = ele.distribution_amount;
              ele.period = ele.period_from;
              return ele;
            });
            if (this.splitFinDataWithPo.length) {
              const data = JSON.parse(JSON.stringify(this.splitFinDataWithPo));
              const minDate = new Date(
                Math.min(...data.map(item => new Date(item.period)))
              );
              const maxDate = new Date(
                Math.max(...data.map(item => new Date(item.period_to)))
              );
              if (minDate && maxDate) {
                this.finFromDateWithPo = commonHelper.formattedDate(minDate);
                this.finToDateWithPo = commonHelper.formattedDate(maxDate);
              }
              const total = this.splitFinDataWithPo
                .filter(ele => ele.amount)
                .map(data => data.amount);
              const totalAmount = commonHelper.calculateTotal(total).toFixed(2);
              this.remainingFinAmtWithPo =
                this.splitLineDataWithPo.taxable_amount - totalAmount;
              this.remainingFinAmtWithPo = this.remainingFinAmtWithPo.toFixed(
                2
              );
            } else {
              this.remainingFinAmtWithPo =
                this.splitLineDataWithPo.taxable_amount - 0;
              this.remainingFinAmtWithPo = this.remainingFinAmtWithPo.toFixed(
                2
              );
            }
            this.isDateDisabledFinWithPo();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    addEditSplitLineWithPo() {
      const filterData = this.splitWithPoData.filter(ele => ele.amount == null);
      if (filterData.length) {
        alert('Please Enter Distribution Amount');
      } else {
        const splitFinDetails = this.splitWithPoData.map(elem => {
          return {
            inv_distribution_dtl_id: elem.inv_distribution_dtl_id
              ? elem.inv_distribution_dtl_id
              : 0,
            period_from: elem.period,
            period_to: elem.period_to,
            days: elem.days,
            distribution_amount: elem.amount,
            expense_month: elem.expense_month
            // code_combination: elem.code_combination
          };
        });
        const payload = {
          vendor_invoice_dtl_id: this.splitLineDataWithPo.vendor_inv_dtl_id,
          distribution_dtls: splitFinDetails ? splitFinDetails : null
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/addEditSplitLineWithPo', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              this.getSplitLineWithPoById();
              this.splitPeriodFromDate = null;
              this.splitPeriodToDate = null;
              alert(response.data.message);
            } else {
              alert(response.response.data.message);
            }
          })
          .catch(() => {
            this.loader = false;
            alert(appStrings.autoFailedMsg);
          });
      }
    },
    addEditSplitLineData(flag) {
      const filterData = this.splitData.filter(
        ele =>
          !ele.cost_centre ||
          !ele.expense_month ||
          !ele.from_date ||
          !ele.to_date
      );
      if (filterData.length) {
        alert('Please Enter Mandatory Fields.');
      } else {
        const splitDetails = this.splitData.map(elem => {
          return {
            inv_cost_centre_id: elem.inv_cost_centre_id
              ? elem.inv_cost_centre_id
              : 0,
            amount: elem.amount,
            expense_month: elem.expense_month,
            cost_centre: elem.cost_centre,
            state_code: elem.state_code,
            from_date:
              this.headerDetails.invoice_level === 'BUYER'
                ? elem.from_date
                : this.finFromDate,
            to_date:
              this.headerDetails.invoice_level === 'BUYER'
                ? elem.to_date
                : this.finToDate,
            concatenated_segments: elem.concatenated_segments,
            distribution_set_id: elem.distribution_set_id,
            percent_distribution: elem.percent_distribution
          };
        });
        const payload = {
          vendor_invoice_dtl_id: this.splitLineData.vendor_inv_dtl_id,
          split_dtls: splitDetails ? splitDetails : null
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/addEditSplitLineData', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              this.getSplitLineDetailsById();
              if (!flag) {
                alert(response.data.message);
              }
            } else {
              alert(response.response.data.message);
            }
          })
          .catch(() => {
            this.loader = false;
            alert(appStrings.autoFailedMsg);
          });
      }
    },
    getSplitLineDetailsById() {
      const payload = {
        vendor_invoice_dtl_id: this.splitLineData.vendor_inv_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getSplitLineDetailsById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            if (result.length) {
              this.splitData = result;
              const total = this.splitData
                .filter(ele => ele.amount)
                .map(data => data.amount);
              const totalAmount = commonHelper.calculateTotal(total).toFixed(2);
              this.remainingAmount =
                this.splitLineData.taxable_amount - totalAmount;
              this.remainingAmount = this.remainingAmount.toFixed(2);
            } else {
              this.splitData = [];
              this.distribution = { text: null, value: null };
              this.expenseMonth = null;
              this.remainingAmount = this.splitLineData.taxable_amount;
              this.remainingAmount = this.remainingAmount.toFixed(2);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        })
        .finally(() => {
          this.isDistributionDetailsSaved();
        });
    },
    addEditSplitLineFinData() {
      const filterData = this.splitFinData.filter(
        ele => ele.amount == null || !ele.code_combination
      );
      if (filterData.length) {
        alert('Please Enter Distribution Amount and Code Combination');
      } else {
        const splitFinDetails = this.splitFinData.map(elem => {
          return {
            inv_distribution_dtl_id: elem.inv_distribution_dtl_id
              ? elem.inv_distribution_dtl_id
              : 0,
            oracle_line_description: elem.oracle_line_description,
            period_from: elem.period,
            period_to: elem.period_to,
            cost_centre_amount: elem.unit_price,
            days: elem.days,
            distribution_amount: elem.amount,
            cost_centre: elem.cost_centre,
            expense_month: elem.expense_month,
            code_combination: elem.code_combination,
            flex_json: elem.code_combination_value
          };
        });
        const payload = {
          vendor_invoice_dtl_id: this.splitLineData.vendor_inv_dtl_id,
          distribution_dtls: splitFinDetails ? splitFinDetails : null
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/addEditSplitLineFinData', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              if (this.finFromDate && this.finToDate) {
                this.addEditSplitLineData(true);
              }
              this.getSplitLineFinDetailsById();
              if(this.headerDetails.ajd_flag !== '1') { // 2.8 (Himanshu)
              this.finFromDate = null;
              this.finToDate = null;
              }              
              alert(response.data.message);
            } else {
              alert(response.response.data.message);
            }
          })
          .catch(() => {
            this.loader = false;
            alert(appStrings.autoFailedMsg);
          });
      }
    },
    getSplitLineFinDetailsById() {
      const payload = {
        vendor_invoice_dtl_id: this.splitLineData.vendor_inv_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getSplitLineFinDetailsById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.splitFinData = result.map(ele => {
              ele.unit_price = ele.cost_centre_amount;
              ele.amount = ele.distribution_amount;
              ele.period = ele.period_from;
              ele.code_combination_value = JSON.parse(ele.flex_json);
              return ele;
            });
            if (this.splitFinData.length) {
              const total = this.splitFinData
                .filter(ele => ele.amount)
                .map(data => data.amount);
              const totalAmount = commonHelper.calculateTotal(total).toFixed(2);
              if(this.headerDetails.adj_flag === '1') { // 2.8 (Himanshu)
                this.remainingFinAmt =
                this.splitLineData.cn_return_amt - totalAmount;
              } else {
                this.remainingFinAmt =
                this.splitLineData.taxable_amount - totalAmount;
              }
              
              this.remainingFinAmt = this.remainingFinAmt.toFixed(2);
            } else { // 2.8 (Himanshu)
              if(this.headerDetails.adj_flag === '1') {
                this.remainingFinAmt = this.splitLineData.cn_return_amt - 0;
              } else {
              this.remainingFinAmt = this.splitLineData.taxable_amount - 0;
              }              
              this.remainingFinAmt = this.remainingFinAmt.toFixed(2);
            }
            this.isDateDisabled();
            if(this.headerDetails.adj_flag !== '1') { // 2.8 (Himanshu)
             setTimeout(() => {
              this.defaultDateSetInvoice();
            }, 500);
            } else { // 2.8 (Himanshu)
              setTimeout(() => {
              this.defaultDateSetCreditNote();
            }, 500);
            }
            
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    addNewRow() {
      if (this.approvalStatusKey !== 'APPROVED')
        if (this.remainingAmount == 0) {
          alert('Remaining Amount Not Available');
        } else {
          this.splitData.push({
            amount: null,
            cost_centre: null,
            expense_month: null,
            from_date: null,
            to_date: null,
            state_code: null,
            concatenated_segments: null,
            distribution_set_id: null
          });
        }
    },
    removeRow(index, item) {
      this.splitData.splice(index, 1);
      this.calculateAmount(item);
    },
    calculateAmount(item) {
      const totalLineAmount = this.splitData
        .filter(ele => ele.amount)
        .map(data => data.amount);
      if (totalLineAmount.length) {
        const finalAmount =
          totalLineAmount.length > 1
            ? commonHelper.calculateTotal(totalLineAmount).toFixed(2)
            : parseFloat(totalLineAmount[0]).toFixed(2);
        if (finalAmount > +this.splitLineData.taxable_amount) {
          alert('Amount cannot be greater than Remaining Amount');
          item.amount = null;
          this.calculateAmount(item);
        } else {
          this.remainingAmount =
            +this.splitLineData.taxable_amount - finalAmount;
          this.remainingAmount = this.remainingAmount.toFixed(2);
        }
      } else {
        this.remainingAmount = this.splitLineData.taxable_amount;
      }
    },
    calculateAmountFinance(item) {
      const totalLineAmount = this.splitFinData
        .filter(ele => ele.amount)
        .map(data => data.amount);
      if (totalLineAmount.length) {
        const finalAmount =
          totalLineAmount.length > 1
            ? commonHelper.calculateTotal(totalLineAmount).toFixed(2)
            : parseFloat(totalLineAmount[0]).toFixed(2);
        if (finalAmount > +this.splitLineData.taxable_amount) {
          alert('Amount cannot be greater than Remaining Amount');
          item.amount = null;
          this.calculateAmountFinance(item);
        } else { // 2.8 (Himanshu)
          if(this.headerDetails.adj_flag === '1') {
            this.remainingFinAmt =
            +this.splitLineData.cn_return_amt - finalAmount;
          } else {
            this.remainingFinAmt =
            +this.splitLineData.taxable_amount - finalAmount;
          }
          
          this.remainingFinAmt = this.remainingFinAmt.toFixed(2);
        }
      } else {
        this.remainingFinAmt = this.splitLineData.taxable_amount;
      }
    },
    calculateAmountFinanceWithPo(item) {
      const totalLineAmount = this.splitFinDataWithPo
        .filter(ele => ele.amount)
        .map(data => data.amount);
      if (totalLineAmount.length) {
        const finalAmount =
          totalLineAmount.length > 1
            ? commonHelper.calculateTotal(totalLineAmount).toFixed(2)
            : parseFloat(totalLineAmount[0]).toFixed(2);
        if (finalAmount > +this.splitLineDataWithPo.taxable_amount) {
          alert('Amount cannot be greater than Remaining Amount');
          item.amount = null;
          this.calculateAmountFinanceWithPo(item);
        } else {
          this.remainingFinAmtWithPo =
            +this.splitLineDataWithPo.taxable_amount - finalAmount;
          this.remainingFinAmtWithPo = this.remainingFinAmtWithPo.toFixed(2);
        }
      } else {
        this.remainingFinAmtWithPo = this.splitLineDataWithPo.taxable_amount;
      }
    },
    showHideCostCentreModal(flag, index) {
      this.specIndex = index;
      this.showCostCentreModal = flag;
      if (flag) {
        this.getCostCentreDetails();
      }
    },
    getCostCentreDetails() {
      const payload = {
        _page: this.currentPageCostCentre - 1,
        _limit: this.perPageCostCentre,
        org_id: this.operatingUnit.value,
        company_state_code: this.headerDetails.state_code,
        cost_centre: this.costCentreSearch
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getCostCentreDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.costCentreData = result;
            this.totalRowsCostCentre = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedCostCentre(item) {
      this.splitData[this.specIndex].cost_centre = item.cost_centre;
      this.splitData[this.specIndex].state_code = item.state_code;
      this.perPageCostCentre = commonHelper.perPageRecord;
      this.totalRowsCostCentre = null;
      this.currentPageCostCentre = 1;
      this.showCostCentreModal = false;
    },
    periodToWithPo(item) {
      if (new Date(item.period_to) > new Date(this.finToDateWithPo)) {
        item.period_to = null;
        alert('Period To Date cannot greater than To Date');
      }
      if (item.period && item.period_to) {
        const totalDays = this.getTotalDays(item.period_to, item.period);
        item.days = totalDays;
      }
    },
    periodWithPo(item) {
      item.period_to = null;
      item.days = null;
    },
    isOverrideChange(item, flag, index) {
      if (flag) {
        item.createdIndex = index;
        this.copyArrItems.push(item);
        this.deepCopy = JSON.parse(JSON.stringify(this.copyArrItems));
      } else {
        this.copyArrItems = this.copyArrItems.filter(obj => obj !== item);
        const filterCopyItem = this.deepCopy.find(
          copyItem => copyItem.createdIndex === index
        );
        if (filterCopyItem) {
          filterCopyItem.override_flag = false;
          this.splitFinDataWithPo[index] = { ...filterCopyItem };
          this.splitFinDataWithPo = [...this.splitFinDataWithPo];
        }
      }
    },
    // isOverrideChange(item, flag, index) {
    //   if (flag) {
    //     item.createdIndex = index;
    //     this.copyArrItems.push(item);
    //     this.deepCopy = JSON.parse(JSON.stringify(this.copyArrItems));
    //   } else if (!flag) {
    //     this.copyArrItems = this.copyArrItems.filter(obj => obj !== item);
    //     const filterCopyItem = this.deepCopy.filter(item => {
    //       if (item.createdIndex == index) {
    //         return item;
    //       }
    //     });
    //     filterCopyItem[0].override_flag = false;
    //     this.splitFinDataWithPo[index] = filterCopyItem[0];
    //     this.splitFinDataWithPo = JSON.parse(
    //       JSON.stringify(this.splitFinDataWithPo)
    //     );
    //   }
    // },
    compareDate(periodFromDate, glDate) {
      const temp_period_date =
        new Date(periodFromDate).getMonth() +
        1 +
        '-' +
        new Date(periodFromDate).getFullYear();
      const temp_gl_date =
        new Date(glDate).getMonth() + 1 + '-' + new Date(glDate).getFullYear();
      const parseDate = dateString => {
        const [month, year] = dateString.split('-');
        return new Date(year, month - 1);
      };
      const period_date = parseDate(temp_period_date);
      const gl_date = parseDate(temp_gl_date);
      if (period_date <= gl_date) {
        return (
          periodFromDate.split('-')[1].toUpperCase() +
          '-' +
          periodFromDate
            .split('-')[2]
            .toString()
            .slice(2)
        );
      } else {
        return 'PREPAID';
      }
    },
    calculateDateFunction() {
      if (this.finFromDate && this.finToDate) {
        this.splitFinData = [];
        const periodTotalDays = this.getCustomDays(
          this.finToDate,
          this.finFromDate
        );
        const totalDays = this.getTotalDays(this.finToDate, this.finFromDate);
        for (let i = 0; i < this.splitData.length; i++) {
          for (let j = 0; j < periodTotalDays.length; j++) {
            const currentDate = new Date(this.headerDetails.gl_date);
            const calAmt =
              (this.splitData[i].amount * periodTotalDays[j]) / totalDays;
            this.splitFinData.push({
              oracle_line_description:
                (this.splitLineData.item_description
                  ? this.splitLineData.item_description
                  : '') +
                ' | ' +
                (this.headerDetails.remarks ? this.headerDetails.remarks : '') +
                ' | ' +
                (this.splitData[i].expense_month
                  ? this.splitData[i].expense_month
                  : '') +
                ' | ' +
                (this.periodFromDates[j] ? this.periodFromDates[j] : '') +
                ' | ' +
                (this.periodToDates[j]
                  ? format(this.periodToDates[j], 'dd-MMM-yyyy')
                  : ''),
              period: this.periodFromDates[j]
                ? this.periodFromDates[j]
                : 'PREPAID',
              period_to: this.periodToDates[j]
                ? format(this.periodToDates[j], 'dd-MMM-yyyy')
                : null,
              unit_price: this.splitData[i].amount,
              days: periodTotalDays[j],
              amount: calAmt.toFixed(2),
              cost_centre: this.splitData[i].cost_centre,
              // expense_month: this.compareDate(
              //   this.periodFromDates[j],
              //   this.headerDetails.gl_date
              // ),
              expense_month:
                // new Date(this.periodFromDates[j]).getMonth() + 1 <=
                // new Date(this.headerDetails.gl_date).getMonth() + 1
                new Date(this.periodFromDates[j]) <=
                new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth() + 1,
                  0
                )
                  ? this.periodFromDates[j].split('-')[1].toUpperCase() +
                    '-' +
                    this.periodFromDates[j]
                      .split('-')[2]
                      .toString()
                      .slice(2)
                  : 'PREPAID',
              // expense_month: this.periodFromDates[j]
              //   ? this.periodFromDates[j].split('-')[1].toUpperCase() +
              //     '-' +
              //     this.periodFromDates[j]
              //       .split('-')[2]
              //       .toString()
              //       .slice(2)
              //   : 'PREPAID',
              code_combination: this.splitData[i].concatenated_segments,
              new_key:
                new Date(this.finToDate) <=
                new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth() + 1,
                  0
                )
                  ? this.finToDate.split('-')[1].toUpperCase() +
                      '-' +
                      this.finToDate.split('-')[2] ==
                    this.periodFromDates[j].split('-')[1].toUpperCase() +
                      '-' +
                      this.periodFromDates[j].split('-')[2]
                    ? 'POSTPAID'
                    : null
                  : null
              // expense_month: this.splitData[i].expense_month
            });
          }
        }
        const finArrCopy = JSON.parse(JSON.stringify(this.splitFinData));
        let result = [];
        // while (finArrCopy.length > 0) {
        // for (let i = 0; i < finArrCopy.length; i++)
        for (let i = finArrCopy.length; i > 0; i--) {
          const findIndex = finArrCopy.findIndex(
            ele => ele.expense_month === 'PREPAID'
          );
          const findIndexPostpaid = finArrCopy.findIndex(
            ele => ele.new_key === 'POSTPAID'
          );
          if (findIndex !== -1) {
            let prepaidExpenses = finArrCopy.splice(0, findIndex + 1);
            result.push(prepaidExpenses);
            for (let i = 0; i < result.length; i++) {
              let sum = 0;
              result[i].filter(ele => {
                if (ele.expense_month !== 'PREPAID') {
                  sum += parseFloat(ele.amount);
                }
              });
              result[i].filter(data => {
                if (data.expense_month === 'PREPAID') {
                  data.amount = data.unit_price - sum;
                  data.amount = data.amount.toFixed(2);
                }
              });
            }
          } else {
            let postpaidExpenses = finArrCopy.splice(0, findIndexPostpaid + 1);
            result.push(postpaidExpenses);
            for (let i = 0; i < result.length; i++) {
              let sum = 0;
              result[i].filter(ele => {
                if (ele.new_key !== 'POSTPAID') {
                  sum += parseFloat(ele.amount);
                }
              });
              result[i].filter(data => {
                if (data.new_key === 'POSTPAID') {
                  data.amount = this.splitData[i].amount - sum;
                  data.amount = data.amount.toFixed(2);
                }
              });
            }
          }
          let tempArr = [];
          for (let i = 0; i < result.length; i++) {
            result[i].forEach(ele => {
              tempArr.push(ele);
            });
          }
          if (findIndex !== -1) {
            this.splitFinData = tempArr;
          } else if (findIndexPostpaid !== -1) {
            this.splitFinData = tempArr;
          }
        }
        const filterAmt = this.splitFinData
          .filter(ele => ele.amount)
          .map(item => item.amount);
        if (filterAmt.length) {
          const totalFilterAmt =
            filterAmt.length > 1
              ? commonHelper.calculateTotal(filterAmt).toFixed(2)
              : parseFloat(filterAmt[0]).toFixed(2);
              if(this.headerDetails.adj_flag === '1') { // 2.8 (Himanshu)
              this.remainingFinAmt =
            this.splitLineData.cn_return_amt - totalFilterAmt;
              } else {
             this.remainingFinAmt =
            this.splitLineData.taxable_amount - totalFilterAmt;
              }
          
          this.remainingFinAmt = parseFloat(this.remainingFinAmt).toFixed(2);
        }
      } else {
        if (this.finFromDate == null && this.finToDate == null) {
          const tempArr = this.splitData.map(item => ({
            oracle_line_description:
              (this.splitLineData.item_description
                ? this.splitLineData.item_description
                : '') +
              ' | ' +
              (this.headerDetails.remarks ? this.headerDetails.remarks : '') +
              ' | ' +
              (item.expense_month ? item.expense_month : '') +
              ' | ' +
              (item.from_date ? item.from_date : '') +
              ' | ' +
              (item.to_date ? item.to_date : ''),
            period: item.from_date,
            period_to: item.to_date,
            days: this.getTotalDays(item.to_date, item.from_date),
            unit_price: item.amount,
            amount: item.amount,
            cost_centre: item.cost_centre,
            expense_month: item.expense_month,
            code_combination: item.concatenated_segments
          }));
          this.splitFinData = tempArr;
          const filterAmt = this.splitFinData
            .filter(ele => ele.amount)
            .map(item => item.amount);
          if (filterAmt.length) {
            const totalFilterAmt =
              filterAmt.length > 1
                ? commonHelper.calculateTotal(filterAmt).toFixed(2)
                : parseFloat(filterAmt[0]).toFixed(2);
                if(this.headerDetails.adj_flag === '1') { // 2.8 (Himanshu)
              this.remainingFinAmt =
              this.splitLineData.cn_return_amt - totalFilterAmt;
                } else {
              this.remainingFinAmt =
              this.splitLineData.taxable_amount - totalFilterAmt;
                }
            
            this.remainingFinAmt = parseFloat(this.remainingFinAmt).toFixed(2);
          }
        } else {
          alert('Kindly Enter From Date and To Date');
        }
      }
    },
    dateClearFunction() {
      this.finToDate = null;
      this.splitFinData = [];
    },
    getTotalDays(toDate, fromDate) {
      const { differenceInCalendarDays } = require('date-fns');
      const totalDays =
        differenceInCalendarDays(new Date(toDate), new Date(fromDate)) + 1;
      return totalDays;
    },
    getCustomDays(toDate, fromDate) {
      const {
        getDaysInMonth,
        addMonths,
        startOfMonth,
        differenceInDays,
        endOfMonth
      } = require('date-fns');
      // const currentDate = new Date();
      const currentDate = new Date(this.headerDetails.gl_date);
      let startDate = startOfMonth(new Date(fromDate));
      let endDate = new Date(toDate);
      let periodTotalDays = [];
      let periodFromDates = [];
      let periodToDates = [];
      while (startDate <= endDate) {
        const daysInMonth = Math.min(
          getDaysInMonth(startDate),
          differenceInDays(endDate, startDate) + 1
        );
        if (startDate <= currentDate) {
          periodFromDates.push(format(startDate, 'dd-MMM-yyyy'));
          periodToDates.push(endOfMonth(new Date(startDate)));
          periodTotalDays.push(daysInMonth);
        } else {
          periodTotalDays.push(differenceInDays(endDate, startDate) + 1);
          break;
        }
        startDate = addMonths(startDate, 1);
      }
      periodFromDates[0] = commonHelper.formattedDate(fromDate); // new added
      periodFromDates.push(commonHelper.formattedDate(startDate)); // new added
      // if (
      //   new Date(toDate).getMonth() + 1 >
      //   new Date(currentDate).getMonth() + 1
      // )
      if (new Date(toDate) > new Date(currentDate)) {
        periodToDates.push(new Date(toDate)); // new added
      } else {
        periodToDates[periodToDates.length - 1] = new Date(toDate); // new added
      }
      const newTempDate = fromDate.split('-');
      periodTotalDays[0] = periodTotalDays[0] - newTempDate[0] + 1;
      this.periodFromDates = periodFromDates;
      this.periodToDates = periodToDates;
      return periodTotalDays;
    },
    getOperatingUnitDetails() {
      const payload = {
        le_id: this.headerDetails.erp_le_id,
        ou_name: this.operatingUnitSearch
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getOperatingUnitDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data;
            this.operatingUnitData = result;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedOperatingUnit(item) {
      this.operatingUnit.text = item.ou_name;
      this.operatingUnit.value = item.ou_id;
      this.headerDetails.vendor_site_id = null;
      this.headerDetails.vendor_site_name = null;
      // this.getAdvanceData(); // 3.1 (Himanshu)
      this.showInvoiceCommonModal = false;
    },
    isGrnMapped(invoiceLevel) {
      const grnAlreadyMappedMessage =
        'GRN already mapped for this Invoice. Kindly do the RTV or Correction in Oracle';
      if (invoiceLevel === 'GRN' && this.headerDetails.receipt_num) {
        alert(grnAlreadyMappedMessage);
        return;
      }
      this.showHideRejectModal(true);
    },
    // isGrnMapped(invoiceLevel) {
    //   if (invoiceLevel === 'GRN') {
    //     if (this.headerDetails.receipt_num) {
    //       alert(
    //         'GRN already mapped for this Invoice. Kindly do the RTV or Correction in Oracle'
    //       );
    //     } else {
    //       this.showHideRejectModal(true);
    //     }
    //   } else {
    //     this.showHideRejectModal(true);
    //   }
    // },
    openDocumentNewTab(docDtlId, fileName, authToken) {
      this.fileExtension = commonHelper.getFileExtension(fileName);
      if (this.fileExtension === 'xlsx') {
        alert('Not Allowed');
      } else {
        const payload = {
          docDetailId: docDtlId,
          token: authToken,
          fileExtension: this.fileExtension
        };
        this.loader = true;
        commonHelper.previewImgDocParty(payload);
        this.loader = false;
      }
    },
    validateVendorSite() {
      if (this.operatingUnit.value) {
        this.showHideInvoiceCommonModal(true, 'vendor_site', null, 'header');
      } else {
        alert('Please Enter Operating Unit');
      }
    },
    getVendorSiteDetails() {
      const payload = {
        _page: this.currentPageVendorSite - 1,
        _limit: this.perPageVendorSite,
        vendor_site_name: this.vendorSiteSearch,
        vendor_id: this.headerDetails.vendor_id,
        org_id: this.operatingUnit.value,
        invoice_date: this.headerDetails.inv_date,
        registration_number: this.headerDetails.third_party_gstn
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getVendorSiteDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.vendorSiteData = result;
            this.totalRowsVendorSite = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedVendorSite(item) {
      this.headerDetails.vendor_site_id = item.vendor_site_id;
      this.headerDetails.vendor_site_name = item.vendor_site_name;
      this.perPageVendorSite = commonHelper.perPageRecord;
      this.totalRowsVendorSite = null;
      this.currentPageVendorSite = 1;
      this.showInvoiceCommonModal = false;
      // this.getAdvanceData();
    },
    endDateIndex(index) {
      this.specIndex = index;
      this.splitData = JSON.parse(JSON.stringify(this.splitData));
    },
    disabledDates(date) {
      return commonHelper.disabledDates(
        date,
        this.splitData[this.specIndex].from_date
      );
    },
    showHideUploadExcel(flag, type) {
      if (
        this.headerDetails.remarks &&
        this.operatingUnit.text &&
        this.headerDetails.vendor_site_id
      ) {
        this.downloadType = type;
        this.showUploadExcel = flag;
        setTimeout(() => {
          this.updateInvoiceDetailsManual();
        }, 0);
      } else {
        alert('Kindly enter mandatory fields.');
      }
    },
    removeCostCentreLine(item) {
      const payload = {
        cost_centre_id: item.inv_cost_centre_id,
        vendor_inv_dtl_id: item.vendor_invoice_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/removeCostCentreLine', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            alert('Cost Centre Line Delete Successfully.');
            this.getSplitLineDetailsById();
          } else {
            alert('Something went wrong.');
          }
        })
        .catch(() => {
          this.loader = false;
          alert(appStrings.autoFailedMsg);
        });
    },
    showHideLineDescriptionModal(flag, line_description, index) {
      this.specIndex = index
      this.showLineDescriptionModal = flag;
      if (line_description && line_description.length > 240) {
        this.lineDescription = line_description.substring(0, 240);
      } else {
        this.lineDescription = line_description;
      }
      // this.specIndex = index;
    },
    saveLineDescription() {
      this.splitFinData[
        this.specIndex
      ].oracle_line_description = this.lineDescription;
      this.showLineDescriptionModal = false;
    },
    showHideSplitModalWithPo(flag) {
      this.showSplitModalWithPo = flag;
      if (!flag) {
        this.copyArrItems = [];
      }
    },
    newSplitFunction(item) {
      this.splitLineDataWithPo = item;
      this.splitLineDataWithPo.taxable_amount = parseFloat(
        this.splitLineDataWithPo.taxable_amount
      ).toFixed(2);
      this.showHideSplitModalWithPo(true);
      if (this.headerDetails.invoice_level === 'GRN') {
        this.getSplitLineWithPoById();
        setTimeout(() => {
          if (this.splitWithPoData.length < 1) {
            this.splitPeriodFromDate = item.period_from_date;
            this.splitPeriodToDate = item.period_to_date;
          }
        }, 500);
      }
      if (this.headerDetails.invoice_level === 'INVOICE') {
        this.getSplitLineWithPoById();
        this.getSplitLineFinWithPoDetailsById();
        setTimeout(() => {
          if (this.splitFinDataWithPo.length < 1) {
            this.finFromDateWithPo = item.period_from_date;
            this.finToDateWithPo = item.period_to_date;
          }
        }, 500);
      }
    },
    getSplitLineWithPoById() {
      const payload = {
        vendor_invoice_dtl_id: this.splitLineDataWithPo.vendor_inv_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getSplitLineWithPoById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.splitWithPoData = result.map(ele => {
              ele.amount = ele.distribution_amount;
              ele.period = ele.period_from;
              return ele;
            });
            if (this.splitWithPoData.length) {
              const total = this.splitWithPoData
                .filter(ele => ele.amount)
                .map(data => data.amount);
              const totalAmount = commonHelper.calculateTotal(total).toFixed(2);
              this.remainingAmtWithPo =
                this.splitLineDataWithPo.taxable_amount - totalAmount;
              this.remainingAmtWithPo = this.remainingAmtWithPo.toFixed(2);
            } else {
              this.splitWithPoData = [];
              this.remainingAmtWithPo = this.splitLineDataWithPo.taxable_amount;
              this.remainingAmtWithPo = this.remainingAmtWithPo.toFixed(2);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        })
        .finally(() => {
          this.isDateDisabledWithPo();
        });
    },
    dateClearFunctionWithPo() {
      this.splitPeriodToDate = null;
      this.splitWithPoData = [];
    },
    dateClearFunctionFinWithPo() {
      this.finToDateWithPo = null;
      this.splitFinDataWithPo = [];
    },
    calculateDateFunctionWithPo() {
      // not using function
      if (this.splitPeriodFromDate && this.splitPeriodToDate) {
        this.splitWithPoData = [];
        const periodTotalDays = this.getCustomDays(
          this.splitPeriodToDate,
          this.splitPeriodFromDate
        );
        const totalDays = this.getTotalDays(
          this.splitPeriodToDate,
          this.splitPeriodFromDate
        );
        for (let i = 0; i < periodTotalDays.length; i++) {
          const currentDate = new Date();
          const calAmt =
            (this.splitLineDataWithPo.taxable_amount * periodTotalDays[i]) /
            totalDays;
          this.splitWithPoData.push({
            period: this.periodFromDates[i]
              ? this.periodFromDates[i]
              : 'PREPAID',
            period_to: this.periodToDates[i]
              ? format(this.periodToDates[i], 'dd-MMM-yyyy')
              : null,
            days: periodTotalDays[i],
            amount: calAmt.toFixed(2),
            expense_month:
              // new Date(this.periodFromDates[i]).getMonth() + 1 <=
              // new Date().getMonth() + 1
              new Date(this.periodFromDates[i]) <= new Date()
                ? this.periodFromDates[i].split('-')[1].toUpperCase() +
                  '-' +
                  this.periodFromDates[i]
                    .split('-')[2]
                    .toString()
                    .slice(2)
                : 'PREPAID',
            // expense_month: this.periodFromDates[i]
            //   ? this.periodFromDates[i].split('-')[1].toUpperCase() +
            //     '-' +
            //     this.periodFromDates[i]
            //       .split('-')[2]
            //       .toString()
            //       .slice(2)
            //   : 'PREPAID',
            new_key:
              new Date(this.splitPeriodToDate) <=
              new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
                ? this.splitPeriodToDate.split('-')[1].toUpperCase() +
                    '-' +
                    this.splitPeriodToDate.split('-')[2] ==
                  this.periodFromDates[i].split('-')[1].toUpperCase() +
                    '-' +
                    this.periodFromDates[i].split('-')[2]
                  ? 'POSTPAID'
                  : null
                : null
          });
        }
        const splitArrCopy = JSON.parse(JSON.stringify(this.splitWithPoData));
        let result = [];
        // for (let i = 0; i < splitArrCopy.length; i++)
        for (let i = splitArrCopy.length; i > 0; i--) {
          const findIndex = splitArrCopy.findIndex(
            ele => ele.expense_month === 'PREPAID'
          );
          const findIndexPostpaid = splitArrCopy.findIndex(
            ele => ele.new_key === 'POSTPAID'
          );
          if (findIndex !== -1) {
            let prepaidExpenses = splitArrCopy.splice(0, findIndex + 1);
            result.push(prepaidExpenses);
            for (let i = 0; i < result.length; i++) {
              let sum = 0;
              result[i].filter(ele => {
                if (ele.expense_month !== 'PREPAID') {
                  sum += parseFloat(ele.amount);
                }
              });
              result[i].filter(data => {
                if (data.expense_month === 'PREPAID') {
                  data.amount = this.splitLineDataWithPo.taxable_amount - sum;
                  data.amount = data.amount.toFixed(2);
                }
              });
            }
          } else {
            let postpaidExpenses = splitArrCopy.splice(
              0,
              findIndexPostpaid + 1
            );
            result.push(postpaidExpenses);
            for (let i = 0; i < result.length; i++) {
              let sum = 0;
              result[i].filter(ele => {
                if (ele.new_key !== 'POSTPAID') {
                  sum += parseFloat(ele.amount);
                }
              });
              result[i].filter(data => {
                if (data.new_key === 'POSTPAID') {
                  data.amount = this.splitLineDataWithPo.taxable_amount - sum;
                  data.amount = data.amount.toFixed(2);
                }
              });
            }
          }
          let tempArr = [];
          for (let i = 0; i < result.length; i++) {
            result[i].forEach(ele => {
              tempArr.push(ele);
            });
          }
          if (findIndex !== -1) {
            this.splitWithPoData = tempArr;
          } else if (findIndexPostpaid !== -1) {
            this.splitWithPoData = tempArr;
          }
        }
        const filterAmt = this.splitWithPoData
          .filter(ele => ele.amount)
          .map(item => item.amount);
        if (filterAmt.length) {
          const totalFilterAmt =
            filterAmt.length > 1
              ? commonHelper.calculateTotal(filterAmt).toFixed(2)
              : parseFloat(filterAmt[0]).toFixed(2);
          this.remainingAmtWithPo =
            this.splitLineDataWithPo.taxable_amount - totalFilterAmt;
          this.remainingAmtWithPo = parseFloat(this.remainingAmtWithPo).toFixed(
            2
          );
        }
      } else {
        alert('Kindly Enter From Date and To Date');
      }
    },
    calculateDateFunctionFinWithPo() {
      if (this.finFromDateWithPo && this.finToDateWithPo) {
        this.splitFinDataWithPo = [];
        const periodTotalDays = this.getCustomDays(
          this.finToDateWithPo,
          this.finFromDateWithPo
        );
        const totalDays = this.getTotalDays(
          this.finToDateWithPo,
          this.finFromDateWithPo
        );
        for (let i = 0; i < periodTotalDays.length; i++) {
          const currentDate = new Date(this.headerDetails.gl_date);
          const calAmt =
            (this.splitLineDataWithPo.taxable_amount * periodTotalDays[i]) /
            totalDays;
          this.splitFinDataWithPo.push({
            // oracle_line_description:
            //   (this.splitLineDataWithPo.item_description
            //     ? this.splitLineDataWithPo.item_description
            //     : '') +
            //   ' | ' +
            //   (this.headerDetails.remarks ? this.headerDetails.remarks : '') +
            //   ' | ' +
            //   (this.splitWithPoData[i].expense_month
            //     ? this.splitWithPoData[i].expense_month
            //     : '') +
            //   ' | ' +
            //   (this.periodFromDates[i] ? this.periodFromDates[i] : '') +
            //   ' | ' +
            //   (this.periodToDates[i]
            //     ? format(this.periodToDates[i], 'dd-MMM-yyyy')
            //     : ''),
            period: this.periodFromDates[i]
              ? this.periodFromDates[i]
              : 'PREPAID',
            period_to: this.periodToDates[i]
              ? format(this.periodToDates[i], 'dd-MMM-yyyy')
              : null,
            days: periodTotalDays[i],
            amount: calAmt.toFixed(2),
            // expense_month: this.compareDate(
            //   this.periodFromDates[i],
            //   this.headerDetails.gl_date
            // ),
            expense_month:
              // new Date(this.periodFromDates[i]).getMonth() + 1 <=
              // new Date(this.headerDetails.gl_date).getMonth() + 1
              new Date(this.periodFromDates[i]) <=
              new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
                ? this.periodFromDates[i].split('-')[1].toUpperCase() +
                  '-' +
                  this.periodFromDates[i]
                    .split('-')[2]
                    .toString()
                    .slice(2)
                : 'PREPAID',
            // expense_month: this.periodFromDates[i]
            //   ? this.periodFromDates[i].split('-')[1].toUpperCase() +
            //     '-' +
            //     this.periodFromDates[i]
            //       .split('-')[2]
            //       .toString()
            //       .slice(2)
            //   : 'PREPAID',
            code_combination: this.splitLineDataWithPo.concatenated_segments,
            code_combination_id: this.splitLineDataWithPo.code_combination_id,
            new_key:
              new Date(this.finToDateWithPo) <=
              new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
                ? this.finToDateWithPo.split('-')[1].toUpperCase() +
                    '-' +
                    this.finToDateWithPo.split('-')[2] ==
                  this.periodFromDates[i].split('-')[1].toUpperCase() +
                    '-' +
                    this.periodFromDates[i].split('-')[2]
                  ? 'POSTPAID'
                  : null
                : null
          });
          this.splitFinDataWithPo.map(ele => {
            ele.oracle_line_description =
              (this.splitLineDataWithPo.item_description
                ? this.splitLineDataWithPo.item_description
                : '') +
              ' | ' +
              (this.headerDetails.remarks ? this.headerDetails.remarks : '') +
              ' | ' +
              (ele.expense_month ? ele.expense_month : '') +
              ' | ' +
              (this.periodFromDates[i] ? this.periodFromDates[i] : '') +
              ' | ' +
              (this.periodToDates[i]
                ? format(this.periodToDates[i], 'dd-MMM-yyyy')
                : '');
          });
        }
        //
        // for (let i = 0; i < this.splitWithPoData.length; i++) {
        //   for (let j = 0; j < periodTotalDays.length; j++) {
        //     const calAmt =
        //       (this.splitWithPoData[i].amount * periodTotalDays[j]) / totalDays;
        //     this.splitFinDataWithPo.push({
        //       oracle_line_description:
        //         (this.splitLineDataWithPo.item_description
        //           ? this.splitLineDataWithPo.item_description
        //           : '') +
        //         ' | ' +
        //         (this.headerDetails.remarks ? this.headerDetails.remarks : '') +
        //         ' | ' +
        //         (this.splitWithPoData[i].expense_month
        //           ? this.splitWithPoData[i].expense_month
        //           : '') +
        //         ' | ' +
        //         (this.finFromDateWithPo ? this.finFromDateWithPo : '') +
        //         ' | ' +
        //         (this.finToDateWithPo ? this.finToDateWithPo : ''),
        //       period: this.periodFromDates[j]
        //         ? this.periodFromDates[j]
        //         : 'PREPAID',
        //       period_to: this.periodToDates[j]
        //         ? format(this.periodToDates[j], 'dd-MMM-yyyy')
        //         : null,
        //       days: periodTotalDays[j],
        //       amount: calAmt.toFixed(2),
        //       expense_month: this.periodFromDates[j]
        //         ? this.periodFromDates[j].split('-')[1].toUpperCase() +
        //           '-' +
        //           this.periodFromDates[j]
        //             .split('-')[2]
        //             .toString()
        //             .slice(2)
        //         : 'PREPAID',
        //       code_combination: this.splitLineDataWithPo.concatenated_segments,
        //       code_combination_id: this.splitLineDataWithPo.code_combination_id,
        //       new_key:
        //         new Date(this.finToDateWithPo) < new Date()
        //           ? this.finToDateWithPo.split('-')[1].toUpperCase() +
        //               '-' +
        //               this.finToDateWithPo.split('-')[2] ==
        //             this.periodFromDates[j].split('-')[1].toUpperCase() +
        //               '-' +
        //               this.periodFromDates[j].split('-')[2]
        //             ? 'POSTPAID'
        //             : null
        //           : null
        //       // expense_month: this.splitData[i].expense_month
        //     });
        //   }
        // }
        //
        const finArrCopy = JSON.parse(JSON.stringify(this.splitFinDataWithPo));
        let result = [];
        // for (let i = 0; i < finArrCopy.length; i++)
        for (let i = finArrCopy.length; i > 0; i--) {
          const findIndex = finArrCopy.findIndex(
            ele => ele.expense_month === 'PREPAID'
          );
          const findIndexPostpaid = finArrCopy.findIndex(
            ele => ele.new_key === 'POSTPAID'
          );
          if (findIndex !== -1) {
            let prepaidExpenses = finArrCopy.splice(0, findIndex + 1);
            result.push(prepaidExpenses);
            for (let i = 0; i < result.length; i++) {
              let sum = 0;
              result[i].filter(ele => {
                if (ele.expense_month !== 'PREPAID') {
                  sum += parseFloat(ele.amount);
                }
              });
              result[i].filter(data => {
                if (data.expense_month === 'PREPAID') {
                  data.amount = this.splitLineDataWithPo.taxable_amount - sum;
                  data.amount = data.amount.toFixed(2);
                }
              });
            }
          } else {
            let postpaidExpenses = finArrCopy.splice(0, findIndexPostpaid + 1);
            result.push(postpaidExpenses);
            for (let i = 0; i < result.length; i++) {
              let sum = 0;
              result[i].filter(ele => {
                if (ele.new_key !== 'POSTPAID') {
                  sum += parseFloat(ele.amount);
                }
              });
              result[i].filter(data => {
                if (data.new_key === 'POSTPAID') {
                  data.amount = this.splitLineDataWithPo.taxable_amount - sum;
                  data.amount = data.amount.toFixed(2);
                }
              });
            }
          }
          let tempArr = [];
          for (let i = 0; i < result.length; i++) {
            result[i].forEach(ele => {
              tempArr.push(ele);
            });
          }
          if (findIndex !== -1) {
            this.splitFinDataWithPo = tempArr;
          } else if (findIndexPostpaid !== -1) {
            this.splitFinDataWithPo = tempArr;
          }
        }
        const filterAmt = this.splitFinDataWithPo
          .filter(ele => ele.amount)
          .map(item => item.amount);
        if (filterAmt.length) {
          const totalFilterAmt =
            filterAmt.length > 1
              ? commonHelper.calculateTotal(filterAmt).toFixed(2)
              : parseFloat(filterAmt[0]).toFixed(2);
          this.remainingFinAmtWithPo =
            this.splitLineDataWithPo.taxable_amount - totalFilterAmt;
          this.remainingFinAmtWithPo = parseFloat(
            this.remainingFinAmtWithPo
          ).toFixed(2);
        }
      } else {
        // if (this.finFromDateWithPo == null && this.finToDateWithPo == null) {
        //   const tempArr = this.splitWithPoData.map(item => ({
        //     oracle_line_description:
        //       (this.splitLineDataWithPo.item_description
        //         ? this.splitLineDataWithPo.item_description
        //         : '') +
        //       ' | ' +
        //       (this.headerDetails.remarks ? this.headerDetails.remarks : '') +
        //       ' | ' +
        //       (item.expense_month ? item.expense_month : '') +
        //       ' | ' +
        //       (item.period ? item.period : '') +
        //       ' | ' +
        //       (item.period_to ? item.period_to : ''),
        //     period: item.period,
        //     period_to: item.period_to,
        //     days: item.days,
        //     amount: item.amount,
        //     expense_month: item.expense_month,
        //     code_combination: this.splitLineDataWithPo.concatenated_segments,
        //     code_combination_id: this.splitLineDataWithPo.code_combination_id
        //   }));
        //   this.splitFinDataWithPo = tempArr;
        //   this.remainingFinAmtWithPo = parseFloat(0).toFixed(2);
        // } else {
        alert('Kindly Enter From Date and To Date');
        // }
      }
    },
    calculateAmountFinanceWithpo(item) {
      const totalLineAmount = this.splitWithPoData
        .filter(ele => ele.amount)
        .map(data => data.amount);
      if (totalLineAmount.length) {
        const finalAmount =
          totalLineAmount.length > 1
            ? commonHelper.calculateTotal(totalLineAmount).toFixed(2)
            : parseFloat(totalLineAmount[0]).toFixed(2);
        if (finalAmount > +this.splitLineDataWithPo.taxable_amount) {
          alert('Amount cannot be greater than Remaining Amount');
          item.amount = null;
          this.calculateAmountFinanceWithpo(item);
        } else {
          this.remainingAmtWithPo =
            +this.splitLineDataWithPo.taxable_amount - finalAmount;
          this.remainingAmtWithPo = this.remainingAmtWithPo.toFixed(2);
        }
      } else {
        this.remainingAmtWithPo = this.splitLineDataWithPo.taxable_amount;
      }
    },
    isDateDisabled() {
      const isDistributionSaved = this.splitFinData.some(
        ele => ele.inv_distribution_dtl_id
      );
      if (isDistributionSaved) {
        this.dateDisabledFlag = true;
      } else {
        this.dateDisabledFlag = false;
      }
    },
    isDateDisabledWithPo() {
      const isCostCentreSaved = this.splitWithPoData.some(
        ele => ele.inv_distribution_dtl_id
      );
      if (isCostCentreSaved) {
        this.dateDisabledFlagWithPo = true;
      } else {
        this.dateDisabledFlagWithPo = false;
      }
    },
    isDateDisabledFinWithPo() {
      const isCostCentreSaved = this.splitFinDataWithPo.some(
        ele => ele.inv_distribution_dtl_id
      );
      if (isCostCentreSaved) {
        this.dateDisabledFinFlagWithPo = true;
      } else {
        this.dateDisabledFinFlagWithPo = false;
      }
    },
    showHideDistributionModal(flag) {
      this.showDistributionModal = flag;
      if (flag) {
        this.getDistributionDetails();
      }
      if (!flag) {
        this.distributionSearch = null;
        this.currentPageDistribution = 1;
        this.perPageDistribution = commonHelper.perPageRecord;
        this.pageOptionsDistribution = commonHelper.getPageOption();
        this.totalRowsDistribution = null;
      }
    },
    getDistributionDetails() {
      const payload = {
        _page: this.currentPageDistribution - 1,
        _limit: this.perPageDistribution,
        distribution_set: this.distributionSearch
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getDistributionDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.distributionData = result;
            this.totalRowsDistribution = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    rowSelectedDistribution(item) {
      if (item.distribution_set_id) {
        this.distribution.text = item.distribution_set_name;
        this.distribution.value = item.distribution_set_id;
        this.getDistributionSetDetails(item);
      }
      this.showHideDistributionModal(false);
    },
    getDistributionSetDetails(item) {
      const payload = { distribution_set_id: item.distribution_set_id };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getDistributionSetDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.splitData = result.map(ele => {
              ele.state_code = ele.segment4;
              ele.cost_centre = ele.segment5;
              ele.amount =
                (this.splitLineData.taxable_amount * ele.percent_distribution) /
                100;
              ele.amount = parseFloat(ele.amount).toFixed(2);
              return ele;
            });
            const totalLength = this.splitData.length;
            if (totalLength > 1) {
              const filterAmt = this.splitData
                .slice(0, -1)
                .filter(ele => ele.amount)
                .map(data => data.amount);
              const totalAmt =
                filterAmt.length > 1
                  ? commonHelper.calculateTotal(filterAmt).toFixed(2)
                  : parseFloat(filterAmt[0]).toFixed(2);
              const transferAmt = this.splitLineData.taxable_amount - totalAmt;
              this.splitData[totalLength - 1].amount = parseFloat(
                transferAmt
              ).toFixed(2);
            }
            this.remainingAmount = parseFloat(0).toFixed(2);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    isDistributionDetailsSaved() {
      const isDistributionSetSaved = this.splitData.some(
        ele => ele.inv_cost_centre_id
      );
      if (isDistributionSetSaved) {
        this.distributionSetFlag = true;
      } else {
        this.distributionSetFlag = false;
      }
    },
    deleteCostCentre(type) {
      const promt = confirm(
        'Are you sure, you want to delete this cost centre?'
      );
      if (promt) {
        const payload = {
          vendor_inv_dtl_id:
            type === 'without_po'
              ? this.splitLineData.vendor_inv_dtl_id
              : this.splitLineDataWithPo.vendor_inv_dtl_id,
          type: type
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/deleteCostCentre', payload)
          .then(resp => {
            this.loader = false;
            if (resp.status === 200) {
              alert('Record Deleted Successfully');
              if (type === 'without_po') {
                this.getSplitLineDetailsById();
              } else {
                this.getSplitLineWithPoById();
              }
            } else {
              alert(resp.response.data.message);
            }
          })
          .catch(() => {
            this.loader = false;
            alert(appStrings.autoFailedMsg);
          });
      }
    },
    downloadCostCentreDetails() {
      const payload = {
        vendor_inv_id: this.vendorInvId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/downloadCostCentreDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            const customDownloadData = result.map(obj => ({
              manual_invoice_line_id: obj.manual_invoice_line_id,
              oracle_line_description: obj.oracle_line_description,
              period_from: obj.period_from,
              period_to: obj.period_to,
              days: obj.days,
              cost_centre: obj.cost_centre,
              cost_centre_amount: obj.cost_centre_amount,
              distribution_amount: obj.distribution_amount,
              expense_month: obj.expense_month,
              code_combination: obj.code_combination
            }));
            if (customDownloadData.length) {
              commonHelper.downloadExcel(
                customDownloadData,
                'cost-centre-details'
              );
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    deleteDistributionDetails(type, item) {
      const payload = {
        type: type,
        vendor_inv_dtl_id: item.vendor_inv_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/deleteDistributionDetails', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            alert('Distribution Line Delete Successfully.');
            if (type === 'without_po') {
              this.getSplitLineFinDetailsById();
            } else if (type === 'with_po') {
              this.getSplitLineFinWithPoDetailsById();
            }
          } else {
            alert('Something went wrong.');
          }
        })
        .catch(() => {
          this.loader = false;
          alert(appStrings.autoFailedMsg);
        });
    },
    checkAccField(item, index, type) {
      if (type === 'qty') {
        this.qtyTwoDecimalValue(index, item.acc_qty);
        if (item.acc_qty > item.deliver_qty) {
          alert(
            'Accepted quantity cannot be greater than Quantity Being Delivered'
          );
          this.invoiceLineData[index].acc_qty = null;
          this.invoiceLineData[index].acc_amt = null;
        } else {
          if (this.invoiceLineData[index].acc_qty === null) {
            this.invoiceLineData[index].acc_amt = null;
          } else {
            this.invoiceLineData[index].acc_amt =
              this.invoiceLineData[index].po_price *
              this.invoiceLineData[index].acc_qty;
            this.invoiceLineData[index].acc_amt = this.invoiceLineData[
              index
            ].acc_amt.toFixed(2);
          }
        }
      } else if (type === 'amt') {
        this.amtTwoDecimalValue(index, item.acc_amt);
        if (item.acc_amt > item.taxable_amount) {
          alert('Accepted amount cannot be greater than Taxable Amount');
          this.invoiceLineData[index].acc_amt = null;
          this.invoiceLineData[index].acc_qty = null;
        } else {
          if (this.invoiceLineData[index].acc_amt === null) {
            this.invoiceLineData[index].acc_qty = null;
          } else {
            this.invoiceLineData[index].acc_qty =
              this.invoiceLineData[index].acc_amt /
              this.invoiceLineData[index].po_price;
            this.invoiceLineData[index].acc_qty = this.invoiceLineData[
              index
            ].acc_qty.toFixed(10);
          }
        }
      }
    },
    formatAmount(num) {
      num = num
        ? num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        : null;
      return num;
    },
    formatQuantity(num) {
      num = num
        ? num.toLocaleString('en-IN', {
            minimumFractionDigits: 10,
            maximumFractionDigits: 10
          })
        : null;
      return num;
    },
    qtyTwoDecimalValue(index, qty) {
      if (qty > 0) {
        let quantity = this.invoiceLineData[index].acc_qty
          .toString()
          .split('.');
        if (quantity.length >= 1 && quantity[0].length > 14) {
          this.invoiceLineData[index].acc_qty = null;
          alert('Only Fourteen digits allowed before decimal');
        } else if (quantity.length > 1 && quantity[1].length > 10) {
          this.invoiceLineData[index].acc_qty = parseFloat(
            this.invoiceLineData[index].acc_qty
          ).toFixed(10);
          alert('Only Ten Decimal Value Allowed.');
        }
      } else {
        alert('Quantity should be greater than 0');
        this.invoiceLineData[index].acc_qty = null;
        this.invoiceLineData[index].acc_amt = null;
      }
    },
    amtTwoDecimalValue(index, amt) {
      if (amt > 0) {
        let quantity = this.invoiceLineData[index].acc_amt
          .toString()
          .split('.');
        if (quantity.length >= 1 && quantity[0].length > 14) {
          this.invoiceLineData[index].acc_amt = null;
          alert('Only Fourteen digits allowed before decimal');
        } else if (quantity.length > 1 && quantity[1].length > 2) {
          this.invoiceLineData[index].acc_amt = parseFloat(
            this.invoiceLineData[index].acc_amt
          ).toFixed(2);
          alert('Only Two Decimal Value Allowed.');
        }
      } else {
        alert('Amount should be greater than 0');
        this.invoiceLineData[index].acc_amt = null;
        this.invoiceLineData[index].acc_qty = null;
      }
    },
    checkVendorActiveInactive(type) {
      const payload = {
        vendor_id: this.headerDetails.vendor_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/checkVendorActiveInactive', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            if(response.data.data === 'Active Vendor') {
              this.approveRejectInvoiceApproval(type);
            } else {
              alert('Vendor Inactive')
            }
          } else { 
            alert('Something went wrong.');
          }
        })
        .catch(() => {
          this.loader = false;
          alert(appStrings.autoFailedMsg);
        });
    },
    updateGrnFlag() {
      const payload = {
        vendor_invoice_id: this.vendorInvId,
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/updateGrnFlag', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            setTimeout(() => {}, 0)
          } else {
            alert('Something went wrong.');
          }
        })
        .catch(() => {
          this.loader = false;
          alert(appStrings.autoFailedMsg);
        });
    },
    checkVendorActiveInactiveManual() {
      const payload = {
        vendor_id: this.headerDetails.vendor_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/checkVendorActiveInactive', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            if(response.data.data === 'Active Vendor') {
              this.approveForwardInvoice();
            } else {
              alert('Vendor Inactive')
            }
          } else { 
            alert('Something went wrong.');
          }
        })
        .catch(() => {
          this.loader = false;
          alert(appStrings.autoFailedMsg);
        });
    },
    openCloseUserPreferenceModal(flag) {
      this.selectAllCheckBox = false;
      this.searchUser = null;
      this.selectedUsers = [];
      this.selectedUsersData = [];
      this.getUsersData();
      this.selectUserPreference();
      this.userPreferenceModal = flag;
      setTimeout(() => {
        this.userPreferenceModal = flag;
      }, 500)
      if(!flag) {
        this.showApproveForwardModal = false;
      }
    },
    getUsersData() {
      const payload = {
        _page: this.currentPageUserPreference - 1,
        _limit: this.perPageUserPreference,
        user_email: this.searchUser
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getUserDataForUserPreference', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.totalRowsUserPreference = response.data.data.total_elements;
            this.usersData = response.data.data.page;
            for(let i=0; i<this.usersData.length; i++) {
              for(let j=0; j<this.selectedUsersData.length; j++) {
                if(this.selectedUsersData[j].user_email === this.usersData[i].user_email) {
                  this.usersData[i].selectBox = true;
                }
              }
            }
          } else {
            alert('Something went wrong.');
          }
        })
        .catch(() => {
          this.loader = false;
          // alert(appStrings.autoFailedMsg);
        });
    },
    selectBoxCheckedUsers(flag, index, item, empId) {
      this.usersData[index].selectBox = flag;
      if (flag === true) {
        this.selectedUsers.push(item);
        this.selectedUsersData.push(item);
        if(this.selectedUsers.length === this.usersData.length) {
          this.selectAllCheckBox = true;
        }
      } else {
        this.selectedUsers = this.selectedUsers.filter(
          el => el.emp_id !== empId
        );
        this.selectedUsersData = this.selectedUsersData.filter(
          el => el.emp_id !== empId
        );
        this.selectAllCheckBox = false;
      }
    },
    selectAllBoxCheckedUsers(flag) {
      this.selectedUsers = [];
      if (flag) {
        this.usersData = this.usersData.map(
          (data, index) => {
            data.selectBox = this.selectAllCheckBox;
            if (this.selectAllCheckBox) {
              this.selectBoxCheckedUsers(data.selectBox, index);
            }
            return data;
          }
        );
        this.selectedUsers = this.usersData;
      } else {
        this.usersData = this.usersData.map(
          (data, index) => {
            data.selectBox = this.selectAllCheckBox;
            if (this.selectAllCheckBox) {
              this.selectBoxCheckedUsers(data.selectBox, index);
            }
            return data;
          }
        );
        this.selectedUsers = [];
      }
    },
    postUserPreferenceData() {
      let empId = [];
      for(let i of this.selectedUsersData) {
        empId.push({
          approver_id: i.emp_id
        });
      }
      const payload = {
        userId: this.workflowId.userId,
        approver_ids: empId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/postUserPreferenceData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            alert('Users saved successfully')
          } else {
            alert('Something went wrong.');
          }
        })
        .catch(() => {
          this.loader = false;
          alert(appStrings.autoFailedMsg);
        });
    },
    selectUserPreference() {
      const payload = {
        user_id: this.workflowId.userId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getUserPreferenceInvoiceApproval', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data;
            if(result) {
              this.selectedUsersData = result;
            }           
            for (let i of result) {
              this.selectedEmpEmail.push(i.user_email);
              if (!this.selectedEmpId.includes(i.emp_id)) {
                this.selectedEmpId.push({ approver_id: +i.emp_id });
              }
            }
          } else {
            this.makeToast(response.response.data.error, "danger");
          }
        })
        .catch(() => {
          this.loader = false;
          // alert(appStrings.autoFailedMsg);
        });
    },
    makeToast(content, variant) {
      this.$bvToast.toast(content, {
        title: 'Alert',
        variant: variant,
        solid: true
      });
    },
    // selectBoxChecked(flag, index, item, advNo) { // 2.2 (Himanshu) Prepayment TDS Line match check
    //   if(this.selectedRow.length>0 && flag && item.tds_section !== null && item.tds_section !== this.selectedRow[this.selectedRow.length-1].tds_section) {
    //     this.makeToast('TDS Section cannot be different', "danger");
    //     this.advanceData[index].selectBox = false;
    //   } else if(this.selectedRow.length===0 && flag && this.advancesAppliedData.length>1 && item.tds_section !== null && item.tds_section !== this.advancesAppliedData[0].tds_section) {
    //     this.makeToast('TDS Section cannot be different', "danger");
    //     this.advanceData[index].selectBox = false;
    //   } else {
    //    this.advanceData[index].selectBox = flag;
    //   if (flag === true) {
    //     this.selectedRow.push(item);
    //     if (this.selectedRow.length === this.advanceData.length) {
    //       this.selectAllCheckBox = true;
    //     }
    //   } else {
    //     this.totalAdjAmt = this.totalAdjAmt - this.advanceData[index].adj_amt;
    //     this.advanceData[index].app_date = null;
    //     this.advanceData[index].adj_amt = 0;
    //     this.selectedRow = this.selectedRow.filter(el => el.adv_num !== advNo);
    //     this.selectAllCheckBox = false;
    //   }
    //   }
      
    // },
    selectBoxChecked(flag, index, item, advNo) { // 2.2 (Himanshu) Prepayment TDS Line match check
  const selectedTds = this.selectedRow.length > 0 
    ? this.selectedRow[this.selectedRow.length - 1].tds_section 
    : null;
  const appliedTds = this.advancesAppliedData.length > 0 
    ? this.advancesAppliedData[0].tds_section 
    : null;
  if (flag) {
    if (
      item.tds_section !== null && 
      (
        (selectedTds !== null && item.tds_section !== selectedTds) || 
        (this.selectedRow.length === 0 && appliedTds !== null && item.tds_section !== appliedTds)
      )
    ) {
      this.makeToast("TDS Section cannot be different", "danger");
      this.advanceData[index].selectBox = false;
      return;
    }
    this.advanceData[index].selectBox = true;
    this.selectedRow.push(item);
    if (this.selectedRow.length === this.advanceData.length) {
      this.selectAllCheckBox = true;
    }
  } else {
    this.advanceData[index].selectBox = false;
    this.totalAdjAmt = this.totalAdjAmt - this.advanceData[index].adj_amt;
    this.advanceData[index].app_date = null;
    this.advanceData[index].adj_amt = 0;
    this.selectedRow = this.selectedRow.filter(el => el.adv_num !== advNo);
    this.selectAllCheckBox = false;
  }
},
    selectAllBoxChecked(flag) {
      this.selectedRow = [];
      if (flag) {
        this.advanceData = this.advanceData.map((data, index) => {
          data.selectBox = this.selectAllCheckBox;
          if (this.selectAllCheckBox) {
            this.selectBoxChecked(data.selectBox, index);
          }
          return data;
        });
        this.selectedRow = this.advanceData;
      } else {
        this.advanceData = this.advanceData.map((data, index) => {
          data.selectBox = this.selectAllCheckBox;
          if (this.selectAllCheckBox) {
            this.selectBoxChecked(data.selectBox, index);
          }
          return data;
        });
        this.selectedRow = [];
      }
    },
    calculateTotalAdjAmt(adjAmt, amountPending, index, item) {
      if (adjAmt > amountPending) {
        alert('Adjustment Amount cannot be greater than Realapp Pending');
        this.advanceData[index].adj_amt = 0;
        this.totalAdjAmt = 0;
      } else if (item.tds_rate && item.tds_rate > 0 && adjAmt > this.taxableAmountWithoutCurrency) {
        alert('Adjustment Amount cannot be greater than Taxable Amount');
        this.advanceData[index].adj_amt = 0;
        this.totalAdjAmt = 0;
      } else if ((item.tds_rate === null || item.tds_rate === 0 || item.tds_rate === "") && +adjAmt > +this.headerDetails.invoice_amount) { // 1.7(Himanshu) changed comparison conditions with a new variable
        alert(`Adjustment Amount cannot be greater than Invoice Amount. Adjustment Amount is ${adjAmt} and Invoice Amount is ${+this.headerDetails.invoice_amount}`);
        this.advanceData[index].adj_amt = 0;
        this.totalAdjAmt = 0;
      } else {
        for (let i of this.advanceData) {
          if (!i.adj_amt) {
            i.adj_amt = 0;
          }
        }
        let total = 0;
        for (let i of this.advanceData) {
          total = +total + +i.adj_amt;
        }
        this.totalAdjAmt = total;
      }
    },
    getAdvanceData() {
      const payload = {
        _page: 0,
        _limit: 1000,
        vendor_id: this.headerDetails.vendor_id,
        // vendor_site_id: this.headerDetails.vendor_site_id,
        po_header_id: this.headerDetails.po_header_id
          ? this.headerDetails.po_header_id
          : null,
          advance_number: this.advanceNumber,
          ou_id: this.operatingUnit.value ? this.operatingUnit.value : this.headerDetails.ou_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getAdvanceDataInInvoiceApproval', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.advanceData = response.data.data.data.page;
            let count=0;
            for(let i of this.advanceData) {
              if(i.adv_num === this.invoiceLineData[0].po_number) {
                count=count+1;
                this.advanceMatchFlag = true;
              }
            }
            if(count>0) {
              this.advanceData = this.moveToFirstPosition(this.advanceData, data => data.adv_num === this.invoiceLineData[0].po_number)
            }            
            this.getRealappPenindAmount();
            // const table2Ids = new Set(
            //   this.advancesAppliedData.map(item => item.adv_id)
            // );
            //  // 2.2 (Himanshu) Prepayment TDS Line get delayed
            //   this.advanceData = this.advanceData.filter(
            //   record => !table2Ids.has(record.adv_id)
            // );
            // this.advanceData.push({
            //   adv_amt: null,
            //   adv_amt_applied: null,
            //   adv_date: null,
            //   adj_amt_pending: null,
            //   vendor_num: null,
            //   vendor_site: null,
            //   adv_num: null,
            //   adj_amt: 0,
            //   tds_rate: null,
            //   tds_section: null,
            //   adv_id: null,
            //   po_num: null,
            //   vendor_name: null
            // });          
            // this.calculateTotalAdjAmt();
          } else {
            alert(response.response.data.message); // 2.2 (Himanshu) Alert message changed
          }
        })
        .catch(() => {
          this.loader = false;
          alert(appStrings.autoFailedMsg);
        });
    },
    postAdvanceData() {
      let count = 0;
      for (let i of this.selectedRow) {
        if (i.adj_amt === 0) {
          count = count + 1;
        }
      }
      if (count > 0) {
        alert('Adjustment Amount cannot be zero');
      } else {
        // this.calculateTotalAdjAmt();
        if (
          this.totalAdjAmt + this.totalAdjAmtApplied >
          +this.taxableAmountWithoutCurrency + +this.taxAmountWithoutCurrency
        ) {
          alert('Total Applied Amount cannot be greater than Invoice Amount');
        } else {
          let advanceDetails = [];
          for (let i of this.selectedRow) {
            advanceDetails.push({
              vendor_adv_id: i.vendor_adv_id ? i.vendor_adv_id : 0,
              po_num: i.po_num,
              adv_num: i.adv_num,
              adv_amt: i.adv_amt,
              adv_amt_applied: i.adv_amt_applied,
              adv_date: i.adv_date,
              adj_amt_pending: null,
              adj_amt: +i.adj_amt,
              tds_rate: i.tds_rate,
              tds_section: i.tds_section,
              adv_id: i.adv_id,
              app_date: i.app_date,
              prepay_line_number:i.prepay_line_number // 2.0 (Himanshu)  Commented prepay_line_number key from payload     // 2.1 (Himanshu)  Uncommented prepay_line_number key from payload

            });
          }
          const payload = {
            vendor_inv_id: this.vendorInvId,
            adv_dtls: advanceDetails
          };
          this.loader = true;
          this.$store
            .dispatch('intWorkflow/postAdvanceDataInInvoiceApproval', payload)
            .then(response => {
              this.loader = false;
              if (response.status === 200) {
                this.responseMsg = 'Applied Successfully';
                this.makeToast(this.responseMsg, 'success');
                this.selectedRow = [];
                // this.getAdvanceData();
                // this.getAdvancesAppliedData();
              } else {
                this.isSuccess = true;
                this.responseMsg = 'Some Error Occured';
                this.makeToast(this.responseMsg, 'danger');
              }
            })
            .catch(err => {
              this.loader = false;
              this.makeToast(err, 'danger');
            });
        }
      }
    },
    getAdvancesAppliedData() {
      const payload = {
        vendorInvId: this.vendorInvId
      };
      this.loader = true;
      this.$store
        .dispatch(
          'intWorkflow/getAdvancesAppliedDataInInvoiceApproval',
          payload
        )
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.advancesAppliedData = response.data.data;
            this.advancesAppliedData.push({
              adv_amt: null,
              adv_amt_applied: null,
              adv_date: null,
              adj_amt_pending: null,
              vendor_num: null,
              vendor_site: null,
              adv_num: null,
              adj_amt: 0,
              tds_rate: null,
              tds_section: null,
              adv_id: null,
              po_num: null,
              vendor_name: null
            });
            this.calculateTotalAdjAmtApplied();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    calculateTotalAdjAmtApplied() {
      for (let i of this.advancesAppliedData) {
        if (!i.adj_amt) {
          i.adj_amt = 0;
        }
      }
      let total = 0;
      for (let i of this.advancesAppliedData) {
        total = +total + +i.adj_amt;
      }
      this.totalAdjAmtApplied = total;
    },
    deleteAdvanceData(advId) {
      const payload = {
        vendor_inv_id: this.vendorInvId,
        adv_dtls: [
          {
            vendor_adv_id: advId
          }
        ]
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/deleteAdvancesDataInInvoiceApproval', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            // this.getAdvanceData();
            // this.getAdvancesAppliedData();
            this.makeToast('Unapplied Successfully', 'success');
            this.selectedRow = []; // 2.2 (Himanshu)
          } else {
            this.makeToast('Something went wrong', 'danger');
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getRealappPenindAmount() {
      let advanceIdList = [];
      for (let i of this.advanceData) {
        advanceIdList.push({
          adv_id: i.adv_id
        });
      }
      const payload = {
        adv_id_list: advanceIdList
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getRealappPenindAmount', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.realappPendingData = response.data;
            if (response.data.length === 0) {
              for (let i of this.advanceData) {
                i.realapp_pending = 0;
              }
            } else {
              this.advanceData = this.advanceData.map(record => {
                const match = this.realappPendingData.find(
                  item => item.adv_id === record.adv_id
                );
                return {
                  ...record,
                  realapp_pending: match ? match.realapp_pending : 0
                };
              });
            }
            for (let i of this.advanceData) {
              i.amount_pending =
                i.adv_amt_unapplied - i.oracle_pending - i.realapp_pending;
            }
            setTimeout(() => {
              this.advanceData = JSON.parse(JSON.stringify(this.advanceData));
            }, 0);
             // 2.2 (Himanshu) Prepayment TDS Line check
            const table2Ids = new Set(
              this.advancesAppliedData.map(item => item.adv_id)
            );
              this.advanceData = this.advanceData.filter(
              record => !table2Ids.has(record.adv_id)
            );
              this.advanceData.push({
              adv_amt: null,
              adv_amt_applied: null,
              adv_date: null,
              adj_amt_pending: null,
              vendor_num: null,
              vendor_site: null,
              adv_num: null,
              adj_amt: 0,
              tds_rate: null,
              tds_section: null,
              adv_id: null,
              po_num: null,
              vendor_name: null
            });
            this.totalAdjAmt = 0;
          }
        })
        .catch(err => {
          this.loader = false;
          this.makeToast(err, 'danger');
        });
    },
    enableDisableEditMode() {
      this.editMode = !this.editMode;
    },
    disabledDatesFromSysDate(date) {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const day = now.getDate();
      const monthNames = [
        'JAN',
        'FEB',
        'MAR',
        'APR',
        'MAY',
        'JUN',
        'JUL',
        'AUG',
        'SEP',
        'OCT',
        'NOV',
        'DEC'
      ];
      this.currentDate = `${day}-${monthNames[month]}-${year}`;
      const restrictedDate = new Date(this.currentDate);
      restrictedDate.setHours(0, 0, 0, 0);
      return date > restrictedDate;
    },
    getHeaderPaymentTerms() {
      const payload = {
        _page:0,
        _limit:1000,
        vendor_id: this.vendorInvId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getPaymentTermsInvoiceApproval', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.payment_terms_manual = response.data.data.page[0].description;
          } else {
            this.makeToast('Something went wrong', 'danger');
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getVendorInvoiceDetailsByIdForHoldInvoices() {
      const payload = {
        vendor_inv_id: this.vendorInvId,
        user_id: this.workflowId.userId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getVendorInvoiceDetailsByIdForHoldInvoices', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.headerDetails = result;
            if (this.headerDetails.po_num) {
              this.headerDetails.remarks = this.headerDetails.remarks ? this.headerDetails.remarks : `INV No-${
                this.headerDetails.inv_num
              } | PO-${this.headerDetails.po_num} | GRN-${
                this.headerDetails.receipt_num
                  ? this.headerDetails.receipt_num
                  : ''
              } | EXP MON-${this.headerDetails.period_name} | PO Hdr Dsc `;
            }
            this.operatingUnit.text = result.manual_ou_name;
            this.operatingUnit.value = result.manual_ou_id;
            this.approvalStatusKey = result.approval_status_key;
            this.headerDetails.show_inv_amt = commonHelper.formatAmountWithoutCurrency(
              result.inv_amt
            );
            this.invoiceLineData = result.invoice_dtls.map(elem => {
              // elem.taxable_amount = elem.deliver_qty * elem.po_price;
              elem.period_name = result.period_name;
              return elem;
            });
            if (
              result.actual_gr_date &&
              result.period_name &&
              result.material_received_by
            ) {
              this.isComDetailsSaved = true;
            } else {
              this.isComDetailsSaved = false;
            }
            if (result.gl_date) {
              this.isFinDetailsSaved = true;
            } else {
              this.isFinDetailsSaved = false;
            }
            this.validateCurrency();
            this.getTotalTaxAmount();
            if (this.headerDetails.invoice_level == 'INVOICE') {
              this.headerDetails.gl_date = !this.headerDetails.gl_date
                ? format(new Date(), appStrings.DATEFNSFORMAT)
                : this.headerDetails.gl_date;
            }
            if (this.headerDetails.manual_invoice) {
              if (this.headerDetails.invoice_level === 'INVOICE') {
                this.invoiceLineFields = [
                  {
                    key: 'manual_invoice_line_id',
                    label: 'Manual Invoice Line No.'
                  },
                  {
                    key: 'item_description',
                    label: 'Description'
                  },
                  {
                    key: 'po_price',
                    label: 'PO Price',
                    class: 'col-width-fix'
                  },
                  {
                    key: 'deliver_qty',
                    label: 'Qty. Being Delivered',
                    class: 'qty-width-fix'
                  },
                  {
                    key: 'hsn_sac',
                    label: 'Invoice HSN/SAC',
                    // class: 'col-width-fix' // 1.8 (Himanshu)
                  },
                  { key: 'taxable_amount', class: 'tax-amt-fix' },
                  {
                    key: 'tax_amount',
                    class: 'text-fix-po'
                  },
                  {
                    key: 'tax_non_recoverable',
                    label: 'Tax Non Recoverable'
                  },
                  {
                    key: 'status_code',
                    label: 'GRN Status',
                    class: 'col-width-fix'
                  },
                  {
                    key: 'status_msg',
                    label: 'Error Message'
                  },
                  {
                    key: 'tax_details',
                    label: 'Tax',
                    stickyColumn: true
                  },
                  {
                    key: 'split',
                    stickyColumn: true
                  }
                ];
                if(this.headerDetails.currency !== 'INR') { // 2.4 (Himanhu) key added for taxable_amount_inr in details
                  this.invoiceLineFields.splice(
                   this.invoiceLineFields.findIndex(f => f.key === 'taxable_amount') + 1,
                   0,
                   { key: 'taxable_amount_inr', label: 'Taxable Amount (INR)', class: 'tax-amt-fix' }
                 );
                }
              } else {
                this.invoiceLineFields = [
                  {
                    key: 'manual_invoice_line_id',
                    label: 'Manual Invoice Line No.'
                  },
                  {
                    key: 'item_description',
                    label: 'Description'
                  },
                  {
                    key: 'po_price',
                    label: 'PO Price',
                    class: 'col-width-fix'
                  },
                  {
                    key: 'deliver_qty',
                    label: 'Qty. Being Delivered',
                    class: 'qty-width-fix'
                  },
                  {
                    key: 'hsn_sac',
                    label: 'Invoice HSN/SAC',
                    // class: 'col-width-fix' // 1.8 (Himanshu)
                  },
                  { key: 'taxable_amount', class: 'tax-amt-fix' },
                  {
                    key: 'tax_amount',
                    class: 'text-fix-po'
                  },
                  {
                    key: 'tax_details',
                    label: 'Tax',
                    stickyColumn: true
                  },
                  {
                    key: 'split',
                    stickyColumn: true
                  }
                ];
              }
            } else {
              this.setFieldsForFinance();
            }
            // if (!this.headerDetails.manual_invoice) {
            //   if (this.headerDetails.invoice_level == 'INVOICE') {
            //     this.headerDetails.remarks = this.headerDetails.remarks
            //       ? this.headerDetails.remarks
            //       : this.headerDetails.inv_num +
            //         ' | ' +
            //         this.headerDetails.vendor_name +
            //         ' | ' +
            //         this.headerDetails.po_num;
            //   }
            // }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
 moveToFirstPosition(array, predicate) {
  const index = array.findIndex(predicate);
  if (index > -1) {
    const [item] = array.splice(index, 1);
    array.unshift(item);
  }
  return array;
},
calculateExchangeRateAmount(rate) {
  // 1.7 (Himanshu) function for calculating exchange amount
  this.headerDetails.exchange_amount = +(+this.headerDetails.inv_amt * +rate).toFixed(2);
  for(let i of this.invoiceLineData) { // 2.4 (Himanshu) value calculated for taxable_amount_inr
    i.taxable_amount_inr = +this.headerDetails.exchange_rate * +i.taxable_amount;
    i.taxable_amount_inr = i.taxable_amount_inr.toFixed(2);
  }
  setTimeout(() => {
    this.headerDetails.exchange_amount = JSON.parse(JSON.stringify(this.headerDetails.exchange_amount));
    this.invoiceLineData = JSON.parse(JSON.stringify(this.invoiceLineData));   
  }, 500)
  this.$forceUpdate();
},
checkHsnSacCode(hsnSac, index) {
  // 1.7 (Himanshu) function for checking hsn_sac code to be of 6 or 8 digits
 if(hsnSac.length !== 6 && hsnSac.length !== 8) {
  this.invoiceLineData[index].hsn_sac = null;
  alert('HSN/SAC code must be of 6 or 8 digits');
 }
},
openCloseResponseModal(type, item, index) {
  // 1.7 (Himanshu) function for opening response modal for rcm taxes
      if (type === 'RCM_TAXES') {
        if(!item.tax_type) {
          alert('Please select Tax Type first')
        } else {
        this.rcmTaxIndex = index;
        this.getRcmTaxesData(item);
        }        
      } else if (type === 'TAX_TYPE') { // 2.2 (Himanshu) Tax Type response modal
        this.rcmTaxIndex = index;
        this.getTaxTypeList(item);
      }
    },
    closeRcmTaxesModal(flag) {
      // 1.7 (Himanshu) for closing response modal
      this.showOpenRcmTaxes = flag;
    },
    getRcmTaxesData(item) {
      // 1.7 (Himanshu) for getting rcm taxes
       const payload = {
        _page:0,
        _limit:100,
        tax_type_id: item.tax_type_id,
        legal_entity: this.headerDetails.erp_le_id
      };
      this.loading = true;
      this.$store
        .dispatch('intWorkflow/getRcmTaxes', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            this.rcmTaxesData = response.data.data.data.page;
             this.showOpenRcmTaxes = true; // 2.2 (Himanshu)
          } else {
            this.makeToast('Something went wrong', 'danger');
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
//     selectedRcmTax(flag, selectedRcmTax) {
//       // 1.7 (Himanshu) for selecting rcm tax
//       this.previewTaxData[this.rcmTaxIndex].tax_rate = Number(selectedRcmTax.tax_rate_percentage);
// const taxableAmount = Number(
//   String(this.previewTaxData[this.rcmTaxIndex].taxable_amount).replace(/,/g, "")
// ) || 0;
// this.previewTaxData[this.rcmTaxIndex].amount = Math.round(
//   (this.previewTaxData[this.rcmTaxIndex].tax_rate / 100) * taxableAmount * 100
// ) / 100;
//       this.showOpenRcmTaxes = flag;
//     },
selectedRcmTax(flag, selectedRcmTax) {
  // 1.7 (Himanshu) for selecting RCM tax
  this.previewTaxData[this.rcmTaxIndex].tax_rate = Number(selectedRcmTax.tax_rate_percentage);
  let taxableAmount = this.previewTaxData[this.rcmTaxIndex].taxable_amount;
  taxableAmount = Number(String(taxableAmount).replace(/,/g, "")) || 0;
  this.previewTaxData[this.rcmTaxIndex].taxable_amount = taxableAmount;
  this.previewTaxData[this.rcmTaxIndex].amount = Math.round(
    (this.previewTaxData[this.rcmTaxIndex].tax_rate / 100) * taxableAmount * 100
  ) / 100;
  this.showOpenRcmTaxes = flag;
},

    addNewTaxDetailsManual() {
      // 2.2 (Himanshu) RCM taxes add
      if(this.previewTaxData[this.previewTaxData.length-1].tax_type === null || this.previewTaxData[this.previewTaxData.length-1].tax_rate === null) {
        alert('Please fill in data for previous line');
      } else {
        this.previewTaxData.push({
        tax_type : null,
        taxable_amount: this.previewTaxData[0].taxable_amount,
        tax_rate: null,
        amount: this.previewTaxData[0].amount,
        tax_category_name: this.previewTaxData[0].tax_category_name,
        rcm_flag: this.previewTaxData[0].rcm_flag,
        tax_type_id: this.previewTaxData[0].tax_type_id
      })
      }      
    },
    getTaxTypeList() {
      // 2.2 (Himanshu) RCM taxes add
      let payload = {
        state_match_flag: 0,
        vendor_gstn_flag: 1
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getTaxTypeList', payload)
        .then(response => {
          this.loader = false;
          let result = response.data.data.data;
          this.taxTypeData = result;
        this.showOpenTaxTypeModal = true;
          // this.data = response.data.data.page;
          // this.totalRows = response.data.data.total_elements;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    closeTaxTypesModal(flag) {
      // 2.2 (Himanshu) RCM taxes add
      this.showOpenTaxTypeModal = flag;
    },
    selectedTaxType(flag, selectedTaxType) {
      // 2.2 (Himanshu) RCM taxes add
      this.previewTaxData[this.rcmTaxIndex].tax_type = selectedTaxType.tax_type_code;
      this.previewTaxData[this.rcmTaxIndex].tax_type_id = selectedTaxType.tax_type_id;
      this.previewTaxData[this.rcmTaxIndex].tax_rate = null;
      this.previewTaxData[this.rcmTaxIndex].amount = null;
      this.showOpenTaxTypeModal = flag;
    },
    removeTaxDetailsRow(item, index) {
      // 2.2 (Himanshu) RCM taxes add
      // this.previewTaxData.splice(index, 1);
      this.$set(this.previewTaxData[index], "delete_flag", item.delete_flag === 1 ? 0 : 1);
    },
    addNewRcmTax() {
      // 2.2 (Himanshu) to add RCM taxes
      this.addNewRcmTaxFlag = true;
      this.previewTaxData.push({
       add: null,
       remove: null,
       tax_type: null,
       taxable_amount: this.totalTaxableAmt,
       tax_rate: null,
       amount: null,
       tax_category_name: null,
       rcm_flag: null
      })
    },
    saveRcmTaxes() {
      // 2.2 (Himanshu)  save RCM taxes
       if (!this.checkRcmTaxes()) {
        return;
       }
        if (!this.validateRcmTaxDependencies()) {
          return;
        }
      let taxDetails = [];
      for(let i of this.previewTaxData) {
       taxDetails.push({
            vendor_inv_tax_id: i.vnd_inv_tax_id ? i.vnd_inv_tax_id : 0,
            vendor_inv_dtl_id:i.vnd_inv_dtl_id ? i.vnd_inv_dtl_id : this.vendorInvoiceDetailId,
            tax_type_id: i.tax_type_id,
            tax_type: i.tax_type,
            taxable_amount: Number(String(i.taxable_amount).replace(/,/g, "")) || 0,
            tax_rate: i.tax_rate,
            amount: i.amount,
            rcm_flag: i.rcm_flag === true ? 'Y' : i.rcm_flag,
            delete_flag:i.delete_flag ? 1 : 0,
       })
      }
      let payload = {
        tax_dtls: taxDetails
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/postRcmTaxes', payload)
        .then(response => {
          this.loader = false;
          if(response.status === 200) {
            let result = response.data.data;
            this.previewTaxData = result;
            this.invoiceLineData[this.selectedInvoiceIndex].tax_details = result; // 2.3 (Himanshu)
            this.makeToast('Saved Successfully', 'success');
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    editRcmTaxes() {
      // 2.2 (Himanshu) to edit RCM taxes
      // for(let i of this.previewTaxData) {
      //   i.rcm_flag = i.rcm_flag === 'Y' ? 'N' : 'Y';
      // }
      this.editMode = !this.editMode;
      this.addNewRcmTaxFlag = true;
    },
  //   checkRcmTaxes() {
  //     // 2.2 (Himanshu) checking all necessary conditions for RCM taxes
  // let data = this.previewTaxData;
  // for (let i of data) {
  //   if (!i.tax_type) {
  //     alert("Each line must have a tax type.");
  //     return false;
  //   }
  //   if (i.tax_rate === null || i.tax_rate === undefined || i.tax_rate === "") {
  //     alert("Each line must have a tax rate.");
  //     return false;
  //   }
  // }
  // let totalRate = data.reduce((sum, i) => sum + Number(i.tax_rate || 0), 0);
  // for (let i of data) {
  //   if (Number(i.tax_rate) === 12 || Number(i.tax_rate) === 28) {
  //     alert("Tax rate cannot be 12% or 28% individually.");
  //     return false;
  //   }
  // }
  // if (totalRate === 12 || totalRate === 28) {
  //   alert("Total tax rate cannot be 12% or 28%.");
  //   return false;
  // }
  // let cgst = data.filter(i => i.tax_type === "CGST RCM");
  // let sgst = data.filter(i => i.tax_type === "SGST RCM");
  // let ugst = data.filter(i => i.tax_type === "UGST RCM");
  // let igst = data.filter(i => i.tax_type === "IGST RCM");
  // const firstPartyState = this.headerDetails.first_party_gstn
  //   ? this.headerDetails.first_party_gstn.substring(0, 2)
  //   : null;
  // const thirdPartyState = this.headerDetails.third_party_gstn
  //   ? this.headerDetails.third_party_gstn.substring(0, 2)
  //   : null;
  // if (firstPartyState && thirdPartyState) {
  //   if (firstPartyState === thirdPartyState) {
  //     if (igst.length > 0) {
  //       alert("For same-state GSTINs, only CGST and SGST/UGST are allowed, not IGST.");
  //       return false;
  //     }
  //   } else {
  //     if (cgst.length > 0 || sgst.length > 0 || ugst.length > 0) {
  //       alert("For different-state GSTINs, only IGST is allowed, not CGST/SGST/UGST.");
  //       return false;
  //     }
  //   }
  // }
  // if (igst.length > 0) {
  //   if (igst.length !== 1) {
  //     alert("If IGST exists, there must be exactly one IGST line.");
  //     return false;
  //   }
  //   if (cgst.length > 0 || sgst.length > 0 || ugst.length > 0) {
  //     alert("If IGST exists, there cannot be any CGST, SGST, or UGST lines.");
  //     return false;
  //   }
  // }
  // if (cgst.length > 0) {
  //   let combined = [...sgst, ...ugst];
  //   if (combined.length !== 1 || cgst.length !== 1) {
  //     alert("If CGST exists, there must be exactly 1 SGST or UGST and exactly 1 CGST line.");
  //     return false;
  //   }
  //   if (Number(cgst[0].tax_rate) !== Number(combined[0].tax_rate)) {
  //     alert("CGST and SGST/UGST must have the same tax rate.");
  //     return false;
  //   }
  // }
  // if (sgst.length > 0 && cgst.length === 0) {
  //   alert("SGST requires exactly one CGST line with the same rate.");
  //   return false;
  // }
  // if (ugst.length > 0 && cgst.length === 0) {
  //   alert("UGST requires exactly one CGST line with the same rate.");
  //   return false;
  // }
  // return true;
  //   },
  checkRcmTaxes() {
  // 2.2 (Himanshu) checking all necessary conditions for RCM taxes
  let data = this.previewTaxData;
  for (let i of data) {
    if (!i.tax_type) {
      alert("Each line must have a tax type.");
      return false;
    }
    if (i.tax_rate === null || i.tax_rate === undefined || i.tax_rate === "") {
      alert("Each line must have a tax rate.");
      return false;
    }
  }
  let totalRate = data.reduce((sum, i) => sum + Number(i.tax_rate || 0), 0);
  for (let i of data) {
    if (Number(i.tax_rate) === 12 || Number(i.tax_rate) === 28) {
      alert("Tax rate cannot be 12% or 28% individually.");
      return false;
    }
  }
  if (totalRate === 12 || totalRate === 28) {
    alert("Total tax rate cannot be 12% or 28%.");
    return false;
  }
  let cgst = data.filter(i => i.tax_type === "CGST RCM");
  let sgst = data.filter(i => i.tax_type === "SGST RCM");
  let ugst = data.filter(i => i.tax_type === "UGST RCM");
  let igst = data.filter(i => i.tax_type === "IGST RCM");
  const firstPartyState = this.headerDetails.first_party_gstn
    ? this.headerDetails.first_party_gstn.substring(0, 2)
    : null;
  const thirdPartyState = this.headerDetails.third_party_gstn
    ? this.headerDetails.third_party_gstn.substring(0, 2)
    : null;
  const firstGst = this.headerDetails.first_party_gstn;
  const thirdGst = this.headerDetails.third_party_gstn;
  const gstNotAvailable =
    firstGst === "GSTNOTAVAILABLE" || thirdGst === "GSTNOTAVAILABLE";
  if (!gstNotAvailable && firstPartyState && thirdPartyState) {
    if (firstPartyState === thirdPartyState) {
      if (igst.length > 0) {
        alert("For same-state GSTINs, only CGST and SGST/UGST are allowed, not IGST.");
        return false;
      }
    } else {
      if (cgst.length > 0 || sgst.length > 0 || ugst.length > 0) {
        alert("For different-state GSTINs, only IGST is allowed, not CGST/SGST/UGST.");
        return false;
      }
    }
  }
  if (igst.length > 0) {
    if (igst.length !== 1) {
      alert("If IGST exists, there must be exactly one IGST line.");
      return false;
    }
    if (cgst.length > 0 || sgst.length > 0 || ugst.length > 0) {
      alert("If IGST exists, there cannot be any CGST, SGST, or UGST lines.");
      return false;
    }
  }
  if (cgst.length > 0) {
    let combined = [...sgst, ...ugst];
    if (combined.length !== 1 || cgst.length !== 1) {
      alert("If CGST exists, there must be exactly 1 SGST or UGST and exactly 1 CGST line.");
      return false;
    }
    if (Number(cgst[0].tax_rate) !== Number(combined[0].tax_rate)) {
      alert("CGST and SGST/UGST must have the same tax rate.");
      return false;
    }
  }
  if (sgst.length > 0 && cgst.length === 0) {
    alert("SGST requires exactly one CGST line with the same rate.");
    return false;
  }
  if (ugst.length > 0 && cgst.length === 0) {
    alert("UGST requires exactly one CGST line with the same rate.");
    return false;
  }
  return true;
},

    removeAllRcmTax() {
      this.previewTaxData = [];
    },
    removeRcmRow(index) {
      // 2.2 (Himanshu) Removes deleted rows
      if(this.previewTaxData[index].vnd_inv_dtl_id) {
      this.deleteRcmTax(index);     
      } else {
      this.previewTaxData.splice(index, 1);
      }
      
    },
    validateRcmTaxDependencies() {
      // 2.2 (Himanshu) checking other necessary conditions for RCM taxes
    for (let i = 0; i < this.previewTaxData.length; i++) {
    const row = this.previewTaxData[i];
    const flag = row.rcm_flag === true || row.rcm_flag === 'Y';
    if (flag) {
      if (!row.tax_type || !row.tax_rate) {
        alert(`Please enter Tax Type and Tax Rate for row ${i + 1} where RCM is selected.`);
        return false;
      }
    } else {
      if (row.tax_type || row.tax_rate) {
        alert(`Please remove Tax Type and Tax Rate for row ${i + 1} where RCM is not selected.`);
        return false;
      }
    }
  }
  return true;
},
     deleteRcmTax(index) {
      // 2.2 (Himanshu) delete selected RCM taxes
      let payload = {};
      if(this.previewTaxData[index].tax_type === 'CGST RCM' || this.previewTaxData[index].tax_type === 'SGST RCM') {
        let taxDetails = [];
        for(let i of this.previewTaxData) {
          taxDetails.push({
            vendor_inv_tax_id: i.vnd_inv_tax_id ? i.vnd_inv_tax_id : 0,
            vendor_inv_dtl_id: i.vnd_inv_dtl_id ? i.vnd_inv_dtl_id : this.vendorInvoiceDetailId,
            tax_type_id: i.tax_type_id,
            tax_type: i.tax_type,
            taxable_amount: Number(String(i.taxable_amount).replace(/,/g, "")) || 0,
            tax_rate: i.tax_rate,
            amount: i.amount,
            rcm_flag: i.rcm_flag === true ? 'Y' : i.rcm_flag,
            delete_flag: 1,
          })
        }
        payload = {
          tax_dtls: taxDetails
        }
      } else {
       payload = {
        tax_dtls: [
          {
            vendor_inv_tax_id: this.previewTaxData[index].vnd_inv_tax_id ? this.previewTaxData[index].vnd_inv_tax_id : 0,
            vendor_inv_dtl_id:this.previewTaxData[index].vnd_inv_dtl_id ? this.previewTaxData[index].vnd_inv_dtl_id : this.vendorInvoiceDetailId,
            tax_type_id: this.previewTaxData[index].tax_type_id,
            tax_type: this.previewTaxData[index].tax_type,
            taxable_amount: Number(String(this.previewTaxData[index].taxable_amount).replace(/,/g, "")) || 0,
            tax_rate: this.previewTaxData[index].tax_rate,
            amount: this.previewTaxData[index].amount,
            rcm_flag: this.previewTaxData[index].rcm_flag === true ? 'Y' : this.previewTaxData[index].rcm_flag,
            delete_flag: 1,
          }
        ]
      };
      }      
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/postRcmTaxes', payload)
        .then(response => {
          this.loader = false;
          if(response.status === 200) {
            let result = response.data.data;
            this.previewTaxData = result;
            this.makeToast('Saved Successfully', 'success');
          }
        })
        .catch(() => {
          this.loader = false;
        });
     },
     getPreviewTaxData(index) {
      // 2.2 (Himanshu) get preview RCM Taxes data
      const payload = {
           vendor_inv_dtl_id: this.invoiceLineData[index].vendor_inv_dtl_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getRcmPreviewTaxes', payload)
        .then(response => {
          this.loader = false;
          if(response.status === 200) {
            let result = response.data.data;
            this.previewTaxData = result;      
          }
        })
        .catch(() => {
          this.loader = false;
        });
     },
     checkUncheckRcmFlag(item) {
      // 2.4 (Himanshu) function for checking rcm_flag
      if(this.headerDetails.manual_invoice && this.headerDetails.invoice_level === 'INVOICE' && this.headerDetails.currency !== 'INR') {
      if(item.rcm_flag === 'Y') {
        item.tax_type = 'IGST RCM';
        item.tax_type_id = 10005;
      } else {
        item.tax_type = 'IGST';
        item.tax_type_id = 10001;
        item.tax_rate = 0;
        item.amount = 0;
      }
      }      
     },
     allowOnlyAlphanumeric(e) {
      // 2.4 (Himanshu) function to check purpose_code to be alphanumeric
    const char = String.fromCharCode(e.which);
    if (!/[a-zA-Z0-9]/.test(char)) {
      e.preventDefault();
    }
  },
  saveRcmTaxesForForeignInvoices() {
    // 2.4 (Himanshu) saving RCM taxes for currency not INR
    let taxDetails = [];
      for(let i of this.previewTaxData) {
       taxDetails.push({
            vendor_inv_tax_id: i.vnd_inv_tax_id ? i.vnd_inv_tax_id : 0,
            vendor_inv_dtl_id:i.vnd_inv_dtl_id ? i.vnd_inv_dtl_id : this.vendorInvoiceDetailId,
            tax_type_id: i.tax_type_id,
            tax_type: i.tax_type,
            taxable_amount: Number(String(i.taxable_amount).replace(/,/g, "")) || 0,
            tax_rate: i.tax_rate,
            amount: i.amount,
            rcm_flag: i.rcm_flag === true ? 'Y' : i.rcm_flag,
            delete_flag:i.delete_flag ? 1 : 0,
       })
      }
      let payload = {
        tax_dtls: taxDetails
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/postRcmTaxes', payload)
        .then(response => {
          this.loader = false;
          if(response.status === 200) {
            let result = response.data.data;
            this.previewTaxData = result;
            this.invoiceLineData[this.selectedInvoiceIndex].tax_details = result;
            this.makeToast('Saved Successfully', 'success');
          }
        })
        .catch(() => {
          this.loader = false;
        });
  },
  checkInvoiceExist(onExistCallback, ...args) {
    // 2.6 (Himanshu) function to check if invoice already exist or not
    let payload = {
        vendor_id: this.headerDetails.vendor_id,
        invoice_num: this.headerDetails.inv_num
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getDuplicateInvoices', payload)
        .then(response => {
          this.loader = false;
          if(response.status === 200) {
            let result = response.data.data.data;
            if (result === true && typeof onExistCallback === "function") {
              alert('Invoice number already exist')          
            } else {
              onExistCallback(...args);
            }
             }
        })
        .catch(() => {
          this.loader = false;
        });
  },
  checkCodeCombinationFinance(item) {
    // 2.7 (Himanshu)
       if(item.code_combination.includes(" ")) {
        item.code_combination = null;
        alert('Code Combination cannot have spaces');
       } else {
        const str = item.code_combination;
        const parts = str.split(".");
        const result = parts[4];
        this.checkCostCenterActiveInactive(result, item);
       }
  },
  checkCostCenterActiveInactive(costCenter, item) {
    // 2.7 (Himanshu)
    const payload = {
      _page: this.currentPageCostCentre - 1,
        _limit: this.perPageCostCentre,
        org_id: this.operatingUnit.value,
        company_state_code: this.headerDetails.state_code,
        cost_centre: costCenter
    };
    this.loader = true;
      this.$store
        .dispatch('intWorkflow/checkCostCenterActiveInactive', payload)
        .then(response => {
          this.loader = false;
          if(response.status === 200) {
            let result = response.data.data.page;
            if(result.length===0) {
              item.code_combination = null;
              alert('Cost Center is Inactive');
            }
             }
        })
        .catch(() => {
          this.loader = false;
        });
  },
   mapMenuId() {
      const storedData = sessionStorage.getItem('VendorInvoiceEntry');
      if (storedData) {
        const obj = JSON.parse(storedData);
        this.menuId = obj.menu_id;
        this.subMenuId = obj.sub_menu_id;
      }
    },
    addSplitFinLines(lines) {
      if(lines<=0) {
        alert('Number of lines should be greater than zero');
        lines =null;
        return;
      } else {
       this.splitFinData = [];
      for(let i=0; i<lines; i++) {
        this.splitFinData.push({
         oracle_line_description: null,
         period: null,
         period_to: null,
         days: null,
         cost_centre: null,
         unit_price: null,
         amount: (+this.splitLineData.taxable_amount/lines).toFixed(2),
         expense_month: null,
         code_combination: null,
         status_code: null,
         status_message: null
        })
      }
      this.remainingFinAmt = 0;
      }
      
    },
    showHideCodeCombinationModal(flag, item) {
      this.codeCombinationModal = flag;
      if (item) {
        this.currentItem = item;
      }
    },
    handleCodeCombination(value) {
    if (this.currentItem) {
      this.currentItem.code_combination = value;
    }
    this.codeCombinationModal = false;
  },
  periodTo(item) {
    if (item.period && item.period_to) {
        const totalDays = this.getTotalDays(item.period_to, item.period);
        item.days = totalDays;
      }
  },
  handleCodeCombinationValue(vaLue) {
    if (this.currentItem) {
      this.currentItem.code_combination_value = vaLue;
    }
  },
  getTransporterNameData() {
       const payload = {
        _page: this.currentPageTransporterName,
        _limit: this.perPage,
        party_name: null
      };
      this.loading = true;
      this.$store
        .dispatch('intWorkflow/getTransporterName', payload)
        .then(resp => {
          this.loading = false;
          if (resp.status === 200) {
            let result = resp.data.data.data.page;
            this.transporterNameData = result;
            this.totalRowsTransporterName = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    selectedTransporterName(flag, trName) {
      this.showOpenTransporterName = flag;
      this.headerDetails.transporter_name = trName.text;
    },
    transporterNameModal(flag) {
      this.showOpenTransporterName = flag;
    },
    getDocSequenceData() {
      const payload = {
        _page: this.currentPageDocSequence-1,
        _limit: this.perPage,
        doc_number: null
      };
      this.loading = true;
      this.$store
        .dispatch('intWorkflow/getDocSeqValue', payload)
        .then(resp => {
          this.loading = false;
          if (resp.status === 200) {
            let result = resp.data.data.data.page;
            this.docSequenceData = result;
            this.totalRowsDocSequence = resp.data.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    selectedDocSequence(flag, docSeq) {
      this.showOpenDocSequence = flag;
      this.headerDetails.doc_seq = docSeq.text;
    },
    disablePeriodToDate(date, item) {
    if (!item.period) return false;
    const fromDate = new Date(item.period);
    fromDate.setHours(0, 0, 0, 0);
    return date < fromDate;
  },
  onPeriodChange(item) {
    if (!item.period) {
      item.period_to = null;
      return;
    }
    if (item.period_to) {
      const from = new Date(item.period);
      const to = new Date(item.period_to);
      if (to < from) {
        item.period_to = null;
      }
    }
  }
  },
  beforeDestroy() {
    this.unsubscribe();
    clearTimeout(this.setTimeVset);
    document.removeEventListener('keydown', this.handleKeyDown);
  }
};
